!function(e, t) {
    var i = function(e, t) {
        "use strict";
        if (t.getElementsByClassName) {
            var i, n, o = t.documentElement, s = e.Date, a = e.HTMLPictureElement, r = "addEventListener", l = "getAttribute", c = e[r], u = e.setTimeout, h = e.requestAnimationFrame || u, d = e.requestIdleCallback, m = /^picture$/i, p = [ "load", "error", "lazyincluded", "_lazyloaded" ], f = {}, g = Array.prototype.forEach, v = function(e, t) {
                return f[t] || (f[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")), f[t].test(e[l]("class") || "") && f[t];
            }, y = function(e, t) {
                v(e, t) || e.setAttribute("class", (e[l]("class") || "").trim() + " " + t);
            }, _ = function(e, t) {
                var i;
                (i = v(e, t)) && e.setAttribute("class", (e[l]("class") || "").replace(i, " "));
            }, w = function(e, t, i) {
                var n = i ? r : "removeEventListener";
                i && w(e, t), p.forEach(function(i) {
                    e[n](i, t);
                });
            }, b = function(e, n, o, s, a) {
                var r = t.createEvent("Event");
                return o || (o = {}), o.instance = i, r.initEvent(n, !s, !a), r.detail = o, e.dispatchEvent(r), 
                r;
            }, C = function(t, i) {
                var o;
                !a && (o = e.picturefill || n.pf) ? (i && i.src && !t[l]("srcset") && t.setAttribute("srcset", i.src), 
                o({
                    reevaluate: !0,
                    elements: [ t ]
                })) : i && i.src && (t.src = i.src);
            }, E = function(e, t) {
                return (getComputedStyle(e, null) || {})[t];
            }, k = function(e, t, i) {
                for (i = i || e.offsetWidth; i < n.minSize && t && !e._lazysizesWidth; ) i = t.offsetWidth, 
                t = t.parentNode;
                return i;
            }, S = function() {
                var e, i, n = [], o = [], s = n, a = function() {
                    var t = s;
                    for (s = n.length ? o : n, e = !0, i = !1; t.length; ) t.shift()();
                    e = !1;
                }, r = function(n, o) {
                    e && !o ? n.apply(this, arguments) : (s.push(n), i || (i = !0, (t.hidden ? u : h)(a)));
                };
                return r._lsFlush = a, r;
            }(), x = function(e, t) {
                return t ? function() {
                    S(e);
                } : function() {
                    var t = this, i = arguments;
                    S(function() {
                        e.apply(t, i);
                    });
                };
            }, L = function(e) {
                var t, i = 0, o = n.throttleDelay, a = n.ricTimeout, r = function() {
                    t = !1, i = s.now(), e();
                }, l = d && a > 49 ? function() {
                    d(r, {
                        timeout: a
                    }), a !== n.ricTimeout && (a = n.ricTimeout);
                } : x(function() {
                    u(r);
                }, !0);
                return function(e) {
                    var n;
                    (e = !0 === e) && (a = 33), t || (t = !0, (n = o - (s.now() - i)) < 0 && (n = 0), 
                    e || n < 9 ? l() : u(l, n));
                };
            }, A = function(e) {
                var t, i, n = function() {
                    t = null, e();
                }, o = function() {
                    var e = s.now() - i;
                    e < 99 ? u(o, 99 - e) : (d || n)(n);
                };
                return function() {
                    i = s.now(), t || (t = u(o, 99));
                };
            };
            !function() {
                var t, i = {
                    lazyClass: "lazyload",
                    loadedClass: "lazyloaded",
                    loadingClass: "lazyloading",
                    preloadClass: "lazypreload",
                    errorClass: "lazyerror",
                    autosizesClass: "lazyautosizes",
                    srcAttr: "data-src",
                    srcsetAttr: "data-srcset",
                    sizesAttr: "data-sizes",
                    minSize: 40,
                    customMedia: {},
                    init: !0,
                    expFactor: 1.5,
                    hFac: .8,
                    loadMode: 2,
                    loadHidden: !0,
                    ricTimeout: 0,
                    throttleDelay: 125
                };
                for (t in n = e.lazySizesConfig || e.lazysizesConfig || {}, i) t in n || (n[t] = i[t]);
                u(function() {
                    n.init && D();
                });
            }();
            var P = function() {
                var a, h, d, p, f, k, P, D, z, T, I, O, q = /^img$/i, B = /^iframe$/i, N = "onscroll" in e && !/(gle|ing)bot/.test(navigator.userAgent), R = 0, j = 0, H = -1, F = function(e) {
                    j--, (!e || j < 0 || !e.target) && (j = 0);
                }, $ = function(e) {
                    return null == O && (O = "hidden" == E(t.body, "visibility")), O || "hidden" != E(e.parentNode, "visibility") && "hidden" != E(e, "visibility");
                }, U = function(e, i) {
                    var n, s = e, a = $(e);
                    for (D -= i, I += i, z -= i, T += i; a && (s = s.offsetParent) && s != t.body && s != o; ) (a = (E(s, "opacity") || 1) > 0) && "visible" != E(s, "overflow") && (n = s.getBoundingClientRect(), 
                    a = T > n.left && z < n.right && I > n.top - 1 && D < n.bottom + 1);
                    return a;
                }, W = function() {
                    var e, s, r, c, u, d, m, f, g, v, y, _, w = i.elements;
                    if ((p = n.loadMode) && j < 8 && (e = w.length)) {
                        for (s = 0, H++; s < e; s++) if (w[s] && !w[s]._lazyRace) if (!N || i.prematureUnveil && i.prematureUnveil(w[s])) J(w[s]); else if ((f = w[s][l]("data-expand")) && (d = 1 * f) || (d = R), 
                        v || (v = !n.expand || n.expand < 1 ? o.clientHeight > 500 && o.clientWidth > 500 ? 500 : 370 : n.expand, 
                        i._defEx = v, y = v * n.expFactor, _ = n.hFac, O = null, R < y && j < 1 && H > 2 && p > 2 && !t.hidden ? (R = y, 
                        H = 0) : R = p > 1 && H > 1 && j < 6 ? v : 0), g !== d && (k = innerWidth + d * _, 
                        P = innerHeight + d, m = -1 * d, g = d), r = w[s].getBoundingClientRect(), (I = r.bottom) >= m && (D = r.top) <= P && (T = r.right) >= m * _ && (z = r.left) <= k && (I || T || z || D) && (n.loadHidden || $(w[s])) && (h && j < 3 && !f && (p < 3 || H < 4) || U(w[s], d))) {
                            if (J(w[s]), u = !0, j > 9) break;
                        } else !u && h && !c && j < 4 && H < 4 && p > 2 && (a[0] || n.preloadAfterLoad) && (a[0] || !f && (I || T || z || D || "auto" != w[s][l](n.sizesAttr))) && (c = a[0] || w[s]);
                        c && !u && J(c);
                    }
                }, V = L(W), X = function(e) {
                    var t = e.target;
                    return t._lazyCache ? void delete t._lazyCache : (F(e), y(t, n.loadedClass), _(t, n.loadingClass), 
                    w(t, Q), void b(t, "lazyloaded"));
                }, G = x(X), Q = function(e) {
                    G({
                        target: e.target
                    });
                }, Y = function(e) {
                    var t, i = e[l](n.srcsetAttr);
                    (t = n.customMedia[e[l]("data-media") || e[l]("media")]) && e.setAttribute("media", t), 
                    i && e.setAttribute("srcset", i);
                }, K = x(function(e, t, i, o, s) {
                    var a, r, c, h, p, f;
                    (p = b(e, "lazybeforeunveil", t)).defaultPrevented || (o && (i ? y(e, n.autosizesClass) : e.setAttribute("sizes", o)), 
                    r = e[l](n.srcsetAttr), a = e[l](n.srcAttr), s && (c = e.parentNode, h = c && m.test(c.nodeName || "")), 
                    f = t.firesLoad || "src" in e && (r || a || h), p = {
                        target: e
                    }, y(e, n.loadingClass), f && (clearTimeout(d), d = u(F, 2500), w(e, Q, !0)), h && g.call(c.getElementsByTagName("source"), Y), 
                    r ? e.setAttribute("srcset", r) : a && !h && (B.test(e.nodeName) ? function(e, t) {
                        try {
                            e.contentWindow.location.replace(t);
                        } catch (i) {
                            e.src = t;
                        }
                    }(e, a) : e.src = a), s && (r || h) && C(e, {
                        src: a
                    })), e._lazyRace && delete e._lazyRace, _(e, n.lazyClass), S(function() {
                        var t = e.complete && e.naturalWidth > 1;
                        f && !t || (t && y(e, "ls-is-cached"), X(p), e._lazyCache = !0, u(function() {
                            "_lazyCache" in e && delete e._lazyCache;
                        }, 9)), "lazy" == e.loading && j--;
                    }, !0);
                }), J = function(e) {
                    if (!e._lazyRace) {
                        var t, i = q.test(e.nodeName), o = i && (e[l](n.sizesAttr) || e[l]("sizes")), s = "auto" == o;
                        (!s && h || !i || !e[l]("src") && !e.srcset || e.complete || v(e, n.errorClass) || !v(e, n.lazyClass)) && (t = b(e, "lazyunveilread").detail, 
                        s && M.updateElem(e, !0, e.offsetWidth), e._lazyRace = !0, j++, K(e, t, s, o, i));
                    }
                }, Z = A(function() {
                    n.loadMode = 3, V();
                }), ee = function() {
                    3 == n.loadMode && (n.loadMode = 2), Z();
                }, te = function() {
                    if (!h) {
                        if (s.now() - f < 999) return void u(te, 999);
                        h = !0, n.loadMode = 3, V(), c("scroll", ee, !0);
                    }
                };
                return {
                    _: function() {
                        f = s.now(), i.elements = t.getElementsByClassName(n.lazyClass), a = t.getElementsByClassName(n.lazyClass + " " + n.preloadClass), 
                        c("scroll", V, !0), c("resize", V, !0), e.MutationObserver ? new MutationObserver(V).observe(o, {
                            childList: !0,
                            subtree: !0,
                            attributes: !0
                        }) : (o[r]("DOMNodeInserted", V, !0), o[r]("DOMAttrModified", V, !0), setInterval(V, 999)), 
                        c("hashchange", V, !0), [ "focus", "mouseover", "click", "load", "transitionend", "animationend" ].forEach(function(e) {
                            t[r](e, V, !0);
                        }), /d$|^c/.test(t.readyState) ? te() : (c("load", te), t[r]("DOMContentLoaded", V), 
                        u(te, 2e4)), i.elements.length ? (W(), S._lsFlush()) : V();
                    },
                    checkElems: V,
                    unveil: J,
                    _aLSL: ee
                };
            }(), M = function() {
                var e, i = x(function(e, t, i, n) {
                    var o, s, a;
                    if (e._lazysizesWidth = n, n += "px", e.setAttribute("sizes", n), m.test(t.nodeName || "")) for (o = t.getElementsByTagName("source"), 
                    s = 0, a = o.length; s < a; s++) o[s].setAttribute("sizes", n);
                    i.detail.dataAttr || C(e, i.detail);
                }), o = function(e, t, n) {
                    var o, s = e.parentNode;
                    s && (n = k(e, s, n), (o = b(e, "lazybeforesizes", {
                        width: n,
                        dataAttr: !!t
                    })).defaultPrevented || (n = o.detail.width) && n !== e._lazysizesWidth && i(e, s, o, n));
                }, s = A(function() {
                    var t, i = e.length;
                    if (i) for (t = 0; t < i; t++) o(e[t]);
                });
                return {
                    _: function() {
                        e = t.getElementsByClassName(n.autosizesClass), c("resize", s);
                    },
                    checkElems: s,
                    updateElem: o
                };
            }(), D = function() {
                D.i || (D.i = !0, M._(), P._());
            };
            return i = {
                cfg: n,
                autoSizer: M,
                loader: P,
                init: D,
                uP: C,
                aC: y,
                rC: _,
                hC: v,
                fire: b,
                gW: k,
                rAF: S
            };
        }
    }(e, e.document);
    e.lazySizes = i, "object" == typeof module && module.exports && (module.exports = i);
}(window), function(e, t) {
    var i = function() {
        t(e.lazySizes), e.removeEventListener("lazyunveilread", i, !0);
    };
    t = t.bind(null, e, e.document), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? i() : e.addEventListener("lazyunveilread", i, !0);
}(window, function(e, t, i) {
    "use strict";
    var n, o = i.cfg, s = i && i.cfg, a = t.createElement("img"), r = "sizes" in a && "srcset" in a, l = /\s+\d+h/g, c = function() {
        var e = /\s+(\d+)(w|h)\s+(\d+)(w|h)/, n = Array.prototype.forEach;
        return function() {
            var s = t.createElement("img"), a = function(t) {
                var i, n, s = t.getAttribute(o.srcsetAttr);
                s && (n = s.match(e)) && ((i = "w" == n[2] ? n[1] / n[3] : n[3] / n[1]) && t.setAttribute("data-aspectratio", i), 
                t.setAttribute(o.srcsetAttr, s.replace(l, "")));
            }, r = function(e) {
                if (e.detail.instance == i) {
                    var t = e.target.parentNode;
                    t && "PICTURE" == t.nodeName && n.call(t.getElementsByTagName("source"), a), a(e.target);
                }
            }, c = function() {
                s.currentSrc && t.removeEventListener("lazybeforeunveil", r);
            };
            t.addEventListener("lazybeforeunveil", r), s.onload = c, s.onerror = c, s.srcset = "data:,a 1w 1h", 
            s.complete && c();
        };
    }();
    return s.supportsType || (s.supportsType = function(e) {
        return !e;
    }), e.HTMLPictureElement && r ? void (!i.hasHDescriptorFix && t.msElementsFromPoint && (i.hasHDescriptorFix = !0, 
    c())) : void (e.picturefill || s.pf || (s.pf = function(t) {
        var i, o;
        if (!e.picturefill) for (i = 0, o = t.elements.length; i < o; i++) n(t.elements[i]);
    }, n = function() {
        var o = function(e, t) {
            return e.w - t.w;
        }, a = /^\s*\d+\.*\d*px\s*$/, c = function() {
            var e, t = /(([^,\s].[^\s]+)\s+(\d+)w)/g, i = /\s/, n = function(t, i, n, o) {
                e.push({
                    c: i,
                    u: n,
                    w: 1 * o
                });
            };
            return function(o) {
                return e = [], (o = o.trim()).replace(l, "").replace(t, n), e.length || !o || i.test(o) || e.push({
                    c: o,
                    u: o,
                    w: 99
                }), e;
            };
        }(), u = function() {
            var e, i, o;
            u.init || (u.init = !0, addEventListener("resize", (i = t.getElementsByClassName("lazymatchmedia"), 
            o = function() {
                var e, t;
                for (e = 0, t = i.length; e < t; e++) n(i[e]);
            }, function() {
                clearTimeout(e), e = setTimeout(o, 66);
            })));
        }, h = function(t, n) {
            var o, a = t.getAttribute("srcset") || t.getAttribute(s.srcsetAttr);
            !a && n && (a = t._lazypolyfill ? t._lazypolyfill._set : t.getAttribute(s.srcAttr) || t.getAttribute("src")), 
            t._lazypolyfill && t._lazypolyfill._set == a || (o = c(a || ""), n && t.parentNode && (o.isPicture = "PICTURE" == t.parentNode.nodeName.toUpperCase(), 
            o.isPicture && e.matchMedia && (i.aC(t, "lazymatchmedia"), u())), o._set = a, Object.defineProperty(t, "_lazypolyfill", {
                value: o,
                writable: !0
            }));
        }, d = function(t) {
            var n = e.devicePixelRatio || 1, o = i.getX && i.getX(t);
            return Math.min(o || n, 2.5, n);
        }, m = function(t) {
            return e.matchMedia ? (m = function(e) {
                return !e || (matchMedia(e) || {}).matches;
            })(t) : !t;
        }, p = function(e) {
            var t, n, r, l, c, u, p;
            if (h(l = e, !0), (c = l._lazypolyfill).isPicture) for (n = 0, r = (t = e.parentNode.getElementsByTagName("source")).length; n < r; n++) if (s.supportsType(t[n].getAttribute("type"), e) && m(t[n].getAttribute("media"))) {
                l = t[n], h(l), c = l._lazypolyfill;
                break;
            }
            return c.length > 1 ? (p = l.getAttribute("sizes") || "", p = a.test(p) && parseInt(p, 10) || i.gW(e, e.parentNode), 
            c.d = d(e), !c.src || !c.w || c.w < p ? (c.w = p, u = function(e) {
                for (var t, i, n = e.length, o = e[n - 1], s = 0; s < n; s++) if ((o = e[s]).d = o.w / e.w, 
                o.d >= e.d) {
                    !o.cached && (t = e[s - 1]) && t.d > e.d - .13 * Math.pow(e.d, 2.2) && (i = Math.pow(t.d - .6, 1.6), 
                    t.cached && (t.d += .15 * i), t.d + (o.d - e.d) * i > e.d && (o = t));
                    break;
                }
                return o;
            }(c.sort(o)), c.src = u) : u = c.src) : u = c[0], u;
        }, f = function(e) {
            if (!r || !e.parentNode || "PICTURE" == e.parentNode.nodeName.toUpperCase()) {
                var t = p(e);
                t && t.u && e._lazypolyfill.cur != t.u && (e._lazypolyfill.cur = t.u, t.cached = !0, 
                e.setAttribute(s.srcAttr, t.u), e.setAttribute("src", t.u));
            }
        };
        return f.parse = c, f;
    }(), s.loadedClass && s.loadingClass && function() {
        var e = [];
        [ 'img[sizes$="px"][srcset].', "picture > img:not([srcset])." ].forEach(function(t) {
            e.push(t + s.loadedClass), e.push(t + s.loadingClass);
        }), s.pf({
            elements: t.querySelectorAll(e.join(", "))
        });
    }()));
}), function(e, t) {
    var i = function() {
        t(e.lazySizes), e.removeEventListener("lazyunveilread", i, !0);
    };
    t = t.bind(null, e, e.document), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? i() : e.addEventListener("lazyunveilread", i, !0);
}(window, function(e, t, i) {
    "use strict";
    if (e.addEventListener) {
        var n, o = /^picture$/i, s = t.documentElement, a = function() {
            var e, t = /(([^,\s].[^\s]+)\s+(\d+)(w|h)(\s+(\d+)(w|h))?)/g, i = function(t, i, n, o, s, a, r, l) {
                e.push({
                    c: i,
                    u: n,
                    w: 1 * ("w" == l ? r : o)
                });
            };
            return function(n) {
                return e = [], n.replace(t, i), e;
            };
        }(), r = function() {
            var e = function(e, t) {
                return e.w - t.w;
            }, t = function(t, n) {
                var o = {
                    srcset: t.getAttribute(i.cfg.srcsetAttr) || ""
                }, s = a(o.srcset);
                return Object.defineProperty(t, n, {
                    value: o,
                    writable: !0
                }), o.cands = s, o.index = 0, o.dirty = !1, s[0] && s[0].w ? (s.sort(e), o.cSrcset = [ s[o.index].c ]) : (o.cSrcset = o.srcset ? [ o.srcset ] : [], 
                o.cands = []), o;
            };
            return function(e, i) {
                var n, s, a, r;
                if (!e[i] && (r = e.parentNode || {}, e[i] = t(e, i), e[i].isImg = !0, o.test(r.nodeName || ""))) for (e[i].picture = !0, 
                s = 0, a = (n = r.getElementsByTagName("source")).length; s < a; s++) t(n[s], i).isImg = !1;
                return e[i];
            };
        }(), l = {
            _lazyOptimumx: function() {
                var e = function(e, t, i) {
                    var n, o;
                    return !e || !e.d || (o = i > .7 ? .6 : .4, !(e.d >= i) && ((n = Math.pow(e.d - o, 1.6) || .1) < .1 ? n = .1 : n > 3 && (n = 3), 
                    e.d + (t - i) * n < i));
                };
                return function(t, i, n) {
                    var o, s;
                    for (o = 0; o < t.cands.length; o++) if ((s = t.cands[o]).d = (s.w || 1) / i, !(t.index >= o)) {
                        if (!(s.d <= n || e(t.cands[o - 1], s.d, n))) break;
                        t.cSrcset.push(s.c), t.index = o;
                    }
                };
            }()
        }, c = function() {
            var e = function(e, t, i, n, o) {
                var s, a = e[o];
                a && (s = a.index, l[o](a, t, i), a.dirty && s == a.index || (a.cSrcset.join(", "), 
                e.setAttribute(n, a.cSrcset.join(", ")), a.dirty = !0));
            };
            return function(t, i, n, o, s) {
                var a, r, l, c, u = t[s];
                if (u.width = i, u.picture && (r = t.parentNode)) for (c = 0, l = (a = r.getElementsByTagName("source")).length; c < l; c++) e(a[c], i, n, o, s);
                e(t, i, n, o, s);
            };
        }(), u = function(e) {
            var t = e.getAttribute("data-optimumx") || e.getAttribute("data-maxdpr");
            return !t && n.constrainPixelDensity && (t = "auto"), t && (t = "auto" == t ? n.getOptimumX(e) : parseFloat(t, 10)), 
            t;
        }, h = function() {
            i && !i.getOptimumX && (i.getX = u, i.pWS = a, s.removeEventListener("lazybeforeunveil", h));
        };
        s.addEventListener("lazybeforeunveil", h), setTimeout(h), "function" != typeof (n = i && i.cfg).getOptimumX && (n.getOptimumX = function() {
            var t = e.devicePixelRatio || 1;
            return t > 2.6 ? t *= .6 : t > 1.9 ? t *= .8 : t -= .01, Math.min(Math.round(100 * t) / 100, 2);
        }), e.devicePixelRatio && addEventListener("lazybeforesizes", function(e) {
            if (e.detail.instance == i) {
                var t, o, s, a, l = e.target, h = e.detail, d = h.dataAttr;
                e.defaultPrevented || !(t = u(l)) || t >= devicePixelRatio || (!d || !l._lazyOptimumx || h.reloaded || n.unloadedClass && i.hC(l, n.unloadedClass) || (l._lazyOptimumx = null), 
                o = r(l, "_lazyOptimumx"), (s = h.width) && (o.width || 0) < s && (a = d ? i.cfg.srcsetAttr : "srcset", 
                i.rAF(function() {
                    c(l, s, t, a, "_lazyOptimumx");
                })));
            }
        });
    }
}), function(e, t) {
    var i = function() {
        t(e.lazySizes), e.removeEventListener("lazyunveilread", i, !0);
    };
    t = t.bind(null, e, e.document), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? i() : e.addEventListener("lazyunveilread", i, !0);
}(window, function(e, t, i) {
    "use strict";
    if (e.addEventListener) {
        var n = i.cfg, o = /\s+/g, s = /\s*\|\s+|\s+\|\s*/g, a = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/, r = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/, l = /\(|\)|'/, c = {
            contain: 1,
            cover: 1
        }, u = function(e, t) {
            if (t) {
                var i = t.match(r);
                i && i[1] ? e.setAttribute("type", i[1]) : e.setAttribute("media", n.customMedia[t] || t);
            }
        }, h = function(e, i, r) {
            var l = t.createElement("picture"), c = i.getAttribute(n.sizesAttr), h = i.getAttribute("data-ratio"), d = i.getAttribute("data-optimumx");
            i._lazybgset && i._lazybgset.parentNode == i && i.removeChild(i._lazybgset), Object.defineProperty(r, "_lazybgset", {
                value: i,
                writable: !0
            }), Object.defineProperty(i, "_lazybgset", {
                value: l,
                writable: !0
            }), e = e.replace(o, " ").split(s), l.style.display = "none", r.className = n.lazyClass, 
            1 != e.length || c || (c = "auto"), e.forEach(function(e) {
                var i, o = t.createElement("source");
                c && "auto" != c && o.setAttribute("sizes", c), (i = e.match(a)) ? (o.setAttribute(n.srcsetAttr, i[1]), 
                u(o, i[2]), u(o, i[3])) : o.setAttribute(n.srcsetAttr, e), l.appendChild(o);
            }), c && (r.setAttribute(n.sizesAttr, c), i.removeAttribute(n.sizesAttr), i.removeAttribute("sizes")), 
            d && r.setAttribute("data-optimumx", d), h && r.setAttribute("data-ratio", h), l.appendChild(r), 
            i.appendChild(l);
        }, d = function(e) {
            if (e.target._lazybgset) {
                var t = e.target, n = t._lazybgset, o = t.currentSrc || t.src;
                if (o) {
                    var s = i.fire(n, "bgsetproxy", {
                        src: o,
                        useSrc: l.test(o) ? JSON.stringify(o) : o
                    });
                    s.defaultPrevented || (n.style.backgroundImage = "url(" + s.detail.useSrc + ")");
                }
                t._lazybgsetLoading && (i.fire(n, "_lazyloaded", {}, !1, !0), delete t._lazybgsetLoading);
            }
        };
        addEventListener("lazybeforeunveil", function(e) {
            var n, o, s;
            !e.defaultPrevented && (n = e.target.getAttribute("data-bgset")) && (s = e.target, 
            (o = t.createElement("img")).alt = "", o._lazybgsetLoading = !0, e.detail.firesLoad = !0, 
            h(n, s, o), setTimeout(function() {
                i.loader.unveil(o), i.rAF(function() {
                    i.fire(o, "_lazyloaded", {}, !0, !0), o.complete && d({
                        target: o
                    });
                });
            }));
        }), t.addEventListener("load", d, !0), e.addEventListener("lazybeforesizes", function(e) {
            if (e.detail.instance == i && e.target._lazybgset && e.detail.dataAttr) {
                var t = function(e) {
                    var t;
                    return t = (getComputedStyle(e) || {
                        getPropertyValue: function() {}
                    }).getPropertyValue("background-size"), !c[t] && c[e.style.backgroundSize] && (t = e.style.backgroundSize), 
                    t;
                }(e.target._lazybgset);
                c[t] && (e.target._lazysizesParentFit = t, i.rAF(function() {
                    e.target.setAttribute("data-parent-fit", t), e.target._lazysizesParentFit && delete e.target._lazysizesParentFit;
                }));
            }
        }, !0), t.documentElement.addEventListener("lazybeforesizes", function(e) {
            !e.defaultPrevented && e.target._lazybgset && e.detail.instance == i && (e.detail.width = function(e) {
                var t = i.gW(e, e.parentNode);
                return (!e._lazysizesWidth || t > e._lazysizesWidth) && (e._lazysizesWidth = t), 
                e._lazysizesWidth;
            }(e.target._lazybgset));
        });
    }
}), function(e, t) {
    var i = function() {
        t(e.lazySizes), e.removeEventListener("lazyunveilread", i, !0);
    };
    t = t.bind(null, e, e.document), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? i() : e.addEventListener("lazyunveilread", i, !0);
}(window, function(e, t, i) {
    "use strict";
    function n(t, i) {
        var n, o, s, a, r = e.getComputedStyle(t);
        for (n in o = t.parentNode, a = {
            isPicture: !(!o || !d.test(o.nodeName || ""))
        }, s = function(e, i) {
            var n = t.getAttribute("data-" + e);
            if (!n) {
                var o = r.getPropertyValue("--ls-" + e);
                o && (n = o.trim());
            }
            if (n) {
                if ("true" == n) n = !0; else if ("false" == n) n = !1; else if (h.test(n)) n = parseFloat(n); else if ("function" == typeof l[e]) n = l[e](t, n); else if (g.test(n)) try {
                    n = JSON.parse(n);
                } catch (e) {}
                a[e] = n;
            } else e in l && "function" != typeof l[e] ? a[e] = l[e] : i && "function" == typeof l[e] && (a[e] = l[e](t, n));
        }, l) s(n);
        return i.replace(f, function(e, t) {
            t in a || s(t, !0);
        }), a;
    }
    function o(e, i, n) {
        var o = 0, s = 0, a = n;
        if (e) {
            if ("container" === i.ratio) {
                for (o = a.scrollWidth, s = a.scrollHeight; !(o && s || a === t); ) o = (a = a.parentNode).scrollWidth, 
                s = a.scrollHeight;
                o && s && (i.ratio = s / o);
            }
            (e = function(e, t) {
                var i = [];
                return i.srcset = [], t.absUrl && (y.setAttribute("href", e), e = y.href), e = ((t.prefix || "") + e + (t.postfix || "")).replace(f, function(e, i) {
                    return u[typeof t[i]] ? t[i] : e;
                }), t.widths.forEach(function(n) {
                    var o = t.widthmap[n] || n, s = t.aspectratio || t.ratio, a = !t.aspectratio && l.traditionalRatio, r = {
                        u: e.replace(m, o).replace(p, s ? a ? Math.round(n * s) : Math.round(n / s) : ""),
                        w: n
                    };
                    i.push(r), i.srcset.push(r.c = r.u + " " + n + "w");
                }), i;
            }(e, i)).isPicture = i.isPicture, w && "IMG" == n.nodeName.toUpperCase() ? n.removeAttribute(r.srcsetAttr) : n.setAttribute(r.srcsetAttr, e.srcset.join(", ")), 
            Object.defineProperty(n, "_lazyrias", {
                value: e,
                writable: !0
            });
        }
    }
    function s(e, t) {
        var o = n(e, t);
        return l.modifyOptions.call(e, {
            target: e,
            details: o,
            detail: o
        }), i.fire(e, "lazyriasmodifyoptions", o), o;
    }
    function a(e) {
        return e.getAttribute(e.getAttribute("data-srcattr") || l.srcAttr) || e.getAttribute(r.srcsetAttr) || e.getAttribute(r.srcAttr) || e.getAttribute("data-pfsrcset") || "";
    }
    var r, l, c = i.cfg, u = {
        string: 1,
        number: 1
    }, h = /^\-*\+*\d+\.*\d*$/, d = /^picture$/i, m = /\s*\{\s*width\s*\}\s*/i, p = /\s*\{\s*height\s*\}\s*/i, f = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, g = /^\[.*\]|\{.*\}$/, v = /^(?:auto|\d+(px)?)$/, y = t.createElement("a"), _ = t.createElement("img"), w = "srcset" in _ && !("sizes" in _), b = !!e.HTMLPictureElement && !w;
    !function() {
        var e, t = {
            prefix: "",
            postfix: "",
            srcAttr: "data-src",
            absUrl: !1,
            modifyOptions: function() {},
            widthmap: {},
            ratio: !1,
            traditionalRatio: !1,
            aspectratio: !1
        };
        for (e in (r = i && i.cfg).supportsType || (r.supportsType = function(e) {
            return !e;
        }), r.rias || (r.rias = {}), "widths" in (l = r.rias) || (l.widths = [], function(e) {
            for (var t, i = 0; !t || t < 3e3; ) (i += 5) > 30 && (i += 1), t = 36 * i, e.push(t);
        }(l.widths)), t) e in l || (l[e] = t[e]);
    }(), addEventListener("lazybeforesizes", function(e) {
        var t, n, c, u, h, d, p, f, g, y, _, w, E;
        if (e.detail.instance == i && (t = e.target, e.detail.dataAttr && !e.defaultPrevented && !l.disabled && (g = t.getAttribute(r.sizesAttr) || t.getAttribute("sizes")) && v.test(g))) {
            if (c = s(t, n = a(t)), _ = m.test(c.prefix) || m.test(c.postfix), c.isPicture && (u = t.parentNode)) for (d = 0, 
            p = (h = u.getElementsByTagName("source")).length; d < p; d++) (_ || m.test(f = a(h[d]))) && (o(f, c, h[d]), 
            w = !0);
            _ || m.test(n) ? (o(n, c, t), w = !0) : w && ((E = []).srcset = [], E.isPicture = !0, 
            Object.defineProperty(t, "_lazyrias", {
                value: E,
                writable: !0
            })), w && (b ? t.removeAttribute(r.srcAttr) : "auto" != g && (y = {
                width: parseInt(g, 10)
            }, C({
                target: t,
                detail: y
            })));
        }
    }, !0);
    var C = function() {
        var n = function(e, t) {
            return e.w - t.w;
        }, o = function(e, t) {
            var n;
            return !e._lazyrias && i.pWS && (n = i.pWS(e.getAttribute(r.srcsetAttr || ""))).length && (Object.defineProperty(e, "_lazyrias", {
                value: n,
                writable: !0
            }), t && e.parentNode && (n.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase())), 
            e._lazyrias;
        }, s = function(t) {
            var n = e.devicePixelRatio || 1, o = i.getX && i.getX(t);
            return Math.min(o || n, 2.4, n);
        }, a = function(t, i) {
            var a, r, l, c, u, h;
            if ((u = t._lazyrias).isPicture && e.matchMedia) for (r = 0, l = (a = t.parentNode.getElementsByTagName("source")).length; r < l; r++) if (o(a[r]) && !a[r].getAttribute("type") && (!(c = a[r].getAttribute("media")) || (matchMedia(c) || {}).matches)) {
                u = a[r]._lazyrias;
                break;
            }
            return (!u.w || u.w < i) && (u.w = i, u.d = s(t), h = function(e) {
                for (var t, i, n = e.length, o = e[n - 1], s = 0; s < n; s++) if ((o = e[s]).d = o.w / e.w, 
                o.d >= e.d) {
                    !o.cached && (t = e[s - 1]) && t.d > e.d - .13 * Math.pow(e.d, 2.2) && (i = Math.pow(t.d - .6, 1.6), 
                    t.cached && (t.d += .15 * i), t.d + (o.d - e.d) * i > e.d && (o = t));
                    break;
                }
                return o;
            }(u.sort(n))), h;
        }, l = function(n) {
            if (n.detail.instance == i) {
                var s, u = n.target;
                return !w && (e.respimage || e.picturefill || c.pf) ? void t.removeEventListener("lazybeforesizes", l) : void (("_lazyrias" in u || n.detail.dataAttr && o(u, !0)) && (s = a(u, n.detail.width), 
                s && s.u && u._lazyrias.cur != s.u && (u._lazyrias.cur = s.u, s.cached = !0, i.rAF(function() {
                    u.setAttribute(r.srcAttr, s.u), u.setAttribute("src", s.u);
                }))));
            }
        };
        return b ? l = function() {} : addEventListener("lazybeforesizes", l), l;
    }();
}), function(e, t) {
    var i = function() {
        t(e.lazySizes), e.removeEventListener("lazyunveilread", i, !0);
    };
    t = t.bind(null, e, e.document), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? i() : e.addEventListener("lazyunveilread", i, !0);
}(window, function(e, t, i) {
    "use strict";
    function n(e, i) {
        if (!a[e]) {
            var n = t.createElement(i ? "link" : "script"), o = t.getElementsByTagName("script")[0];
            i ? (n.rel = "stylesheet", n.href = e) : n.src = e, a[e] = !0, a[n.src || n.href] = !0, 
            o.parentNode.insertBefore(n, o);
        }
    }
    var o, s, a = {};
    t.addEventListener && (s = /\(|\)|\s|'/, o = function(e, i) {
        var n = t.createElement("img");
        n.onload = function() {
            n.onload = null, n.onerror = null, n = null, i();
        }, n.onerror = n.onload, n.src = e, n && n.complete && n.onload && n.onload();
    }, addEventListener("lazybeforeunveil", function(e) {
        var t, a, r;
        e.detail.instance == i && (e.defaultPrevented || ("none" == e.target.preload && (e.target.preload = "auto"), 
        (t = e.target.getAttribute("data-link")) && n(t, !0), (t = e.target.getAttribute("data-script")) && n(t), 
        (t = e.target.getAttribute("data-require")) && (i.cfg.requireJs ? i.cfg.requireJs([ t ]) : n(t)), 
        (a = e.target.getAttribute("data-bg")) && (e.detail.firesLoad = !0, o(a, function() {
            e.target.style.backgroundImage = "url(" + (s.test(a) ? JSON.stringify(a) : a) + ")", 
            e.detail.firesLoad = !1, i.fire(e.target, "_lazyloaded", {}, !0, !0);
        })), (r = e.target.getAttribute("data-poster")) && (e.detail.firesLoad = !0, o(r, function() {
            e.target.poster = r, e.detail.firesLoad = !1, i.fire(e.target, "_lazyloaded", {}, !0, !0);
        }))));
    }, !1));
}), function(e) {
    if ("object" == typeof exports && "undefined" != typeof module) module.exports = e(); else if ("function" == typeof define && define.amd) define([], e); else {
        ("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).domDelegate = e();
    }
}(function() {
    return function e(t, i, n) {
        function o(a, r) {
            if (!i[a]) {
                if (!t[a]) {
                    var l = "function" == typeof require && require;
                    if (!r && l) return l(a, !0);
                    if (s) return s(a, !0);
                    var c = new Error("Cannot find module '" + a + "'");
                    throw c.code = "MODULE_NOT_FOUND", c;
                }
                var u = i[a] = {
                    exports: {}
                };
                t[a][0].call(u.exports, function(e) {
                    var i = t[a][1][e];
                    return o(i || e);
                }, u, u.exports, e, t, i, n);
            }
            return i[a].exports;
        }
        for (var s = "function" == typeof require && require, a = 0; a < n.length; a++) o(n[a]);
        return o;
    }({
        1: [ function(e, t, i) {
            "use strict";
            function n(e) {
                this.listenerMap = [ {}, {} ], e && this.root(e), this.handle = n.prototype.handle.bind(this);
            }
            function o(e, t) {
                return e.toLowerCase() === t.tagName.toLowerCase();
            }
            function s(e, t) {
                return e === t.id;
            }
            t.exports = n, n.prototype.root = function(e) {
                var t, i = this.listenerMap;
                if (this.rootElement) {
                    for (t in i[1]) i[1].hasOwnProperty(t) && this.rootElement.removeEventListener(t, this.handle, !0);
                    for (t in i[0]) i[0].hasOwnProperty(t) && this.rootElement.removeEventListener(t, this.handle, !1);
                }
                if (!e || !e.addEventListener) return this.rootElement && delete this.rootElement, 
                this;
                for (t in this.rootElement = e, i[1]) i[1].hasOwnProperty(t) && this.rootElement.addEventListener(t, this.handle, !0);
                for (t in i[0]) i[0].hasOwnProperty(t) && this.rootElement.addEventListener(t, this.handle, !1);
                return this;
            }, n.prototype.captureForType = function(e) {
                return -1 !== [ "blur", "error", "focus", "load", "resize", "scroll" ].indexOf(e);
            }, n.prototype.on = function(e, t, i, n) {
                var r, l, c, u;
                if (!e) throw new TypeError("Invalid event type: " + e);
                if ("function" == typeof t && (n = i, i = t, t = null), void 0 === n && (n = this.captureForType(e)), 
                "function" != typeof i) throw new TypeError("Handler must be a type of Function");
                return r = this.rootElement, (l = this.listenerMap[n ? 1 : 0])[e] || (r && r.addEventListener(e, this.handle, n), 
                l[e] = []), t ? /^[a-z]+$/i.test(t) ? (u = t, c = o) : /^#[a-z0-9\-_]+$/i.test(t) ? (u = t.slice(1), 
                c = s) : (u = t, c = a) : (u = null, c = function(e, t) {
                    return this.rootElement === window ? t === document : this.rootElement === t;
                }.bind(this)), l[e].push({
                    selector: t,
                    handler: i,
                    matcher: c,
                    matcherParam: u
                }), this;
            }, n.prototype.off = function(e, t, i, n) {
                var o, s, a, r, l;
                if ("function" == typeof t && (n = i, i = t, t = null), void 0 === n) return this.off(e, t, i, !0), 
                this.off(e, t, i, !1), this;
                if (a = this.listenerMap[n ? 1 : 0], !e) {
                    for (l in a) a.hasOwnProperty(l) && this.off(l, t, i);
                    return this;
                }
                if (!(r = a[e]) || !r.length) return this;
                for (o = r.length - 1; o >= 0; o--) s = r[o], t && t !== s.selector || i && i !== s.handler || r.splice(o, 1);
                return r.length || (delete a[e], this.rootElement && this.rootElement.removeEventListener(e, this.handle, n)), 
                this;
            }, n.prototype.handle = function(e) {
                var t, i, n, o, s, a, r = e.type, l = [], c = "ftLabsDelegateIgnore";
                if (!0 !== e[c]) {
                    switch (3 === (a = e.target).nodeType && (a = a.parentNode), n = this.rootElement, 
                    e.eventPhase || (e.target !== e.currentTarget ? 3 : 2)) {
                      case 1:
                        l = this.listenerMap[1][r];
                        break;

                      case 2:
                        this.listenerMap[0] && this.listenerMap[0][r] && (l = l.concat(this.listenerMap[0][r])), 
                        this.listenerMap[1] && this.listenerMap[1][r] && (l = l.concat(this.listenerMap[1][r]));
                        break;

                      case 3:
                        l = this.listenerMap[0][r];
                    }
                    for (i = l.length; a && i; ) {
                        for (t = 0; t < i && (o = l[t]); t++) if (o.matcher.call(a, o.matcherParam, a) && (s = this.fire(e, a, o)), 
                        !1 === s) return e[c] = !0, void e.preventDefault();
                        if (a === n) break;
                        i = l.length, a = a.parentElement;
                    }
                }
            }, n.prototype.fire = function(e, t, i) {
                return i.handler.call(t, e, t);
            };
            var a = function(e) {
                if (e) {
                    var t = e.prototype;
                    return t.matches || t.matchesSelector || t.webkitMatchesSelector || t.mozMatchesSelector || t.msMatchesSelector || t.oMatchesSelector;
                }
            }(Element);
            n.prototype.destroy = function() {
                this.off(), this.root();
            };
        }, {} ],
        2: [ function(e, t, i) {
            "use strict";
            var n = e("./delegate");
            t.exports = function(e) {
                return new n(e);
            }, t.exports.Delegate = n;
        }, {
            "./delegate": 1
        } ]
    }, {}, [ 2 ])(2);
}), function(e) {
    if ("object" == typeof exports && "undefined" != typeof module) module.exports = e(); else if ("function" == typeof define && define.amd) define([], e); else {
        ("undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this).Drift = e();
    }
}(function() {
    return function() {
        return function e(t, i, n) {
            function o(a, r) {
                if (!i[a]) {
                    if (!t[a]) {
                        var l = "function" == typeof require && require;
                        if (!r && l) return l(a, !0);
                        if (s) return s(a, !0);
                        var c = new Error("Cannot find module '" + a + "'");
                        throw c.code = "MODULE_NOT_FOUND", c;
                    }
                    var u = i[a] = {
                        exports: {}
                    };
                    t[a][0].call(u.exports, function(e) {
                        return o(t[a][1][e] || e);
                    }, u, u.exports, e, t, i, n);
                }
                return i[a].exports;
            }
            for (var s = "function" == typeof require && require, a = 0; a < n.length; a++) o(n[a]);
            return o;
        };
    }()({
        1: [ function(e, t, i) {
            "use strict";
            Object.defineProperty(i, "__esModule", {
                value: !0
            });
            var n = function() {
                function e(e, t) {
                    for (var i = 0; i < t.length; i++) {
                        var n = t[i];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), 
                        Object.defineProperty(e, n.key, n);
                    }
                }
                return function(t, i, n) {
                    return i && e(t.prototype, i), n && e(t, n), t;
                };
            }(), o = function(e) {
                return e && e.__esModule ? e : {
                    "default": e
                };
            }(e("./util/throwIfMissing")), s = e("./util/dom"), a = function() {
                function e(t) {
                    (function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    })(this, e), this.isShowing = !1;
                    var i = t.namespace, n = void 0 === i ? null : i, s = t.zoomFactor, a = void 0 === s ? (0, 
                    o.default)() : s, r = t.containerEl, l = void 0 === r ? (0, o.default)() : r;
                    this.settings = {
                        namespace: n,
                        zoomFactor: a,
                        containerEl: l
                    }, this.openClasses = this._buildClasses("open"), this._buildElement();
                }
                return n(e, [ {
                    key: "_buildClasses",
                    value: function(e) {
                        var t = [ "drift-" + e ], i = this.settings.namespace;
                        return i && t.push(i + "-" + e), t;
                    }
                }, {
                    key: "_buildElement",
                    value: function() {
                        this.el = document.createElement("div"), (0, s.addClasses)(this.el, this._buildClasses("bounding-box"));
                    }
                }, {
                    key: "show",
                    value: function(e, t) {
                        this.isShowing = !0, this.settings.containerEl.appendChild(this.el);
                        var i = this.el.style;
                        i.width = Math.round(e / this.settings.zoomFactor) + "px", i.height = Math.round(t / this.settings.zoomFactor) + "px", 
                        (0, s.addClasses)(this.el, this.openClasses);
                    }
                }, {
                    key: "hide",
                    value: function() {
                        this.isShowing && this.settings.containerEl.removeChild(this.el), this.isShowing = !1, 
                        (0, s.removeClasses)(this.el, this.openClasses);
                    }
                }, {
                    key: "setPosition",
                    value: function(e, t, i) {
                        var n = window.pageXOffset, o = window.pageYOffset, s = i.left + e * i.width - this.el.clientWidth / 2 + n, a = i.top + t * i.height - this.el.clientHeight / 2 + o;
                        this.el.getBoundingClientRect(), s < i.left + n ? s = i.left + n : s + this.el.clientWidth > i.left + i.width + n && (s = i.left + i.width - this.el.clientWidth + n), 
                        a < i.top + o ? a = i.top + o : a + this.el.clientHeight > i.top + i.height + o && (a = i.top + i.height - this.el.clientHeight + o), 
                        this.el.style.left = s + "px", this.el.style.top = a + "px";
                    }
                } ]), e;
            }();
            i.default = a;
        }, {
            "./util/dom": 6,
            "./util/throwIfMissing": 7
        } ],
        2: [ function(e, t, i) {
            "use strict";
            function n(e) {
                return e && e.__esModule ? e : {
                    "default": e
                };
            }
            var o = function() {
                function e(e, t) {
                    for (var i = 0; i < t.length; i++) {
                        var n = t[i];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), 
                        Object.defineProperty(e, n.key, n);
                    }
                }
                return function(t, i, n) {
                    return i && e(t.prototype, i), n && e(t, n), t;
                };
            }(), s = e("./util/dom"), a = n(e("./injectBaseStylesheet")), r = n(e("./Trigger")), l = n(e("./ZoomPane"));
            t.exports = function() {
                function e(t) {
                    var i = this, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e), this.VERSION = "1.2.2", this.destroy = function() {
                        i.trigger._unbindEvents();
                    }, this.triggerEl = t, !(0, s.isDOMElement)(this.triggerEl)) throw new TypeError("`new Drift` requires a DOM element as its first argument.");
                    var o = n.namespace, r = void 0 === o ? null : o, l = n.showWhitespaceAtEdges, c = void 0 !== l && l, u = n.containInline, h = void 0 !== u && u, d = n.inlineOffsetX, m = void 0 === d ? 0 : d, p = n.inlineOffsetY, f = void 0 === p ? 0 : p, g = n.inlineContainer, v = void 0 === g ? document.body : g, y = n.sourceAttribute, _ = void 0 === y ? "data-zoom" : y, w = n.zoomFactor, b = void 0 === w ? 3 : w, C = n.paneContainer, E = void 0 === C ? document.body : C, k = n.inlinePane, S = void 0 === k ? 375 : k, x = n.handleTouch, L = void 0 === x || x, A = n.onShow, P = void 0 === A ? null : A, M = n.onHide, D = void 0 === M ? null : M, z = n.injectBaseStyles, T = void 0 === z || z, I = n.hoverDelay, O = void 0 === I ? 0 : I, q = n.touchDelay, B = void 0 === q ? 0 : q, N = n.hoverBoundingBox, R = void 0 !== N && N, j = n.touchBoundingBox, H = void 0 !== j && j, F = n.boundingBoxContainer, $ = void 0 === F ? document.body : F;
                    if (!0 !== S && !(0, s.isDOMElement)(E)) throw new TypeError("`paneContainer` must be a DOM element when `inlinePane !== true`");
                    if (!(0, s.isDOMElement)(v)) throw new TypeError("`inlineContainer` must be a DOM element");
                    this.settings = {
                        namespace: r,
                        showWhitespaceAtEdges: c,
                        containInline: h,
                        inlineOffsetX: m,
                        inlineOffsetY: f,
                        inlineContainer: v,
                        sourceAttribute: _,
                        zoomFactor: b,
                        paneContainer: E,
                        inlinePane: S,
                        handleTouch: L,
                        onShow: P,
                        onHide: D,
                        injectBaseStyles: T,
                        hoverDelay: O,
                        touchDelay: B,
                        hoverBoundingBox: R,
                        touchBoundingBox: H,
                        boundingBoxContainer: $
                    }, this.settings.injectBaseStyles && (0, a.default)(), this._buildZoomPane(), this._buildTrigger();
                }
                return o(e, [ {
                    key: "_buildZoomPane",
                    value: function() {
                        this.zoomPane = new l.default({
                            container: this.settings.paneContainer,
                            zoomFactor: this.settings.zoomFactor,
                            showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges,
                            containInline: this.settings.containInline,
                            inline: this.settings.inlinePane,
                            namespace: this.settings.namespace,
                            inlineOffsetX: this.settings.inlineOffsetX,
                            inlineOffsetY: this.settings.inlineOffsetY,
                            inlineContainer: this.settings.inlineContainer
                        });
                    }
                }, {
                    key: "_buildTrigger",
                    value: function() {
                        this.trigger = new r.default({
                            el: this.triggerEl,
                            zoomPane: this.zoomPane,
                            handleTouch: this.settings.handleTouch,
                            onShow: this.settings.onShow,
                            onHide: this.settings.onHide,
                            sourceAttribute: this.settings.sourceAttribute,
                            hoverDelay: this.settings.hoverDelay,
                            touchDelay: this.settings.touchDelay,
                            hoverBoundingBox: this.settings.hoverBoundingBox,
                            touchBoundingBox: this.settings.touchBoundingBox,
                            namespace: this.settings.namespace,
                            zoomFactor: this.settings.zoomFactor,
                            boundingBoxContainer: this.settings.boundingBoxContainer
                        });
                    }
                }, {
                    key: "setZoomImageURL",
                    value: function(e) {
                        this.zoomPane._setImageURL(e);
                    }
                }, {
                    key: "disable",
                    value: function() {
                        this.trigger.enabled = !1;
                    }
                }, {
                    key: "enable",
                    value: function() {
                        this.trigger.enabled = !0;
                    }
                }, {
                    key: "isShowing",
                    get: function() {
                        return this.zoomPane.isShowing;
                    }
                }, {
                    key: "zoomFactor",
                    get: function() {
                        return this.settings.zoomFactor;
                    },
                    set: function(e) {
                        this.settings.zoomFactor = e, this.zoomPane.settings.zoomFactor = e, this.trigger.settings.zoomFactor = e, 
                        this.boundingBox.settings.zoomFactor = e;
                    }
                } ]), e;
            }();
        }, {
            "./Trigger": 3,
            "./ZoomPane": 4,
            "./injectBaseStylesheet": 5,
            "./util/dom": 6
        } ],
        3: [ function(e, t, i) {
            "use strict";
            function n(e) {
                return e && e.__esModule ? e : {
                    "default": e
                };
            }
            Object.defineProperty(i, "__esModule", {
                value: !0
            });
            var o = function() {
                function e(e, t) {
                    for (var i = 0; i < t.length; i++) {
                        var n = t[i];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), 
                        Object.defineProperty(e, n.key, n);
                    }
                }
                return function(t, i, n) {
                    return i && e(t.prototype, i), n && e(t, n), t;
                };
            }(), s = n(e("./util/throwIfMissing")), a = n(e("./BoundingBox")), r = function() {
                function e() {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    (function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    })(this, e), l.call(this);
                    var i = t.el, n = void 0 === i ? (0, s.default)() : i, o = t.zoomPane, r = void 0 === o ? (0, 
                    s.default)() : o, c = t.sourceAttribute, u = void 0 === c ? (0, s.default)() : c, h = t.handleTouch, d = void 0 === h ? (0, 
                    s.default)() : h, m = t.onShow, p = void 0 === m ? null : m, f = t.onHide, g = void 0 === f ? null : f, v = t.hoverDelay, y = void 0 === v ? 0 : v, _ = t.touchDelay, w = void 0 === _ ? 0 : _, b = t.hoverBoundingBox, C = void 0 === b ? (0, 
                    s.default)() : b, E = t.touchBoundingBox, k = void 0 === E ? (0, s.default)() : E, S = t.namespace, x = void 0 === S ? null : S, L = t.zoomFactor, A = void 0 === L ? (0, 
                    s.default)() : L, P = t.boundingBoxContainer, M = void 0 === P ? (0, s.default)() : P;
                    this.settings = {
                        el: n,
                        zoomPane: r,
                        sourceAttribute: u,
                        handleTouch: d,
                        onShow: p,
                        onHide: g,
                        hoverDelay: y,
                        touchDelay: w,
                        hoverBoundingBox: C,
                        touchBoundingBox: k,
                        namespace: x,
                        zoomFactor: A,
                        boundingBoxContainer: M
                    }, (this.settings.hoverBoundingBox || this.settings.touchBoundingBox) && (this.boundingBox = new a.default({
                        namespace: this.settings.namespace,
                        zoomFactor: this.settings.zoomFactor,
                        containerEl: this.settings.boundingBoxContainer
                    })), this.enabled = !0, this._bindEvents();
                }
                return o(e, [ {
                    key: "_bindEvents",
                    value: function() {
                        this.settings.el.addEventListener("mouseenter", this._handleEntry, !1), this.settings.el.addEventListener("mouseleave", this._hide, !1), 
                        this.settings.el.addEventListener("mousemove", this._handleMovement, !1), this.settings.handleTouch && (this.settings.el.addEventListener("touchstart", this._handleEntry, !1), 
                        this.settings.el.addEventListener("touchend", this._hide, !1), this.settings.el.addEventListener("touchmove", this._handleMovement, !1));
                    }
                }, {
                    key: "_unbindEvents",
                    value: function() {
                        this.settings.el.removeEventListener("mouseenter", this._handleEntry, !1), this.settings.el.removeEventListener("mouseleave", this._hide, !1), 
                        this.settings.el.removeEventListener("mousemove", this._handleMovement, !1), this.settings.handleTouch && (this.settings.el.removeEventListener("touchstart", this._handleEntry, !1), 
                        this.settings.el.removeEventListener("touchend", this._hide, !1), this.settings.el.removeEventListener("touchmove", this._handleMovement, !1));
                    }
                }, {
                    key: "isShowing",
                    get: function() {
                        return this.settings.zoomPane.isShowing;
                    }
                } ]), e;
            }(), l = function() {
                var e = this;
                this._handleEntry = function(t) {
                    t.preventDefault(), e._lastMovement = t, "mouseenter" == t.type && e.settings.hoverDelay ? e.entryTimeout = setTimeout(e._show, e.settings.hoverDelay) : e.settings.touchDelay ? e.entryTimeout = setTimeout(e._show, e.settings.touchDelay) : e._show();
                }, this._show = function() {
                    if (e.enabled) {
                        var t = e.settings.onShow;
                        if (t && "function" == typeof t && t(), e.settings.zoomPane.show(e.settings.el.getAttribute(e.settings.sourceAttribute), e.settings.el.clientWidth, e.settings.el.clientHeight), 
                        e._lastMovement) {
                            var i = e._lastMovement.touches;
                            (i && e.settings.touchBoundingBox || !i && e.settings.hoverBoundingBox) && e.boundingBox.show(e.settings.zoomPane.el.clientWidth, e.settings.zoomPane.el.clientHeight);
                        }
                        e._handleMovement();
                    }
                }, this._hide = function(t) {
                    t.preventDefault(), e._lastMovement = null, e.entryTimeout && clearTimeout(e.entryTimeout), 
                    e.boundingBox && e.boundingBox.hide();
                    var i = e.settings.onHide;
                    i && "function" == typeof i && i(), e.settings.zoomPane.hide();
                }, this._handleMovement = function(t) {
                    if (t) t.preventDefault(), e._lastMovement = t; else {
                        if (!e._lastMovement) return;
                        t = e._lastMovement;
                    }
                    var i = void 0, n = void 0;
                    if (t.touches) {
                        var o = t.touches[0];
                        i = o.clientX, n = o.clientY;
                    } else i = t.clientX, n = t.clientY;
                    var s = e.settings.el.getBoundingClientRect(), a = i - s.left, r = n - s.top, l = a / e.settings.el.clientWidth, c = r / e.settings.el.clientHeight;
                    e.boundingBox && e.boundingBox.setPosition(l, c, s), e.settings.zoomPane.setPosition(l, c, s);
                };
            };
            i.default = r;
        }, {
            "./BoundingBox": 1,
            "./util/throwIfMissing": 7
        } ],
        4: [ function(e, t, i) {
            "use strict";
            Object.defineProperty(i, "__esModule", {
                value: !0
            });
            var n = function() {
                function e(e, t) {
                    for (var i = 0; i < t.length; i++) {
                        var n = t[i];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), 
                        Object.defineProperty(e, n.key, n);
                    }
                }
                return function(t, i, n) {
                    return i && e(t.prototype, i), n && e(t, n), t;
                };
            }(), o = function(e) {
                return e && e.__esModule ? e : {
                    "default": e
                };
            }(e("./util/throwIfMissing")), s = e("./util/dom"), a = document.createElement("div").style, r = "undefined" != typeof document && ("animation" in a || "webkitAnimation" in a), l = function() {
                function e() {
                    var t = this, i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    (function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    })(this, e), this._completeShow = function() {
                        t.el.removeEventListener("animationend", t._completeShow, !1), t.el.removeEventListener("webkitAnimationEnd", t._completeShow, !1), 
                        (0, s.removeClasses)(t.el, t.openingClasses);
                    }, this._completeHide = function() {
                        t.el.removeEventListener("animationend", t._completeHide, !1), t.el.removeEventListener("webkitAnimationEnd", t._completeHide, !1), 
                        (0, s.removeClasses)(t.el, t.openClasses), (0, s.removeClasses)(t.el, t.closingClasses), 
                        (0, s.removeClasses)(t.el, t.inlineClasses), t.el.setAttribute("style", ""), t.el.parentElement === t.settings.container ? t.settings.container.removeChild(t.el) : t.el.parentElement === t.settings.inlineContainer && t.settings.inlineContainer.removeChild(t.el);
                    }, this._handleLoad = function() {
                        t.imgEl.removeEventListener("load", t._handleLoad, !1), (0, s.removeClasses)(t.el, t.loadingClasses);
                    }, this.isShowing = !1;
                    var n = i.container, a = void 0 === n ? null : n, r = i.zoomFactor, l = void 0 === r ? (0, 
                    o.default)() : r, c = i.inline, u = void 0 === c ? (0, o.default)() : c, h = i.namespace, d = void 0 === h ? null : h, m = i.showWhitespaceAtEdges, p = void 0 === m ? (0, 
                    o.default)() : m, f = i.containInline, g = void 0 === f ? (0, o.default)() : f, v = i.inlineOffsetX, y = void 0 === v ? 0 : v, _ = i.inlineOffsetY, w = void 0 === _ ? 0 : _, b = i.inlineContainer, C = void 0 === b ? document.body : b;
                    this.settings = {
                        container: a,
                        zoomFactor: l,
                        inline: u,
                        namespace: d,
                        showWhitespaceAtEdges: p,
                        containInline: g,
                        inlineOffsetX: y,
                        inlineOffsetY: w,
                        inlineContainer: C
                    }, this.openClasses = this._buildClasses("open"), this.openingClasses = this._buildClasses("opening"), 
                    this.closingClasses = this._buildClasses("closing"), this.inlineClasses = this._buildClasses("inline"), 
                    this.loadingClasses = this._buildClasses("loading"), this._buildElement();
                }
                return n(e, [ {
                    key: "_buildClasses",
                    value: function(e) {
                        var t = [ "drift-" + e ], i = this.settings.namespace;
                        return i && t.push(i + "-" + e), t;
                    }
                }, {
                    key: "_buildElement",
                    value: function() {
                        this.el = document.createElement("div"), (0, s.addClasses)(this.el, this._buildClasses("zoom-pane"));
                        var e = document.createElement("div");
                        (0, s.addClasses)(e, this._buildClasses("zoom-pane-loader")), this.el.appendChild(e), 
                        this.imgEl = document.createElement("img"), this.el.appendChild(this.imgEl);
                    }
                }, {
                    key: "_setImageURL",
                    value: function(e) {
                        this.imgEl.setAttribute("src", e);
                    }
                }, {
                    key: "_setImageSize",
                    value: function(e, t) {
                        this.imgEl.style.width = e * this.settings.zoomFactor + "px", this.imgEl.style.height = t * this.settings.zoomFactor + "px";
                    }
                }, {
                    key: "setPosition",
                    value: function(e, t, i) {
                        var n = -(this.imgEl.clientWidth * e - this.el.clientWidth / 2), o = -(this.imgEl.clientHeight * t - this.el.clientHeight / 2), s = -(this.imgEl.clientWidth - this.el.clientWidth), a = -(this.imgEl.clientHeight - this.el.clientHeight);
                        if (this.el.parentElement === this.settings.inlineContainer) {
                            var r = window.pageXOffset, l = window.pageYOffset, c = i.left + e * i.width - this.el.clientWidth / 2 + this.settings.inlineOffsetX + r, u = i.top + t * i.height - this.el.clientHeight / 2 + this.settings.inlineOffsetY + l;
                            this.settings.containInline && (this.el.getBoundingClientRect(), c < i.left + r ? c = i.left + r : c + this.el.clientWidth > i.left + i.width + r && (c = i.left + i.width - this.el.clientWidth + r), 
                            u < i.top + l ? u = i.top + l : u + this.el.clientHeight > i.top + i.height + l && (u = i.top + i.height - this.el.clientHeight + l)), 
                            this.el.style.left = c + "px", this.el.style.top = u + "px";
                        }
                        this.settings.showWhitespaceAtEdges || (n > 0 ? n = 0 : n < s && (n = s), o > 0 ? o = 0 : o < a && (o = a)), 
                        this.imgEl.style.transform = "translate(" + n + "px, " + o + "px)", this.imgEl.style.webkitTransform = "translate(" + n + "px, " + o + "px)";
                    }
                }, {
                    key: "_removeListenersAndResetClasses",
                    value: function() {
                        this.el.removeEventListener("animationend", this._completeShow, !1), this.el.removeEventListener("animationend", this._completeHide, !1), 
                        this.el.removeEventListener("webkitAnimationEnd", this._completeShow, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeHide, !1), 
                        (0, s.removeClasses)(this.el, this.openClasses), (0, s.removeClasses)(this.el, this.closingClasses);
                    }
                }, {
                    key: "show",
                    value: function(e, t, i) {
                        this._removeListenersAndResetClasses(), this.isShowing = !0, (0, s.addClasses)(this.el, this.openClasses), 
                        (0, s.addClasses)(this.el, this.loadingClasses), this.imgEl.addEventListener("load", this._handleLoad, !1), 
                        this._setImageURL(e), this._setImageSize(t, i), this._isInline ? this._showInline() : this._showInContainer(), 
                        r && (this.el.addEventListener("animationend", this._completeShow, !1), this.el.addEventListener("webkitAnimationEnd", this._completeShow, !1), 
                        (0, s.addClasses)(this.el, this.openingClasses));
                    }
                }, {
                    key: "_showInline",
                    value: function() {
                        this.settings.inlineContainer.appendChild(this.el), (0, s.addClasses)(this.el, this.inlineClasses);
                    }
                }, {
                    key: "_showInContainer",
                    value: function() {
                        this.settings.container.appendChild(this.el);
                    }
                }, {
                    key: "hide",
                    value: function() {
                        this._removeListenersAndResetClasses(), this.isShowing = !1, r ? (this.el.addEventListener("animationend", this._completeHide, !1), 
                        this.el.addEventListener("webkitAnimationEnd", this._completeHide, !1), (0, s.addClasses)(this.el, this.closingClasses)) : ((0, 
                        s.removeClasses)(this.el, this.openClasses), (0, s.removeClasses)(this.el, this.inlineClasses));
                    }
                }, {
                    key: "_isInline",
                    get: function() {
                        var e = this.settings.inline;
                        return !0 === e || "number" == typeof e && window.innerWidth <= e;
                    }
                } ]), e;
            }();
            i.default = l;
        }, {
            "./util/dom": 6,
            "./util/throwIfMissing": 7
        } ],
        5: [ function(e, t, i) {
            "use strict";
            Object.defineProperty(i, "__esModule", {
                value: !0
            }), i.default = function() {
                if (!document.querySelector(".drift-base-styles")) {
                    var e = document.createElement("style");
                    e.type = "text/css", e.classList.add("drift-base-styles"), e.appendChild(document.createTextNode(n));
                    var t = document.head;
                    t.insertBefore(e, t.firstChild);
                }
            };
            var n = "\n@keyframes noop {\n  0% { zoom: 1; }\n}\n\n@-webkit-keyframes noop {\n  0% { zoom: 1; }\n}\n\n.drift-zoom-pane.drift-open {\n  display: block;\n}\n\n.drift-zoom-pane.drift-opening, .drift-zoom-pane.drift-closing {\n  animation: noop 1ms;\n  -webkit-animation: noop 1ms;\n}\n\n.drift-zoom-pane {\n  position: absolute;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n\n.drift-zoom-pane-loader {\n  display: none;\n}\n\n.drift-zoom-pane img {\n  position: absolute;\n  display: block;\n  max-width: none;\n  max-height: none;\n}\n\n.drift-bounding-box {\n  position: absolute;\n  pointer-events: none;\n}\n";
        }, {} ],
        6: [ function(e, t, i) {
            "use strict";
            var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            };
            Object.defineProperty(i, "__esModule", {
                value: !0
            });
            var o = "function" == typeof Symbol && "symbol" === n(Symbol.iterator) ? function(e) {
                return void 0 === e ? "undefined" : n(e);
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : void 0 === e ? "undefined" : n(e);
            };
            i.isDOMElement = function(e) {
                return s ? e instanceof HTMLElement : e && "object" === (void 0 === e ? "undefined" : o(e)) && null !== e && 1 === e.nodeType && "string" == typeof e.nodeName;
            }, i.addClasses = function(e, t) {
                t.forEach(function(t) {
                    e.classList.add(t);
                });
            }, i.removeClasses = function(e, t) {
                t.forEach(function(t) {
                    e.classList.remove(t);
                });
            };
            var s = "object" === ("undefined" == typeof HTMLElement ? "undefined" : o(HTMLElement));
        }, {} ],
        7: [ function(e, t, i) {
            "use strict";
            Object.defineProperty(i, "__esModule", {
                value: !0
            }), i.default = function() {
                throw new Error("Missing parameter");
            };
        }, {} ]
    }, {}, [ 2 ])(2);
}), function(e) {
    "use strict";
    function t() {
        var t = this;
        t.reads = [], t.writes = [], t.raf = a.bind(e), s("initialized", t);
    }
    function i(e) {
        e.scheduled || (e.scheduled = !0, e.raf(function(e) {
            s("flush");
            var t, o = e.writes, a = e.reads;
            try {
                s("flushing reads", a.length), n(a), s("flushing writes", o.length), n(o);
            } catch (e) {
                t = e;
            }
            if (e.scheduled = !1, (a.length || o.length) && i(e), t) {
                if (s("task errored", t.message), !e.catch) throw t;
                e.catch(t);
            }
        }.bind(null, e)), s("flush scheduled"));
    }
    function n(e) {
        s("run tasks");
        for (var t; t = e.shift(); ) t();
    }
    function o(e, t) {
        var i = e.indexOf(t);
        return !!~i && !!e.splice(i, 1);
    }
    var s = function() {}, a = e.requestAnimationFrame || e.webkitRequestAnimationFrame || e.mozRequestAnimationFrame || e.msRequestAnimationFrame || function(e) {
        return setTimeout(e, 16);
    };
    t.prototype = {
        constructor: t,
        measure: function(e, t) {
            s("measure");
            var n = t ? e.bind(t) : e;
            return this.reads.push(n), i(this), n;
        },
        mutate: function(e, t) {
            s("mutate");
            var n = t ? e.bind(t) : e;
            return this.writes.push(n), i(this), n;
        },
        clear: function(e) {
            return s("clear", e), o(this.reads, e) || o(this.writes, e);
        },
        extend: function(e) {
            if (s("extend", e), "object" != typeof e) throw new Error("expected object");
            var t = Object.create(this);
            return function(e, t) {
                for (var i in t) t.hasOwnProperty(i) && (e[i] = t[i]);
            }(t, e), t.fastdom = this, t.initialize && t.initialize(), t;
        },
        "catch": null
    };
    var r = e.fastdom = e.fastdom || new t();
    "function" == typeof define ? define(function() {
        return r;
    }) : "object" == typeof module && (module.exports = r);
}("undefined" != typeof window ? window : this), function(e, t) {
    "function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", [ "jquery" ], function(i) {
        return t(e, i);
    }) : "object" == typeof module && module.exports ? module.exports = t(e, require("jquery")) : e.jQueryBridget = t(e, e.jQuery);
}(window, function(e, t) {
    "use strict";
    function i(i, s, r) {
        (r = r || t || e.jQuery) && (s.prototype.option || (s.prototype.option = function(e) {
            r.isPlainObject(e) && (this.options = r.extend(!0, this.options, e));
        }), r.fn[i] = function(e) {
            return "string" == typeof e ? function(e, t, n) {
                var o, s = "$()." + i + '("' + t + '")';
                return e.each(function(e, l) {
                    var c = r.data(l, i);
                    if (c) {
                        var u = c[t];
                        if (u && "_" != t.charAt(0)) {
                            var h = u.apply(c, n);
                            o = void 0 === o ? h : o;
                        } else a(s + " is not a valid method");
                    } else a(i + " not initialized. Cannot call methods, i.e. " + s);
                }), void 0 !== o ? o : e;
            }(this, e, o.call(arguments, 1)) : (function(e, t) {
                e.each(function(e, n) {
                    var o = r.data(n, i);
                    o ? (o.option(t), o._init()) : (o = new s(n, t), r.data(n, i, o));
                });
            }(this, e), this);
        }, n(r));
    }
    function n(e) {
        !e || e && e.bridget || (e.bridget = i);
    }
    var o = Array.prototype.slice, s = e.console, a = void 0 === s ? function() {} : function(e) {
        s.error(e);
    };
    return n(t || e.jQuery), i;
}), function(e, t) {
    "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", t) : "object" == typeof module && module.exports ? module.exports = t() : e.EvEmitter = t();
}("undefined" != typeof window ? window : this, function() {
    function e() {}
    var t = e.prototype;
    return t.on = function(e, t) {
        if (e && t) {
            var i = this._events = this._events || {}, n = i[e] = i[e] || [];
            return -1 == n.indexOf(t) && n.push(t), this;
        }
    }, t.once = function(e, t) {
        if (e && t) {
            this.on(e, t);
            var i = this._onceEvents = this._onceEvents || {};
            return (i[e] = i[e] || {})[t] = !0, this;
        }
    }, t.off = function(e, t) {
        var i = this._events && this._events[e];
        if (i && i.length) {
            var n = i.indexOf(t);
            return -1 != n && i.splice(n, 1), this;
        }
    }, t.emitEvent = function(e, t) {
        var i = this._events && this._events[e];
        if (i && i.length) {
            i = i.slice(0), t = t || [];
            for (var n = this._onceEvents && this._onceEvents[e], o = 0; o < i.length; o++) {
                var s = i[o];
                n && n[s] && (this.off(e, s), delete n[s]), s.apply(this, t);
            }
            return this;
        }
    }, t.allOff = function() {
        delete this._events, delete this._onceEvents;
    }, e;
}), function(e, t) {
    "function" == typeof define && define.amd ? define("get-size/get-size", t) : "object" == typeof module && module.exports ? module.exports = t() : e.getSize = t();
}(window, function() {
    "use strict";
    function e(e) {
        var t = parseFloat(e);
        return -1 == e.indexOf("%") && !isNaN(t) && t;
    }
    function t(e) {
        var t = getComputedStyle(e);
        return t || s("Style returned " + t + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), 
        t;
    }
    function i() {
        if (!l) {
            l = !0;
            var i = document.createElement("div");
            i.style.width = "200px", i.style.padding = "1px 2px 3px 4px", i.style.borderStyle = "solid", 
            i.style.borderWidth = "1px 2px 3px 4px", i.style.boxSizing = "border-box";
            var s = document.body || document.documentElement;
            s.appendChild(i);
            var a = t(i);
            o = 200 == Math.round(e(a.width)), n.isBoxSizeOuter = o, s.removeChild(i);
        }
    }
    function n(n) {
        if (i(), "string" == typeof n && (n = document.querySelector(n)), n && "object" == typeof n && n.nodeType) {
            var s = t(n);
            if ("none" == s.display) return function() {
                for (var e = {
                    width: 0,
                    height: 0,
                    innerWidth: 0,
                    innerHeight: 0,
                    outerWidth: 0,
                    outerHeight: 0
                }, t = 0; t < r; t++) e[a[t]] = 0;
                return e;
            }();
            var l = {};
            l.width = n.offsetWidth, l.height = n.offsetHeight;
            for (var c = l.isBorderBox = "border-box" == s.boxSizing, u = 0; u < r; u++) {
                var h = a[u], d = s[h], m = parseFloat(d);
                l[h] = isNaN(m) ? 0 : m;
            }
            var p = l.paddingLeft + l.paddingRight, f = l.paddingTop + l.paddingBottom, g = l.marginLeft + l.marginRight, v = l.marginTop + l.marginBottom, y = l.borderLeftWidth + l.borderRightWidth, _ = l.borderTopWidth + l.borderBottomWidth, w = c && o, b = e(s.width);
            !1 !== b && (l.width = b + (w ? 0 : p + y));
            var C = e(s.height);
            return !1 !== C && (l.height = C + (w ? 0 : f + _)), l.innerWidth = l.width - (p + y), 
            l.innerHeight = l.height - (f + _), l.outerWidth = l.width + g, l.outerHeight = l.height + v, 
            l;
        }
    }
    var o, s = "undefined" == typeof console ? function() {} : function(e) {
        console.error(e);
    }, a = [ "paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth" ], r = a.length, l = !1;
    return n;
}), function(e, t) {
    "use strict";
    "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", t) : "object" == typeof module && module.exports ? module.exports = t() : e.matchesSelector = t();
}(window, function() {
    "use strict";
    var e = function() {
        var e = window.Element.prototype;
        if (e.matches) return "matches";
        if (e.matchesSelector) return "matchesSelector";
        for (var t = [ "webkit", "moz", "ms", "o" ], i = 0; i < t.length; i++) {
            var n = t[i] + "MatchesSelector";
            if (e[n]) return n;
        }
    }();
    return function(t, i) {
        return t[e](i);
    };
}), function(e, t) {
    "function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", [ "desandro-matches-selector/matches-selector" ], function(i) {
        return t(e, i);
    }) : "object" == typeof module && module.exports ? module.exports = t(e, require("desandro-matches-selector")) : e.fizzyUIUtils = t(e, e.matchesSelector);
}(window, function(e, t) {
    var i = {
        extend: function(e, t) {
            for (var i in t) e[i] = t[i];
            return e;
        },
        modulo: function(e, t) {
            return (e % t + t) % t;
        }
    }, n = Array.prototype.slice;
    i.makeArray = function(e) {
        return Array.isArray(e) ? e : null == e ? [] : "object" == typeof e && "number" == typeof e.length ? n.call(e) : [ e ];
    }, i.removeFrom = function(e, t) {
        var i = e.indexOf(t);
        -1 != i && e.splice(i, 1);
    }, i.getParent = function(e, i) {
        for (;e.parentNode && e != document.body; ) if (e = e.parentNode, t(e, i)) return e;
    }, i.getQueryElement = function(e) {
        return "string" == typeof e ? document.querySelector(e) : e;
    }, i.handleEvent = function(e) {
        var t = "on" + e.type;
        this[t] && this[t](e);
    }, i.filterFindElements = function(e, n) {
        e = i.makeArray(e);
        var o = [];
        return e.forEach(function(e) {
            if (e instanceof HTMLElement) {
                if (!n) return void o.push(e);
                t(e, n) && o.push(e);
                for (var i = e.querySelectorAll(n), s = 0; s < i.length; s++) o.push(i[s]);
            }
        }), o;
    }, i.debounceMethod = function(e, t, i) {
        i = i || 100;
        var n = e.prototype[t], o = t + "Timeout";
        e.prototype[t] = function() {
            var e = this[o];
            clearTimeout(e);
            var t = arguments, s = this;
            this[o] = setTimeout(function() {
                n.apply(s, t), delete s[o];
            }, i);
        };
    }, i.docReady = function(e) {
        var t = document.readyState;
        "complete" == t || "interactive" == t ? setTimeout(e) : document.addEventListener("DOMContentLoaded", e);
    }, i.toDashed = function(e) {
        return e.replace(/(.)([A-Z])/g, function(e, t, i) {
            return t + "-" + i;
        }).toLowerCase();
    };
    var o = e.console;
    return i.htmlInit = function(t, n) {
        i.docReady(function() {
            var s = i.toDashed(n), a = "data-" + s, r = document.querySelectorAll("[" + a + "]"), l = document.querySelectorAll(".js-" + s), c = i.makeArray(r).concat(i.makeArray(l)), u = a + "-options", h = e.jQuery;
            c.forEach(function(e) {
                var i, s = e.getAttribute(a) || e.getAttribute(u);
                try {
                    i = s && JSON.parse(s);
                } catch (t) {
                    return void (o && o.error("Error parsing " + a + " on " + e.className + ": " + t));
                }
                var r = new t(e, i);
                h && h.data(e, n, r);
            });
        });
    }, i;
}), function(e, t) {
    "function" == typeof define && define.amd ? define("flickity/js/cell", [ "get-size/get-size" ], function(i) {
        return t(e, i);
    }) : "object" == typeof module && module.exports ? module.exports = t(e, require("get-size")) : (e.Flickity = e.Flickity || {}, 
    e.Flickity.Cell = t(e, e.getSize));
}(window, function(e, t) {
    function i(e, t) {
        this.element = e, this.parent = t, this.create();
    }
    var n = i.prototype;
    return n.create = function() {
        this.element.style.position = "absolute", this.element.setAttribute("aria-hidden", "true"), 
        this.x = 0, this.shift = 0;
    }, n.destroy = function() {
        this.unselect(), this.element.style.position = "";
        var e = this.parent.originSide;
        this.element.style[e] = "";
    }, n.getSize = function() {
        this.size = t(this.element);
    }, n.setPosition = function(e) {
        this.x = e, this.updateTarget(), this.renderPosition(e);
    }, n.updateTarget = n.setDefaultTarget = function() {
        var e = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
        this.target = this.x + this.size[e] + this.size.width * this.parent.cellAlign;
    }, n.renderPosition = function(e) {
        var t = this.parent.originSide;
        this.element.style[t] = this.parent.getPositionValue(e);
    }, n.select = function() {
        this.element.classList.add("is-selected"), this.element.removeAttribute("aria-hidden");
    }, n.unselect = function() {
        this.element.classList.remove("is-selected"), this.element.setAttribute("aria-hidden", "true");
    }, n.wrapShift = function(e) {
        this.shift = e, this.renderPosition(this.x + this.parent.slideableWidth * e);
    }, n.remove = function() {
        this.element.parentNode.removeChild(this.element);
    }, i;
}), function(e, t) {
    "function" == typeof define && define.amd ? define("flickity/js/slide", t) : "object" == typeof module && module.exports ? module.exports = t() : (e.Flickity = e.Flickity || {}, 
    e.Flickity.Slide = t());
}(window, function() {
    "use strict";
    function e(e) {
        this.parent = e, this.isOriginLeft = "left" == e.originSide, this.cells = [], this.outerWidth = 0, 
        this.height = 0;
    }
    var t = e.prototype;
    return t.addCell = function(e) {
        if (this.cells.push(e), this.outerWidth += e.size.outerWidth, this.height = Math.max(e.size.outerHeight, this.height), 
        1 == this.cells.length) {
            this.x = e.x;
            var t = this.isOriginLeft ? "marginLeft" : "marginRight";
            this.firstMargin = e.size[t];
        }
    }, t.updateTarget = function() {
        var e = this.isOriginLeft ? "marginRight" : "marginLeft", t = this.getLastCell(), i = t ? t.size[e] : 0, n = this.outerWidth - (this.firstMargin + i);
        this.target = this.x + this.firstMargin + n * this.parent.cellAlign;
    }, t.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    }, t.select = function() {
        this.cells.forEach(function(e) {
            e.select();
        });
    }, t.unselect = function() {
        this.cells.forEach(function(e) {
            e.unselect();
        });
    }, t.getCellElements = function() {
        return this.cells.map(function(e) {
            return e.element;
        });
    }, e;
}), function(e, t) {
    "function" == typeof define && define.amd ? define("flickity/js/animate", [ "fizzy-ui-utils/utils" ], function(i) {
        return t(e, i);
    }) : "object" == typeof module && module.exports ? module.exports = t(e, require("fizzy-ui-utils")) : (e.Flickity = e.Flickity || {}, 
    e.Flickity.animatePrototype = t(e, e.fizzyUIUtils));
}(window, function(e, t) {
    var i = {
        startAnimation: function() {
            this.isAnimating || (this.isAnimating = !0, this.restingFrames = 0, this.animate());
        },
        animate: function() {
            this.applyDragForce(), this.applySelectedAttraction();
            var e = this.x;
            if (this.integratePhysics(), this.positionSlider(), this.settle(e), this.isAnimating) {
                var t = this;
                requestAnimationFrame(function() {
                    t.animate();
                });
            }
        },
        positionSlider: function() {
            var e = this.x;
            this.options.wrapAround && this.cells.length > 1 && (e = t.modulo(e, this.slideableWidth), 
            e -= this.slideableWidth, this.shiftWrapCells(e)), this.setTranslateX(e, this.isAnimating), 
            this.dispatchScrollEvent();
        },
        setTranslateX: function(e, t) {
            e += this.cursorPosition, e = this.options.rightToLeft ? -e : e;
            var i = this.getPositionValue(e);
            this.slider.style.transform = t ? "translate3d(" + i + ",0,0)" : "translateX(" + i + ")";
        },
        dispatchScrollEvent: function() {
            var e = this.slides[0];
            if (e) {
                var t = -this.x - e.target, i = t / this.slidesWidth;
                this.dispatchEvent("scroll", null, [ i, t ]);
            }
        },
        positionSliderAtSelected: function() {
            this.cells.length && (this.x = -this.selectedSlide.target, this.velocity = 0, this.positionSlider());
        },
        getPositionValue: function(e) {
            return this.options.percentPosition ? .01 * Math.round(e / this.size.innerWidth * 1e4) + "%" : Math.round(e) + "px";
        },
        settle: function(e) {
            this.isPointerDown || Math.round(100 * this.x) != Math.round(100 * e) || this.restingFrames++, 
            this.restingFrames > 2 && (this.isAnimating = !1, delete this.isFreeScrolling, this.positionSlider(), 
            this.dispatchEvent("settle", null, [ this.selectedIndex ]));
        },
        shiftWrapCells: function(e) {
            var t = this.cursorPosition + e;
            this._shiftCells(this.beforeShiftCells, t, -1);
            var i = this.size.innerWidth - (e + this.slideableWidth + this.cursorPosition);
            this._shiftCells(this.afterShiftCells, i, 1);
        },
        _shiftCells: function(e, t, i) {
            for (var n = 0; n < e.length; n++) {
                var o = e[n], s = t > 0 ? i : 0;
                o.wrapShift(s), t -= o.size.outerWidth;
            }
        },
        _unshiftCells: function(e) {
            if (e && e.length) for (var t = 0; t < e.length; t++) e[t].wrapShift(0);
        },
        integratePhysics: function() {
            this.x += this.velocity, this.velocity *= this.getFrictionFactor();
        },
        applyForce: function(e) {
            this.velocity += e;
        },
        getFrictionFactor: function() {
            return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
        },
        getRestingPosition: function() {
            return this.x + this.velocity / (1 - this.getFrictionFactor());
        },
        applyDragForce: function() {
            if (this.isDraggable && this.isPointerDown) {
                var e = this.dragX - this.x - this.velocity;
                this.applyForce(e);
            }
        },
        applySelectedAttraction: function() {
            if (!(this.isDraggable && this.isPointerDown) && !this.isFreeScrolling && this.slides.length) {
                var e = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction;
                this.applyForce(e);
            }
        }
    };
    return i;
}), function(e, t) {
    if ("function" == typeof define && define.amd) define("flickity/js/flickity", [ "ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./slide", "./animate" ], function(i, n, o, s, a, r) {
        return t(e, i, n, o, s, a, r);
    }); else if ("object" == typeof module && module.exports) module.exports = t(e, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./slide"), require("./animate")); else {
        var i = e.Flickity;
        e.Flickity = t(e, e.EvEmitter, e.getSize, e.fizzyUIUtils, i.Cell, i.Slide, i.animatePrototype);
    }
}(window, function(e, t, i, n, o, s, a) {
    function r(e, t) {
        for (e = n.makeArray(e); e.length; ) t.appendChild(e.shift());
    }
    function l(e, t) {
        var i = n.getQueryElement(e);
        if (i) {
            if (this.element = i, this.element.flickityGUID) {
                var o = m[this.element.flickityGUID];
                return o.option(t), o;
            }
            c && (this.$element = c(this.element)), this.options = n.extend({}, this.constructor.defaults), 
            this.option(t), this._create();
        } else h && h.error("Bad element for Flickity: " + (i || e));
    }
    var c = e.jQuery, u = e.getComputedStyle, h = e.console, d = 0, m = {};
    l.defaults = {
        accessibility: !0,
        cellAlign: "center",
        freeScrollFriction: .075,
        friction: .28,
        namespaceJQueryEvents: !0,
        percentPosition: !0,
        resize: !0,
        selectedAttraction: .025,
        setGallerySize: !0
    }, l.createMethods = [];
    var p = l.prototype;
    n.extend(p, t.prototype), p._create = function() {
        var t = this.guid = ++d;
        for (var i in this.element.flickityGUID = t, m[t] = this, this.selectedIndex = 0, 
        this.restingFrames = 0, this.x = 0, this.velocity = 0, this.originSide = this.options.rightToLeft ? "right" : "left", 
        this.viewport = document.createElement("div"), this.viewport.className = "flickity-viewport", 
        this._createSlider(), (this.options.resize || this.options.watchCSS) && e.addEventListener("resize", this), 
        this.options.on) {
            var n = this.options.on[i];
            this.on(i, n);
        }
        l.createMethods.forEach(function(e) {
            this[e]();
        }, this), this.options.watchCSS ? this.watchCSS() : this.activate();
    }, p.option = function(e) {
        n.extend(this.options, e);
    }, p.activate = function() {
        this.isActive || (this.isActive = !0, this.element.classList.add("flickity-enabled"), 
        this.options.rightToLeft && this.element.classList.add("flickity-rtl"), this.getSize(), 
        r(this._filterFindCellElements(this.element.children), this.slider), this.viewport.appendChild(this.slider), 
        this.element.appendChild(this.viewport), this.reloadCells(), this.options.accessibility && (this.element.tabIndex = 0, 
        this.element.addEventListener("keydown", this)), this.emitEvent("activate"), this.selectInitialIndex(), 
        this.isInitActivated = !0, this.dispatchEvent("ready"));
    }, p._createSlider = function() {
        var e = document.createElement("div");
        e.className = "flickity-slider", e.style[this.originSide] = 0, this.slider = e;
    }, p._filterFindCellElements = function(e) {
        return n.filterFindElements(e, this.options.cellSelector);
    }, p.reloadCells = function() {
        this.cells = this._makeCells(this.slider.children), this.positionCells(), this._getWrapShiftCells(), 
        this.setGallerySize();
    }, p._makeCells = function(e) {
        return this._filterFindCellElements(e).map(function(e) {
            return new o(e, this);
        }, this);
    }, p.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    }, p.getLastSlide = function() {
        return this.slides[this.slides.length - 1];
    }, p.positionCells = function() {
        this._sizeCells(this.cells), this._positionCells(0);
    }, p._positionCells = function(e) {
        e = e || 0, this.maxCellHeight = e && this.maxCellHeight || 0;
        var t = 0;
        if (e > 0) {
            var i = this.cells[e - 1];
            t = i.x + i.size.outerWidth;
        }
        for (var n = this.cells.length, o = e; o < n; o++) {
            var s = this.cells[o];
            s.setPosition(t), t += s.size.outerWidth, this.maxCellHeight = Math.max(s.size.outerHeight, this.maxCellHeight);
        }
        this.slideableWidth = t, this.updateSlides(), this._containSlides(), this.slidesWidth = n ? this.getLastSlide().target - this.slides[0].target : 0;
    }, p._sizeCells = function(e) {
        e.forEach(function(e) {
            e.getSize();
        });
    }, p.updateSlides = function() {
        if (this.slides = [], this.cells.length) {
            var e = new s(this);
            this.slides.push(e);
            var t = "left" == this.originSide ? "marginRight" : "marginLeft", i = this._getCanCellFit();
            this.cells.forEach(function(n, o) {
                if (e.cells.length) {
                    var a = e.outerWidth - e.firstMargin + (n.size.outerWidth - n.size[t]);
                    i.call(this, o, a) ? e.addCell(n) : (e.updateTarget(), e = new s(this), this.slides.push(e), 
                    e.addCell(n));
                } else e.addCell(n);
            }, this), e.updateTarget(), this.updateSelectedSlide();
        }
    }, p._getCanCellFit = function() {
        var e = this.options.groupCells;
        if (!e) return function() {
            return !1;
        };
        if ("number" == typeof e) {
            var t = parseInt(e, 10);
            return function(e) {
                return e % t != 0;
            };
        }
        var i = "string" == typeof e && e.match(/^(\d+)%$/), n = i ? parseInt(i[1], 10) / 100 : 1;
        return function(e, t) {
            return t <= (this.size.innerWidth + 1) * n;
        };
    }, p._init = p.reposition = function() {
        this.positionCells(), this.positionSliderAtSelected();
    }, p.getSize = function() {
        this.size = i(this.element), this.setCellAlign(), this.cursorPosition = this.size.innerWidth * this.cellAlign;
    };
    var f = {
        center: {
            left: .5,
            right: .5
        },
        left: {
            left: 0,
            right: 1
        },
        right: {
            right: 0,
            left: 1
        }
    };
    return p.setCellAlign = function() {
        var e = f[this.options.cellAlign];
        this.cellAlign = e ? e[this.originSide] : this.options.cellAlign;
    }, p.setGallerySize = function() {
        if (this.options.setGallerySize) {
            var e = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
            this.viewport.style.height = e + "px";
        }
    }, p._getWrapShiftCells = function() {
        if (this.options.wrapAround) {
            this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
            var e = this.cursorPosition, t = this.cells.length - 1;
            this.beforeShiftCells = this._getGapCells(e, t, -1), e = this.size.innerWidth - this.cursorPosition, 
            this.afterShiftCells = this._getGapCells(e, 0, 1);
        }
    }, p._getGapCells = function(e, t, i) {
        for (var n = []; e > 0; ) {
            var o = this.cells[t];
            if (!o) break;
            n.push(o), t += i, e -= o.size.outerWidth;
        }
        return n;
    }, p._containSlides = function() {
        if (this.options.contain && !this.options.wrapAround && this.cells.length) {
            var e = this.options.rightToLeft, t = e ? "marginRight" : "marginLeft", i = e ? "marginLeft" : "marginRight", n = this.slideableWidth - this.getLastCell().size[i], o = n < this.size.innerWidth, s = this.cursorPosition + this.cells[0].size[t], a = n - this.size.innerWidth * (1 - this.cellAlign);
            this.slides.forEach(function(e) {
                o ? e.target = n * this.cellAlign : (e.target = Math.max(e.target, s), e.target = Math.min(e.target, a));
            }, this);
        }
    }, p.dispatchEvent = function(e, t, i) {
        var n = t ? [ t ].concat(i) : i;
        if (this.emitEvent(e, n), c && this.$element) {
            var o = e += this.options.namespaceJQueryEvents ? ".flickity" : "";
            if (t) {
                var s = c.Event(t);
                s.type = e, o = s;
            }
            this.$element.trigger(o, i);
        }
    }, p.select = function(e, t, i) {
        if (this.isActive && (e = parseInt(e, 10), this._wrapSelect(e), (this.options.wrapAround || t) && (e = n.modulo(e, this.slides.length)), 
        this.slides[e])) {
            var o = this.selectedIndex;
            this.selectedIndex = e, this.updateSelectedSlide(), i ? this.positionSliderAtSelected() : this.startAnimation(), 
            this.options.adaptiveHeight && this.setGallerySize(), this.dispatchEvent("select", null, [ e ]), 
            e != o && this.dispatchEvent("change", null, [ e ]), this.dispatchEvent("cellSelect");
        }
    }, p._wrapSelect = function(e) {
        var t = this.slides.length;
        if (!(this.options.wrapAround && t > 1)) return e;
        var i = n.modulo(e, t), o = Math.abs(i - this.selectedIndex), s = Math.abs(i + t - this.selectedIndex), a = Math.abs(i - t - this.selectedIndex);
        !this.isDragSelect && s < o ? e += t : !this.isDragSelect && a < o && (e -= t), 
        e < 0 ? this.x -= this.slideableWidth : e >= t && (this.x += this.slideableWidth);
    }, p.previous = function(e, t) {
        this.select(this.selectedIndex - 1, e, t);
    }, p.next = function(e, t) {
        this.select(this.selectedIndex + 1, e, t);
    }, p.updateSelectedSlide = function() {
        var e = this.slides[this.selectedIndex];
        e && (this.unselectSelectedSlide(), this.selectedSlide = e, e.select(), this.selectedCells = e.cells, 
        this.selectedElements = e.getCellElements(), this.selectedCell = e.cells[0], this.selectedElement = this.selectedElements[0]);
    }, p.unselectSelectedSlide = function() {
        this.selectedSlide && this.selectedSlide.unselect();
    }, p.selectInitialIndex = function() {
        var e = this.options.initialIndex;
        if (this.isInitActivated) this.select(this.selectedIndex, !1, !0); else {
            if (e && "string" == typeof e) if (this.queryCell(e)) return void this.selectCell(e, !1, !0);
            var t = 0;
            e && this.slides[e] && (t = e), this.select(t, !1, !0);
        }
    }, p.selectCell = function(e, t, i) {
        var n = this.queryCell(e);
        if (n) {
            var o = this.getCellSlideIndex(n);
            this.select(o, t, i);
        }
    }, p.getCellSlideIndex = function(e) {
        for (var t = 0; t < this.slides.length; t++) {
            if (-1 != this.slides[t].cells.indexOf(e)) return t;
        }
    }, p.getCell = function(e) {
        for (var t = 0; t < this.cells.length; t++) {
            var i = this.cells[t];
            if (i.element == e) return i;
        }
    }, p.getCells = function(e) {
        e = n.makeArray(e);
        var t = [];
        return e.forEach(function(e) {
            var i = this.getCell(e);
            i && t.push(i);
        }, this), t;
    }, p.getCellElements = function() {
        return this.cells.map(function(e) {
            return e.element;
        });
    }, p.getParentCell = function(e) {
        var t = this.getCell(e);
        return t || (e = n.getParent(e, ".flickity-slider > *"), this.getCell(e));
    }, p.getAdjacentCellElements = function(e, t) {
        if (!e) return this.selectedSlide.getCellElements();
        t = void 0 === t ? this.selectedIndex : t;
        var i = this.slides.length;
        if (1 + 2 * e >= i) return this.getCellElements();
        for (var o = [], s = t - e; s <= t + e; s++) {
            var a = this.options.wrapAround ? n.modulo(s, i) : s, r = this.slides[a];
            r && (o = o.concat(r.getCellElements()));
        }
        return o;
    }, p.queryCell = function(e) {
        if ("number" == typeof e) return this.cells[e];
        if ("string" == typeof e) {
            if (e.match(/^[#\.]?[\d\/]/)) return;
            e = this.element.querySelector(e);
        }
        return this.getCell(e);
    }, p.uiChange = function() {
        this.emitEvent("uiChange");
    }, p.childUIPointerDown = function(e) {
        "touchstart" != e.type && e.preventDefault(), this.focus();
    }, p.onresize = function() {
        this.watchCSS(), this.resize();
    }, n.debounceMethod(l, "onresize", 150), p.resize = function() {
        if (this.isActive) {
            this.getSize(), this.options.wrapAround && (this.x = n.modulo(this.x, this.slideableWidth)), 
            this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent("resize");
            var e = this.selectedElements && this.selectedElements[0];
            this.selectCell(e, !1, !0);
        }
    }, p.watchCSS = function() {
        this.options.watchCSS && (-1 != u(this.element, ":after").content.indexOf("flickity") ? this.activate() : this.deactivate());
    }, p.onkeydown = function(e) {
        var t = document.activeElement && document.activeElement != this.element;
        if (this.options.accessibility && !t) {
            var i = l.keyboardHandlers[e.keyCode];
            i && i.call(this);
        }
    }, l.keyboardHandlers = {
        37: function() {
            var e = this.options.rightToLeft ? "next" : "previous";
            this.uiChange(), this[e]();
        },
        39: function() {
            var e = this.options.rightToLeft ? "previous" : "next";
            this.uiChange(), this[e]();
        }
    }, p.focus = function() {
        var t = e.pageYOffset;
        this.element.focus({
            preventScroll: !0
        }), e.pageYOffset != t && e.scrollTo(e.pageXOffset, t);
    }, p.deactivate = function() {
        this.isActive && (this.element.classList.remove("flickity-enabled"), this.element.classList.remove("flickity-rtl"), 
        this.unselectSelectedSlide(), this.cells.forEach(function(e) {
            e.destroy();
        }), this.element.removeChild(this.viewport), r(this.slider.children, this.element), 
        this.options.accessibility && (this.element.removeAttribute("tabIndex"), this.element.removeEventListener("keydown", this)), 
        this.isActive = !1, this.emitEvent("deactivate"));
    }, p.destroy = function() {
        this.deactivate(), e.removeEventListener("resize", this), this.allOff(), this.emitEvent("destroy"), 
        c && this.$element && c.removeData(this.element, "flickity"), delete this.element.flickityGUID, 
        delete m[this.guid];
    }, n.extend(p, a), l.data = function(e) {
        var t = (e = n.getQueryElement(e)) && e.flickityGUID;
        return t && m[t];
    }, n.htmlInit(l, "flickity"), c && c.bridget && c.bridget("flickity", l), l.setJQuery = function(e) {
        c = e;
    }, l.Cell = o, l.Slide = s, l;
}), function(e, t) {
    "function" == typeof define && define.amd ? define("unipointer/unipointer", [ "ev-emitter/ev-emitter" ], function(i) {
        return t(e, i);
    }) : "object" == typeof module && module.exports ? module.exports = t(e, require("ev-emitter")) : e.Unipointer = t(e, e.EvEmitter);
}(window, function(e, t) {
    function i() {}
    var n = i.prototype = Object.create(t.prototype);
    n.bindStartEvent = function(e) {
        this._bindStartEvent(e, !0);
    }, n.unbindStartEvent = function(e) {
        this._bindStartEvent(e, !1);
    }, n._bindStartEvent = function(t, i) {
        var n = (i = void 0 === i || i) ? "addEventListener" : "removeEventListener", o = "mousedown";
        e.PointerEvent ? o = "pointerdown" : "ontouchstart" in e && (o = "touchstart"), 
        t[n](o, this);
    }, n.handleEvent = function(e) {
        var t = "on" + e.type;
        this[t] && this[t](e);
    }, n.getTouch = function(e) {
        for (var t = 0; t < e.length; t++) {
            var i = e[t];
            if (i.identifier == this.pointerIdentifier) return i;
        }
    }, n.onmousedown = function(e) {
        var t = e.button;
        t && 0 !== t && 1 !== t || this._pointerDown(e, e);
    }, n.ontouchstart = function(e) {
        this._pointerDown(e, e.changedTouches[0]);
    }, n.onpointerdown = function(e) {
        this._pointerDown(e, e);
    }, n._pointerDown = function(e, t) {
        e.button || this.isPointerDown || (this.isPointerDown = !0, this.pointerIdentifier = void 0 !== t.pointerId ? t.pointerId : t.identifier, 
        this.pointerDown(e, t));
    }, n.pointerDown = function(e, t) {
        this._bindPostStartEvents(e), this.emitEvent("pointerDown", [ e, t ]);
    };
    var o = {
        mousedown: [ "mousemove", "mouseup" ],
        touchstart: [ "touchmove", "touchend", "touchcancel" ],
        pointerdown: [ "pointermove", "pointerup", "pointercancel" ]
    };
    return n._bindPostStartEvents = function(t) {
        if (t) {
            var i = o[t.type];
            i.forEach(function(t) {
                e.addEventListener(t, this);
            }, this), this._boundPointerEvents = i;
        }
    }, n._unbindPostStartEvents = function() {
        this._boundPointerEvents && (this._boundPointerEvents.forEach(function(t) {
            e.removeEventListener(t, this);
        }, this), delete this._boundPointerEvents);
    }, n.onmousemove = function(e) {
        this._pointerMove(e, e);
    }, n.onpointermove = function(e) {
        e.pointerId == this.pointerIdentifier && this._pointerMove(e, e);
    }, n.ontouchmove = function(e) {
        var t = this.getTouch(e.changedTouches);
        t && this._pointerMove(e, t);
    }, n._pointerMove = function(e, t) {
        this.pointerMove(e, t);
    }, n.pointerMove = function(e, t) {
        this.emitEvent("pointerMove", [ e, t ]);
    }, n.onmouseup = function(e) {
        this._pointerUp(e, e);
    }, n.onpointerup = function(e) {
        e.pointerId == this.pointerIdentifier && this._pointerUp(e, e);
    }, n.ontouchend = function(e) {
        var t = this.getTouch(e.changedTouches);
        t && this._pointerUp(e, t);
    }, n._pointerUp = function(e, t) {
        this._pointerDone(), this.pointerUp(e, t);
    }, n.pointerUp = function(e, t) {
        this.emitEvent("pointerUp", [ e, t ]);
    }, n._pointerDone = function() {
        this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone();
    }, n._pointerReset = function() {
        this.isPointerDown = !1, delete this.pointerIdentifier;
    }, n.pointerDone = function() {}, n.onpointercancel = function(e) {
        e.pointerId == this.pointerIdentifier && this._pointerCancel(e, e);
    }, n.ontouchcancel = function(e) {
        var t = this.getTouch(e.changedTouches);
        t && this._pointerCancel(e, t);
    }, n._pointerCancel = function(e, t) {
        this._pointerDone(), this.pointerCancel(e, t);
    }, n.pointerCancel = function(e, t) {
        this.emitEvent("pointerCancel", [ e, t ]);
    }, i.getPointerPoint = function(e) {
        return {
            x: e.pageX,
            y: e.pageY
        };
    }, i;
}), function(e, t) {
    "function" == typeof define && define.amd ? define("unidragger/unidragger", [ "unipointer/unipointer" ], function(i) {
        return t(e, i);
    }) : "object" == typeof module && module.exports ? module.exports = t(e, require("unipointer")) : e.Unidragger = t(e, e.Unipointer);
}(window, function(e, t) {
    function i() {}
    var n = i.prototype = Object.create(t.prototype);
    n.bindHandles = function() {
        this._bindHandles(!0);
    }, n.unbindHandles = function() {
        this._bindHandles(!1);
    }, n._bindHandles = function(t) {
        for (var i = (t = void 0 === t || t) ? "addEventListener" : "removeEventListener", n = t ? this._touchActionValue : "", o = 0; o < this.handles.length; o++) {
            var s = this.handles[o];
            this._bindStartEvent(s, t), s[i]("click", this), e.PointerEvent && (s.style.touchAction = n);
        }
    }, n._touchActionValue = "none", n.pointerDown = function(e, t) {
        this.okayPointerDown(e) && (this.pointerDownPointer = t, e.preventDefault(), this.pointerDownBlur(), 
        this._bindPostStartEvents(e), this.emitEvent("pointerDown", [ e, t ]));
    };
    var o = {
        TEXTAREA: !0,
        INPUT: !0,
        SELECT: !0,
        OPTION: !0
    }, s = {
        radio: !0,
        checkbox: !0,
        button: !0,
        submit: !0,
        image: !0,
        file: !0
    };
    return n.okayPointerDown = function(e) {
        var t = o[e.target.nodeName], i = s[e.target.type], n = !t || i;
        return n || this._pointerReset(), n;
    }, n.pointerDownBlur = function() {
        var e = document.activeElement;
        e && e.blur && e != document.body && e.blur();
    }, n.pointerMove = function(e, t) {
        var i = this._dragPointerMove(e, t);
        this.emitEvent("pointerMove", [ e, t, i ]), this._dragMove(e, t, i);
    }, n._dragPointerMove = function(e, t) {
        var i = {
            x: t.pageX - this.pointerDownPointer.pageX,
            y: t.pageY - this.pointerDownPointer.pageY
        };
        return !this.isDragging && this.hasDragStarted(i) && this._dragStart(e, t), i;
    }, n.hasDragStarted = function(e) {
        return Math.abs(e.x) > 3 || Math.abs(e.y) > 3;
    }, n.pointerUp = function(e, t) {
        this.emitEvent("pointerUp", [ e, t ]), this._dragPointerUp(e, t);
    }, n._dragPointerUp = function(e, t) {
        this.isDragging ? this._dragEnd(e, t) : this._staticClick(e, t);
    }, n._dragStart = function(e, t) {
        this.isDragging = !0, this.isPreventingClicks = !0, this.dragStart(e, t);
    }, n.dragStart = function(e, t) {
        this.emitEvent("dragStart", [ e, t ]);
    }, n._dragMove = function(e, t, i) {
        this.isDragging && this.dragMove(e, t, i);
    }, n.dragMove = function(e, t, i) {
        e.preventDefault(), this.emitEvent("dragMove", [ e, t, i ]);
    }, n._dragEnd = function(e, t) {
        this.isDragging = !1, setTimeout(function() {
            delete this.isPreventingClicks;
        }.bind(this)), this.dragEnd(e, t);
    }, n.dragEnd = function(e, t) {
        this.emitEvent("dragEnd", [ e, t ]);
    }, n.onclick = function(e) {
        this.isPreventingClicks && e.preventDefault();
    }, n._staticClick = function(e, t) {
        this.isIgnoringMouseUp && "mouseup" == e.type || (this.staticClick(e, t), "mouseup" != e.type && (this.isIgnoringMouseUp = !0, 
        setTimeout(function() {
            delete this.isIgnoringMouseUp;
        }.bind(this), 400)));
    }, n.staticClick = function(e, t) {
        this.emitEvent("staticClick", [ e, t ]);
    }, i.getPointerPoint = t.getPointerPoint, i;
}), function(e, t) {
    "function" == typeof define && define.amd ? define("flickity/js/drag", [ "./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils" ], function(i, n, o) {
        return t(e, i, n, o);
    }) : "object" == typeof module && module.exports ? module.exports = t(e, require("./flickity"), require("unidragger"), require("fizzy-ui-utils")) : e.Flickity = t(e, e.Flickity, e.Unidragger, e.fizzyUIUtils);
}(window, function(e, t, i, n) {
    function o() {
        return {
            x: e.pageXOffset,
            y: e.pageYOffset
        };
    }
    n.extend(t.defaults, {
        draggable: ">1",
        dragThreshold: 3
    }), t.createMethods.push("_createDrag");
    var s = t.prototype;
    n.extend(s, i.prototype), s._touchActionValue = "pan-y";
    var a = "createTouch" in document, r = !1;
    s._createDrag = function() {
        this.on("activate", this.onActivateDrag), this.on("uiChange", this._uiChangeDrag), 
        this.on("deactivate", this.onDeactivateDrag), this.on("cellChange", this.updateDraggable), 
        a && !r && (e.addEventListener("touchmove", function() {}), r = !0);
    }, s.onActivateDrag = function() {
        this.handles = [ this.viewport ], this.bindHandles(), this.updateDraggable();
    }, s.onDeactivateDrag = function() {
        this.unbindHandles(), this.element.classList.remove("is-draggable");
    }, s.updateDraggable = function() {
        ">1" == this.options.draggable ? this.isDraggable = this.slides.length > 1 : this.isDraggable = this.options.draggable, 
        this.isDraggable ? this.element.classList.add("is-draggable") : this.element.classList.remove("is-draggable");
    }, s.bindDrag = function() {
        this.options.draggable = !0, this.updateDraggable();
    }, s.unbindDrag = function() {
        this.options.draggable = !1, this.updateDraggable();
    }, s._uiChangeDrag = function() {
        delete this.isFreeScrolling;
    }, s.pointerDown = function(t, i) {
        this.isDraggable ? this.okayPointerDown(t) && (this._pointerDownPreventDefault(t), 
        this.pointerDownFocus(t), document.activeElement != this.element && this.pointerDownBlur(), 
        this.dragX = this.x, this.viewport.classList.add("is-pointer-down"), this.pointerDownScroll = o(), 
        e.addEventListener("scroll", this), this._pointerDownDefault(t, i)) : this._pointerDownDefault(t, i);
    }, s._pointerDownDefault = function(e, t) {
        this.pointerDownPointer = {
            pageX: t.pageX,
            pageY: t.pageY
        }, this._bindPostStartEvents(e), this.dispatchEvent("pointerDown", e, [ t ]);
    };
    var l = {
        INPUT: !0,
        TEXTAREA: !0,
        SELECT: !0
    };
    return s.pointerDownFocus = function(e) {
        l[e.target.nodeName] || this.focus();
    }, s._pointerDownPreventDefault = function(e) {
        var t = "touchstart" == e.type, i = "touch" == e.pointerType, n = l[e.target.nodeName];
        t || i || n || e.preventDefault();
    }, s.hasDragStarted = function(e) {
        return Math.abs(e.x) > this.options.dragThreshold;
    }, s.pointerUp = function(e, t) {
        delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down"), 
        this.dispatchEvent("pointerUp", e, [ t ]), this._dragPointerUp(e, t);
    }, s.pointerDone = function() {
        e.removeEventListener("scroll", this), delete this.pointerDownScroll;
    }, s.dragStart = function(t, i) {
        this.isDraggable && (this.dragStartPosition = this.x, this.startAnimation(), e.removeEventListener("scroll", this), 
        this.dispatchEvent("dragStart", t, [ i ]));
    }, s.pointerMove = function(e, t) {
        var i = this._dragPointerMove(e, t);
        this.dispatchEvent("pointerMove", e, [ t, i ]), this._dragMove(e, t, i);
    }, s.dragMove = function(e, t, i) {
        if (this.isDraggable) {
            e.preventDefault(), this.previousDragX = this.dragX;
            var n = this.options.rightToLeft ? -1 : 1;
            this.options.wrapAround && (i.x = i.x % this.slideableWidth);
            var o = this.dragStartPosition + i.x * n;
            if (!this.options.wrapAround && this.slides.length) {
                var s = Math.max(-this.slides[0].target, this.dragStartPosition);
                o = o > s ? .5 * (o + s) : o;
                var a = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                o = o < a ? .5 * (o + a) : o;
            }
            this.dragX = o, this.dragMoveTime = new Date(), this.dispatchEvent("dragMove", e, [ t, i ]);
        }
    }, s.dragEnd = function(e, t) {
        if (this.isDraggable) {
            this.options.freeScroll && (this.isFreeScrolling = !0);
            var i = this.dragEndRestingSelect();
            if (this.options.freeScroll && !this.options.wrapAround) {
                var n = this.getRestingPosition();
                this.isFreeScrolling = -n > this.slides[0].target && -n < this.getLastSlide().target;
            } else this.options.freeScroll || i != this.selectedIndex || (i += this.dragEndBoostSelect());
            delete this.previousDragX, this.isDragSelect = this.options.wrapAround, this.select(i), 
            delete this.isDragSelect, this.dispatchEvent("dragEnd", e, [ t ]);
        }
    }, s.dragEndRestingSelect = function() {
        var e = this.getRestingPosition(), t = Math.abs(this.getSlideDistance(-e, this.selectedIndex)), i = this._getClosestResting(e, t, 1), n = this._getClosestResting(e, t, -1);
        return i.distance < n.distance ? i.index : n.index;
    }, s._getClosestResting = function(e, t, i) {
        for (var n = this.selectedIndex, o = 1 / 0, s = this.options.contain && !this.options.wrapAround ? function(e, t) {
            return e <= t;
        } : function(e, t) {
            return e < t;
        }; s(t, o) && (n += i, o = t, null !== (t = this.getSlideDistance(-e, n))); ) t = Math.abs(t);
        return {
            distance: o,
            index: n - i
        };
    }, s.getSlideDistance = function(e, t) {
        var i = this.slides.length, o = this.options.wrapAround && i > 1, s = o ? n.modulo(t, i) : t, a = this.slides[s];
        if (!a) return null;
        var r = o ? this.slideableWidth * Math.floor(t / i) : 0;
        return e - (a.target + r);
    }, s.dragEndBoostSelect = function() {
        if (void 0 === this.previousDragX || !this.dragMoveTime || new Date() - this.dragMoveTime > 100) return 0;
        var e = this.getSlideDistance(-this.dragX, this.selectedIndex), t = this.previousDragX - this.dragX;
        return e > 0 && t > 0 ? 1 : e < 0 && t < 0 ? -1 : 0;
    }, s.staticClick = function(e, t) {
        var i = this.getParentCell(e.target), n = i && i.element, o = i && this.cells.indexOf(i);
        this.dispatchEvent("staticClick", e, [ t, n, o ]);
    }, s.onscroll = function() {
        var e = o(), t = this.pointerDownScroll.x - e.x, i = this.pointerDownScroll.y - e.y;
        (Math.abs(t) > 3 || Math.abs(i) > 3) && this._pointerDone();
    }, t;
}), function(e, t) {
    "function" == typeof define && define.amd ? define("flickity/js/prev-next-button", [ "./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils" ], function(i, n, o) {
        return t(e, i, n, o);
    }) : "object" == typeof module && module.exports ? module.exports = t(e, require("./flickity"), require("unipointer"), require("fizzy-ui-utils")) : t(e, e.Flickity, e.Unipointer, e.fizzyUIUtils);
}(window, function(e, t, i, n) {
    "use strict";
    function o(e, t) {
        this.direction = e, this.parent = t, this._create();
    }
    var s = "http://www.w3.org/2000/svg";
    o.prototype = Object.create(i.prototype), o.prototype._create = function() {
        this.isEnabled = !0, this.isPrevious = -1 == this.direction;
        var e = this.parent.options.rightToLeft ? 1 : -1;
        this.isLeft = this.direction == e;
        var t = this.element = document.createElement("button");
        t.className = "flickity-button flickity-prev-next-button", t.className += this.isPrevious ? " previous" : " next", 
        t.setAttribute("type", "button"), this.disable(), t.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
        var i = this.createSVG();
        t.appendChild(i), this.parent.on("select", this.update.bind(this)), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
    }, o.prototype.activate = function() {
        this.bindStartEvent(this.element), this.element.addEventListener("click", this), 
        this.parent.element.appendChild(this.element);
    }, o.prototype.deactivate = function() {
        this.parent.element.removeChild(this.element), this.unbindStartEvent(this.element), 
        this.element.removeEventListener("click", this);
    }, o.prototype.createSVG = function() {
        var e = document.createElementNS(s, "svg");
        e.setAttribute("class", "flickity-button-icon"), e.setAttribute("viewBox", "0 0 100 100");
        var t = document.createElementNS(s, "path"), i = function(e) {
            return "string" == typeof e ? e : "M " + e.x0 + ",50 L " + e.x1 + "," + (e.y1 + 50) + " L " + e.x2 + "," + (e.y2 + 50) + " L " + e.x3 + ",50  L " + e.x2 + "," + (50 - e.y2) + " L " + e.x1 + "," + (50 - e.y1) + " Z";
        }(this.parent.options.arrowShape);
        return t.setAttribute("d", i), t.setAttribute("class", "arrow"), this.isLeft || t.setAttribute("transform", "translate(100, 100) rotate(180) "), 
        e.appendChild(t), e;
    }, o.prototype.handleEvent = n.handleEvent, o.prototype.onclick = function() {
        if (this.isEnabled) {
            this.parent.uiChange();
            var e = this.isPrevious ? "previous" : "next";
            this.parent[e]();
        }
    }, o.prototype.enable = function() {
        this.isEnabled || (this.element.disabled = !1, this.isEnabled = !0);
    }, o.prototype.disable = function() {
        this.isEnabled && (this.element.disabled = !0, this.isEnabled = !1);
    }, o.prototype.update = function() {
        var e = this.parent.slides;
        if (this.parent.options.wrapAround && e.length > 1) this.enable(); else {
            var t = e.length ? e.length - 1 : 0, i = this.isPrevious ? 0 : t;
            this[this.parent.selectedIndex == i ? "disable" : "enable"]();
        }
    }, o.prototype.destroy = function() {
        this.deactivate(), this.allOff();
    }, n.extend(t.defaults, {
        prevNextButtons: !0,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
        }
    }), t.createMethods.push("_createPrevNextButtons");
    var a = t.prototype;
    return a._createPrevNextButtons = function() {
        this.options.prevNextButtons && (this.prevButton = new o(-1, this), this.nextButton = new o(1, this), 
        this.on("activate", this.activatePrevNextButtons));
    }, a.activatePrevNextButtons = function() {
        this.prevButton.activate(), this.nextButton.activate(), this.on("deactivate", this.deactivatePrevNextButtons);
    }, a.deactivatePrevNextButtons = function() {
        this.prevButton.deactivate(), this.nextButton.deactivate(), this.off("deactivate", this.deactivatePrevNextButtons);
    }, t.PrevNextButton = o, t;
}), function(e, t) {
    "function" == typeof define && define.amd ? define("flickity/js/page-dots", [ "./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils" ], function(i, n, o) {
        return t(e, i, n, o);
    }) : "object" == typeof module && module.exports ? module.exports = t(e, require("./flickity"), require("unipointer"), require("fizzy-ui-utils")) : t(e, e.Flickity, e.Unipointer, e.fizzyUIUtils);
}(window, function(e, t, i, n) {
    function o(e) {
        this.parent = e, this._create();
    }
    o.prototype = Object.create(i.prototype), o.prototype._create = function() {
        this.holder = document.createElement("ol"), this.holder.className = "flickity-page-dots", 
        this.dots = [], this.handleClick = this.onClick.bind(this), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
    }, o.prototype.activate = function() {
        this.setDots(), this.holder.addEventListener("click", this.handleClick), this.bindStartEvent(this.holder), 
        this.parent.element.appendChild(this.holder);
    }, o.prototype.deactivate = function() {
        this.holder.removeEventListener("click", this.handleClick), this.unbindStartEvent(this.holder), 
        this.parent.element.removeChild(this.holder);
    }, o.prototype.setDots = function() {
        var e = this.parent.slides.length - this.dots.length;
        e > 0 ? this.addDots(e) : e < 0 && this.removeDots(-e);
    }, o.prototype.addDots = function(e) {
        for (var t = document.createDocumentFragment(), i = [], n = this.dots.length, o = n + e, s = n; s < o; s++) {
            var a = document.createElement("li");
            a.className = "dot", a.setAttribute("aria-label", "Page dot " + (s + 1)), t.appendChild(a), 
            i.push(a);
        }
        this.holder.appendChild(t), this.dots = this.dots.concat(i);
    }, o.prototype.removeDots = function(e) {
        this.dots.splice(this.dots.length - e, e).forEach(function(e) {
            this.holder.removeChild(e);
        }, this);
    }, o.prototype.updateSelected = function() {
        this.selectedDot && (this.selectedDot.className = "dot", this.selectedDot.removeAttribute("aria-current")), 
        this.dots.length && (this.selectedDot = this.dots[this.parent.selectedIndex], this.selectedDot.className = "dot is-selected", 
        this.selectedDot.setAttribute("aria-current", "step"));
    }, o.prototype.onTap = o.prototype.onClick = function(e) {
        var t = e.target;
        if ("LI" == t.nodeName) {
            this.parent.uiChange();
            var i = this.dots.indexOf(t);
            this.parent.select(i);
        }
    }, o.prototype.destroy = function() {
        this.deactivate(), this.allOff();
    }, t.PageDots = o, n.extend(t.defaults, {
        pageDots: !0
    }), t.createMethods.push("_createPageDots");
    var s = t.prototype;
    return s._createPageDots = function() {
        this.options.pageDots && (this.pageDots = new o(this), this.on("activate", this.activatePageDots), 
        this.on("select", this.updateSelectedPageDots), this.on("cellChange", this.updatePageDots), 
        this.on("resize", this.updatePageDots), this.on("deactivate", this.deactivatePageDots));
    }, s.activatePageDots = function() {
        this.pageDots.activate();
    }, s.updateSelectedPageDots = function() {
        this.pageDots.updateSelected();
    }, s.updatePageDots = function() {
        this.pageDots.setDots();
    }, s.deactivatePageDots = function() {
        this.pageDots.deactivate();
    }, t.PageDots = o, t;
}), function(e, t) {
    "function" == typeof define && define.amd ? define("flickity/js/player", [ "ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity" ], function(e, i, n) {
        return t(e, i, n);
    }) : "object" == typeof module && module.exports ? module.exports = t(require("ev-emitter"), require("fizzy-ui-utils"), require("./flickity")) : t(e.EvEmitter, e.fizzyUIUtils, e.Flickity);
}(window, function(e, t, i) {
    function n(e) {
        this.parent = e, this.state = "stopped", this.onVisibilityChange = this.visibilityChange.bind(this), 
        this.onVisibilityPlay = this.visibilityPlay.bind(this);
    }
    n.prototype = Object.create(e.prototype), n.prototype.play = function() {
        if ("playing" != this.state) {
            if (document.hidden) return void document.addEventListener("visibilitychange", this.onVisibilityPlay);
            this.state = "playing", document.addEventListener("visibilitychange", this.onVisibilityChange), 
            this.tick();
        }
    }, n.prototype.tick = function() {
        if ("playing" == this.state) {
            var e = this.parent.options.autoPlay;
            e = "number" == typeof e ? e : 3e3;
            var t = this;
            this.clear(), this.timeout = setTimeout(function() {
                t.parent.next(!0), t.tick();
            }, e);
        }
    }, n.prototype.stop = function() {
        this.state = "stopped", this.clear(), document.removeEventListener("visibilitychange", this.onVisibilityChange);
    }, n.prototype.clear = function() {
        clearTimeout(this.timeout);
    }, n.prototype.pause = function() {
        "playing" == this.state && (this.state = "paused", this.clear());
    }, n.prototype.unpause = function() {
        "paused" == this.state && this.play();
    }, n.prototype.visibilityChange = function() {
        this[document.hidden ? "pause" : "unpause"]();
    }, n.prototype.visibilityPlay = function() {
        this.play(), document.removeEventListener("visibilitychange", this.onVisibilityPlay);
    }, t.extend(i.defaults, {
        pauseAutoPlayOnHover: !0
    }), i.createMethods.push("_createPlayer");
    var o = i.prototype;
    return o._createPlayer = function() {
        this.player = new n(this), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), 
        this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer);
    }, o.activatePlayer = function() {
        this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this));
    }, o.playPlayer = function() {
        this.player.play();
    }, o.stopPlayer = function() {
        this.player.stop();
    }, o.pausePlayer = function() {
        this.player.pause();
    }, o.unpausePlayer = function() {
        this.player.unpause();
    }, o.deactivatePlayer = function() {
        this.player.stop(), this.element.removeEventListener("mouseenter", this);
    }, o.onmouseenter = function() {
        this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener("mouseleave", this));
    }, o.onmouseleave = function() {
        this.player.unpause(), this.element.removeEventListener("mouseleave", this);
    }, i.Player = n, i;
}), function(e, t) {
    "function" == typeof define && define.amd ? define("flickity/js/add-remove-cell", [ "./flickity", "fizzy-ui-utils/utils" ], function(i, n) {
        return t(e, i, n);
    }) : "object" == typeof module && module.exports ? module.exports = t(e, require("./flickity"), require("fizzy-ui-utils")) : t(e, e.Flickity, e.fizzyUIUtils);
}(window, function(e, t, i) {
    var n = t.prototype;
    return n.insert = function(e, t) {
        var i = this._makeCells(e);
        if (i && i.length) {
            var n = this.cells.length;
            t = void 0 === t ? n : t;
            var o = function(e) {
                var t = document.createDocumentFragment();
                return e.forEach(function(e) {
                    t.appendChild(e.element);
                }), t;
            }(i), s = t == n;
            if (s) this.slider.appendChild(o); else {
                var a = this.cells[t].element;
                this.slider.insertBefore(o, a);
            }
            if (0 === t) this.cells = i.concat(this.cells); else if (s) this.cells = this.cells.concat(i); else {
                var r = this.cells.splice(t, n - t);
                this.cells = this.cells.concat(i).concat(r);
            }
            this._sizeCells(i), this.cellChange(t, !0);
        }
    }, n.append = function(e) {
        this.insert(e, this.cells.length);
    }, n.prepend = function(e) {
        this.insert(e, 0);
    }, n.remove = function(e) {
        var t = this.getCells(e);
        if (t && t.length) {
            var n = this.cells.length - 1;
            t.forEach(function(e) {
                e.remove();
                var t = this.cells.indexOf(e);
                n = Math.min(t, n), i.removeFrom(this.cells, e);
            }, this), this.cellChange(n, !0);
        }
    }, n.cellSizeChange = function(e) {
        var t = this.getCell(e);
        if (t) {
            t.getSize();
            var i = this.cells.indexOf(t);
            this.cellChange(i);
        }
    }, n.cellChange = function(e, t) {
        var i = this.selectedElement;
        this._positionCells(e), this._getWrapShiftCells(), this.setGallerySize();
        var n = this.getCell(i);
        n && (this.selectedIndex = this.getCellSlideIndex(n)), this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex), 
        this.emitEvent("cellChange", [ e ]), this.select(this.selectedIndex), t && this.positionSliderAtSelected();
    }, t;
}), function(e, t) {
    "function" == typeof define && define.amd ? define("flickity/js/lazyload", [ "./flickity", "fizzy-ui-utils/utils" ], function(i, n) {
        return t(e, i, n);
    }) : "object" == typeof module && module.exports ? module.exports = t(e, require("./flickity"), require("fizzy-ui-utils")) : t(e, e.Flickity, e.fizzyUIUtils);
}(window, function(e, t, i) {
    "use strict";
    function n(e) {
        if ("IMG" == e.nodeName) {
            var t = e.getAttribute("data-flickity-lazyload"), n = e.getAttribute("data-flickity-lazyload-src"), o = e.getAttribute("data-flickity-lazyload-srcset");
            if (t || n || o) return [ e ];
        }
        var s = e.querySelectorAll("img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]");
        return i.makeArray(s);
    }
    function o(e, t) {
        this.img = e, this.flickity = t, this.load();
    }
    t.createMethods.push("_createLazyload");
    var s = t.prototype;
    return s._createLazyload = function() {
        this.on("select", this.lazyLoad);
    }, s.lazyLoad = function() {
        var e = this.options.lazyLoad;
        if (e) {
            var t = "number" == typeof e ? e : 0, i = this.getAdjacentCellElements(t), s = [];
            i.forEach(function(e) {
                var t = n(e);
                s = s.concat(t);
            }), s.forEach(function(e) {
                new o(e, this);
            }, this);
        }
    }, o.prototype.handleEvent = i.handleEvent, o.prototype.load = function() {
        this.img.addEventListener("load", this), this.img.addEventListener("error", this);
        var e = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src"), t = this.img.getAttribute("data-flickity-lazyload-srcset");
        this.img.src = e, t && this.img.setAttribute("srcset", t), this.img.removeAttribute("data-flickity-lazyload"), 
        this.img.removeAttribute("data-flickity-lazyload-src"), this.img.removeAttribute("data-flickity-lazyload-srcset");
    }, o.prototype.onload = function(e) {
        this.complete(e, "flickity-lazyloaded");
    }, o.prototype.onerror = function(e) {
        this.complete(e, "flickity-lazyerror");
    }, o.prototype.complete = function(e, t) {
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
        var i = this.flickity.getParentCell(this.img), n = i && i.element;
        this.flickity.cellSizeChange(n), this.img.classList.add(t), this.flickity.dispatchEvent("lazyLoad", e, n);
    }, t.LazyLoader = o, t;
}), function(e, t) {
    "function" == typeof define && define.amd ? define("flickity/js/index", [ "./flickity", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload" ], t) : "object" == typeof module && module.exports && (module.exports = t(require("./flickity"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell"), require("./lazyload")));
}(window, function(e) {
    return e;
}), function(e, t) {
    "function" == typeof define && define.amd ? define("flickity-as-nav-for/as-nav-for", [ "flickity/js/index", "fizzy-ui-utils/utils" ], t) : "object" == typeof module && module.exports ? module.exports = t(require("flickity"), require("fizzy-ui-utils")) : e.Flickity = t(e.Flickity, e.fizzyUIUtils);
}(window, function(e, t) {
    e.createMethods.push("_createAsNavFor");
    var i = e.prototype;
    return i._createAsNavFor = function() {
        this.on("activate", this.activateAsNavFor), this.on("deactivate", this.deactivateAsNavFor), 
        this.on("destroy", this.destroyAsNavFor);
        var e = this.options.asNavFor;
        if (e) {
            var t = this;
            setTimeout(function() {
                t.setNavCompanion(e);
            });
        }
    }, i.setNavCompanion = function(i) {
        i = t.getQueryElement(i);
        var n = e.data(i);
        if (n && n != this) {
            this.navCompanion = n;
            var o = this;
            this.onNavCompanionSelect = function() {
                o.navCompanionSelect();
            }, n.on("select", this.onNavCompanionSelect), this.on("staticClick", this.onNavStaticClick), 
            this.navCompanionSelect(!0);
        }
    }, i.navCompanionSelect = function(e) {
        if (this.navCompanion) {
            var t = this.navCompanion.selectedCells[0], i = this.navCompanion.cells.indexOf(t), n = i + this.navCompanion.selectedCells.length - 1, o = Math.floor(function(e, t, i) {
                return (t - e) * i + e;
            }(i, n, this.navCompanion.cellAlign));
            if (this.selectCell(o, !1, e), this.removeNavSelectedElements(), !(o >= this.cells.length)) {
                var s = this.cells.slice(i, n + 1);
                this.navSelectedElements = s.map(function(e) {
                    return e.element;
                }), this.changeNavSelectedClass("add");
            }
        }
    }, i.changeNavSelectedClass = function(e) {
        this.navSelectedElements.forEach(function(t) {
            t.classList[e]("is-nav-selected");
        });
    }, i.activateAsNavFor = function() {
        this.navCompanionSelect(!0);
    }, i.removeNavSelectedElements = function() {
        this.navSelectedElements && (this.changeNavSelectedClass("remove"), delete this.navSelectedElements);
    }, i.onNavStaticClick = function(e, t, i, n) {
        "number" == typeof n && this.navCompanion.selectCell(n);
    }, i.deactivateAsNavFor = function() {
        this.removeNavSelectedElements();
    }, i.destroyAsNavFor = function() {
        this.navCompanion && (this.navCompanion.off("select", this.onNavCompanionSelect), 
        this.off("staticClick", this.onNavStaticClick), delete this.navCompanion);
    }, e;
}), function(e, t) {
    "use strict";
    "function" == typeof define && define.amd ? define("imagesloaded/imagesloaded", [ "ev-emitter/ev-emitter" ], function(i) {
        return t(e, i);
    }) : "object" == typeof module && module.exports ? module.exports = t(e, require("ev-emitter")) : e.imagesLoaded = t(e, e.EvEmitter);
}("undefined" != typeof window ? window : this, function(e, t) {
    function i(e, t) {
        for (var i in t) e[i] = t[i];
        return e;
    }
    function n(e, t, o) {
        if (!(this instanceof n)) return new n(e, t, o);
        var s = e;
        return "string" == typeof e && (s = document.querySelectorAll(e)), s ? (this.elements = function(e) {
            return Array.isArray(e) ? e : "object" == typeof e && "number" == typeof e.length ? l.call(e) : [ e ];
        }(s), this.options = i({}, this.options), "function" == typeof t ? o = t : i(this.options, t), 
        o && this.on("always", o), this.getImages(), a && (this.jqDeferred = new a.Deferred()), 
        void setTimeout(this.check.bind(this))) : void r.error("Bad element for imagesLoaded " + (s || e));
    }
    function o(e) {
        this.img = e;
    }
    function s(e, t) {
        this.url = e, this.element = t, this.img = new Image();
    }
    var a = e.jQuery, r = e.console, l = Array.prototype.slice;
    n.prototype = Object.create(t.prototype), n.prototype.options = {}, n.prototype.getImages = function() {
        this.images = [], this.elements.forEach(this.addElementImages, this);
    }, n.prototype.addElementImages = function(e) {
        "IMG" == e.nodeName && this.addImage(e), !0 === this.options.background && this.addElementBackgroundImages(e);
        var t = e.nodeType;
        if (t && c[t]) {
            for (var i = e.querySelectorAll("img"), n = 0; n < i.length; n++) {
                var o = i[n];
                this.addImage(o);
            }
            if ("string" == typeof this.options.background) {
                var s = e.querySelectorAll(this.options.background);
                for (n = 0; n < s.length; n++) {
                    var a = s[n];
                    this.addElementBackgroundImages(a);
                }
            }
        }
    };
    var c = {
        1: !0,
        9: !0,
        11: !0
    };
    return n.prototype.addElementBackgroundImages = function(e) {
        var t = getComputedStyle(e);
        if (t) for (var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(t.backgroundImage); null !== n; ) {
            var o = n && n[2];
            o && this.addBackground(o, e), n = i.exec(t.backgroundImage);
        }
    }, n.prototype.addImage = function(e) {
        var t = new o(e);
        this.images.push(t);
    }, n.prototype.addBackground = function(e, t) {
        var i = new s(e, t);
        this.images.push(i);
    }, n.prototype.check = function() {
        function e(e, i, n) {
            setTimeout(function() {
                t.progress(e, i, n);
            });
        }
        var t = this;
        return this.progressedCount = 0, this.hasAnyBroken = !1, this.images.length ? void this.images.forEach(function(t) {
            t.once("progress", e), t.check();
        }) : void this.complete();
    }, n.prototype.progress = function(e, t, i) {
        this.progressedCount++, this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded, this.emitEvent("progress", [ this, e, t ]), 
        this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, e), this.progressedCount == this.images.length && this.complete(), 
        this.options.debug && r && r.log("progress: " + i, e, t);
    }, n.prototype.complete = function() {
        var e = this.hasAnyBroken ? "fail" : "done";
        if (this.isComplete = !0, this.emitEvent(e, [ this ]), this.emitEvent("always", [ this ]), 
        this.jqDeferred) {
            var t = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[t](this);
        }
    }, o.prototype = Object.create(t.prototype), o.prototype.check = function() {
        return this.getIsImageComplete() ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth") : (this.proxyImage = new Image(), 
        this.proxyImage.addEventListener("load", this), this.proxyImage.addEventListener("error", this), 
        this.img.addEventListener("load", this), this.img.addEventListener("error", this), 
        void (this.proxyImage.src = this.img.src));
    }, o.prototype.getIsImageComplete = function() {
        return this.img.complete && this.img.naturalWidth;
    }, o.prototype.confirm = function(e, t) {
        this.isLoaded = e, this.emitEvent("progress", [ this, this.img, t ]);
    }, o.prototype.handleEvent = function(e) {
        var t = "on" + e.type;
        this[t] && this[t](e);
    }, o.prototype.onload = function() {
        this.confirm(!0, "onload"), this.unbindEvents();
    }, o.prototype.onerror = function() {
        this.confirm(!1, "onerror"), this.unbindEvents();
    }, o.prototype.unbindEvents = function() {
        this.proxyImage.removeEventListener("load", this), this.proxyImage.removeEventListener("error", this), 
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
    }, s.prototype = Object.create(o.prototype), s.prototype.check = function() {
        this.img.addEventListener("load", this), this.img.addEventListener("error", this), 
        this.img.src = this.url, this.getIsImageComplete() && (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), 
        this.unbindEvents());
    }, s.prototype.unbindEvents = function() {
        this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
    }, s.prototype.confirm = function(e, t) {
        this.isLoaded = e, this.emitEvent("progress", [ this, this.element, t ]);
    }, n.makeJQueryPlugin = function(t) {
        (t = t || e.jQuery) && ((a = t).fn.imagesLoaded = function(e, t) {
            return new n(this, e, t).jqDeferred.promise(a(this));
        });
    }, n.makeJQueryPlugin(), n;
}), function(e, t) {
    "function" == typeof define && define.amd ? define([ "flickity/js/index", "imagesloaded/imagesloaded" ], function(i, n) {
        return t(e, i, n);
    }) : "object" == typeof module && module.exports ? module.exports = t(e, require("flickity"), require("imagesloaded")) : e.Flickity = t(e, e.Flickity, e.imagesLoaded);
}(window, function(e, t, i) {
    "use strict";
    t.createMethods.push("_createImagesLoaded");
    var n = t.prototype;
    return n._createImagesLoaded = function() {
        this.on("activate", this.imagesLoaded);
    }, n.imagesLoaded = function() {
        if (this.options.imagesLoaded) {
            var e = this;
            i(this.slider).on("progress", function(t, i) {
                var n = e.getParentCell(i.img);
                e.cellSizeChange(n && n.element), e.options.freeScroll || e.positionSliderAtSelected();
            });
        }
    }, t;
}), function(e, t) {
    "function" == typeof define && define.amd ? define([ "flickity/js/index", "fizzy-ui-utils/utils" ], t) : "object" == typeof module && module.exports ? module.exports = t(require("flickity"), require("fizzy-ui-utils")) : t(e.Flickity, e.fizzyUIUtils);
}(this, function(e, t) {
    var i = e.Slide, n = i.prototype.updateTarget;
    i.prototype.updateTarget = function() {
        if (n.apply(this, arguments), this.parent.options.fade) {
            var e = this.target - this.x, t = this.cells[0].x;
            this.cells.forEach(function(i) {
                var n = i.x - t - e;
                i.renderPosition(n);
            });
        }
    }, i.prototype.setOpacity = function(e) {
        this.cells.forEach(function(t) {
            t.element.style.opacity = e;
        });
    };
    var o = e.prototype;
    e.createMethods.push("_createFade"), o._createFade = function() {
        this.fadeIndex = this.selectedIndex, this.prevSelectedIndex = this.selectedIndex, 
        this.on("select", this.onSelectFade), this.on("dragEnd", this.onDragEndFade), this.on("settle", this.onSettleFade), 
        this.on("activate", this.onActivateFade), this.on("deactivate", this.onDeactivateFade);
    };
    var s = o.updateSlides;
    o.updateSlides = function() {
        s.apply(this, arguments), this.options.fade && this.slides.forEach(function(e, t) {
            var i = t == this.selectedIndex ? 1 : 0;
            e.setOpacity(i);
        }, this);
    }, o.onSelectFade = function() {
        this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1), this.prevSelectedIndex = this.selectedIndex;
    }, o.onSettleFade = function() {
        (delete this.didDragEnd, this.options.fade) && (this.selectedSlide.setOpacity(1), 
        this.slides[this.fadeIndex] && this.fadeIndex != this.selectedIndex && this.slides[this.fadeIndex].setOpacity(0));
    }, o.onDragEndFade = function() {
        this.didDragEnd = !0;
    }, o.onActivateFade = function() {
        this.options.fade && this.element.classList.add("is-fade");
    }, o.onDeactivateFade = function() {
        this.options.fade && (this.element.classList.remove("is-fade"), this.slides.forEach(function(e) {
            e.setOpacity("");
        }));
    };
    var a = o.positionSlider;
    o.positionSlider = function() {
        return this.options.fade ? (this.fadeSlides(), void this.dispatchScrollEvent()) : void a.apply(this, arguments);
    };
    var r = o.positionSliderAtSelected;
    o.positionSliderAtSelected = function() {
        this.options.fade && this.setTranslateX(0), r.apply(this, arguments);
    }, o.fadeSlides = function() {
        if (!(this.slides.length < 2)) {
            var e = this.getFadeIndexes(), t = this.slides[e.a], i = this.slides[e.b], n = this.wrapDifference(t.target, i.target), o = this.wrapDifference(t.target, -this.x);
            o /= n, t.setOpacity(1 - o), i.setOpacity(o);
            var s = e.a;
            this.isDragging && (s = o > .5 ? e.a : e.b), null != this.fadeHideIndex && this.fadeHideIndex != s && this.fadeHideIndex != e.a && this.fadeHideIndex != e.b && this.slides[this.fadeHideIndex].setOpacity(0), 
            this.fadeHideIndex = s;
        }
    }, o.getFadeIndexes = function() {
        return this.isDragging || this.didDragEnd ? this.options.wrapAround ? this.getFadeDragWrapIndexes() : this.getFadeDragLimitIndexes() : {
            a: this.fadeIndex,
            b: this.selectedIndex
        };
    }, o.getFadeDragWrapIndexes = function() {
        var e = this.slides.map(function(e, t) {
            return this.getSlideDistance(-this.x, t);
        }, this), i = e.map(function(e) {
            return Math.abs(e);
        }), n = Math.min.apply(Math, i), o = i.indexOf(n), s = e[o], a = this.slides.length, r = s >= 0 ? 1 : -1;
        return {
            a: o,
            b: t.modulo(o + r, a)
        };
    }, o.getFadeDragLimitIndexes = function() {
        for (var e = 0, t = 0; t < this.slides.length - 1; t++) {
            var i = this.slides[t];
            if (-this.x < i.target) break;
            e = t;
        }
        return {
            a: e,
            b: e + 1
        };
    }, o.wrapDifference = function(e, t) {
        var i = t - e;
        if (!this.options.wrapAround) return i;
        var n = i + this.slideableWidth, o = i - this.slideableWidth;
        return Math.abs(n) < Math.abs(i) && (i = n), Math.abs(o) < Math.abs(i) && (i = o), 
        i;
    };
    var l = o._getWrapShiftCells;
    o._getWrapShiftCells = function() {
        this.options.fade || l.apply(this, arguments);
    };
    var c = o.shiftWrapCells;
    return o.shiftWrapCells = function() {
        this.options.fade || c.apply(this, arguments);
    }, e;
}), function() {
    var e;
    e = function() {
        function e(e, t) {
            var i, n;
            if (this.options = {
                target: "instafeed",
                get: "popular",
                resolution: "thumbnail",
                sortBy: "none",
                links: !0,
                mock: !1,
                useHttp: !1
            }, "object" == typeof e) for (i in e) n = e[i], this.options[i] = n;
            this.context = null != t ? t : this, this.unique = this._genKey();
        }
        return e.prototype.hasNext = function() {
            return "string" == typeof this.context.nextUrl && this.context.nextUrl.length > 0;
        }, e.prototype.next = function() {
            return !!this.hasNext() && this.run(this.context.nextUrl);
        }, e.prototype.run = function(t) {
            var i, n;
            if ("string" != typeof this.options.clientId && "string" != typeof this.options.accessToken) throw new Error("Missing clientId or accessToken.");
            if ("string" != typeof this.options.accessToken && "string" != typeof this.options.clientId) throw new Error("Missing clientId or accessToken.");
            return null != this.options.before && "function" == typeof this.options.before && this.options.before.call(this), 
            "undefined" != typeof document && null !== document && ((n = document.createElement("script")).id = "instafeed-fetcher", 
            n.src = t || this._buildUrl(), document.getElementsByTagName("head")[0].appendChild(n), 
            i = "instafeedCache" + this.unique, window[i] = new e(this.options, this), window[i].unique = this.unique), 
            !0;
        }, e.prototype.parse = function(e) {
            var t, i, n, o, s, a, r, l, c, u, h, d, m, p, f, g, v, y, _, w, b, C, E, k, S, x, L, A;
            if ("object" != typeof e) {
                if (null != this.options.error && "function" == typeof this.options.error) return this.options.error.call(this, "Invalid JSON data"), 
                !1;
                throw new Error("Invalid JSON response");
            }
            if (200 !== e.meta.code) {
                if (null != this.options.error && "function" == typeof this.options.error) return this.options.error.call(this, e.meta.error_message), 
                !1;
                throw new Error("Error from Instagram: " + e.meta.error_message);
            }
            if (0 === e.data.length) {
                if (null != this.options.error && "function" == typeof this.options.error) return this.options.error.call(this, "No images were returned from Instagram"), 
                !1;
                throw new Error("No images were returned from Instagram");
            }
            if (null != this.options.success && "function" == typeof this.options.success && this.options.success.call(this, e), 
            this.context.nextUrl = "", null != e.pagination && (this.context.nextUrl = e.pagination.next_url), 
            "none" !== this.options.sortBy) switch (x = "random" === this.options.sortBy ? [ "", "random" ] : this.options.sortBy.split("-"), 
            S = "least" === x[0], x[1]) {
              case "random":
                e.data.sort(function() {
                    return .5 - Math.random();
                });
                break;

              case "recent":
                e.data = this._sortBy(e.data, "created_time", S);
                break;

              case "liked":
                e.data = this._sortBy(e.data, "likes.count", S);
                break;

              case "commented":
                e.data = this._sortBy(e.data, "comments.count", S);
                break;

              default:
                throw new Error("Invalid option for sortBy: '" + this.options.sortBy + "'.");
            }
            if ("undefined" != typeof document && null !== document && !1 === this.options.mock) {
                if (d = e.data, k = parseInt(this.options.limit, 10), null != this.options.limit && d.length > k && (d = d.slice(0, k)), 
                a = document.createDocumentFragment(), null != this.options.filter && "function" == typeof this.options.filter && (d = this._filter(d, this.options.filter)), 
                null != this.options.template && "string" == typeof this.options.template) {
                    for (r = "", "", "", A = document.createElement("div"), l = 0, w = d.length; l < w; l++) {
                        if ("object" != typeof (u = (c = d[l]).images[this.options.resolution])) throw s = "No image found for resolution: " + this.options.resolution + ".", 
                        new Error(s);
                        f = "square", (g = u.width) > (p = u.height) && (f = "landscape"), g < p && (f = "portrait"), 
                        h = u.url, window.location.protocol.indexOf("http") >= 0 && !this.options.useHttp && (h = h.replace(/https?:\/\//, "//")), 
                        r += this._makeTemplate(this.options.template, {
                            model: c,
                            id: c.id,
                            link: c.link,
                            type: c.type,
                            image: h,
                            width: g,
                            height: p,
                            orientation: f,
                            caption: this._getObjectProperty(c, "caption.text"),
                            likes: c.likes.count,
                            comments: c.comments.count,
                            location: this._getObjectProperty(c, "location.name")
                        });
                    }
                    for (A.innerHTML = r, o = [], n = 0, i = A.childNodes.length; n < i; ) o.push(A.childNodes[n]), 
                    n += 1;
                    for (y = 0, b = o.length; y < b; y++) E = o[y], a.appendChild(E);
                } else for (_ = 0, C = d.length; _ < C; _++) {
                    if (c = d[_], m = document.createElement("img"), "object" != typeof (u = c.images[this.options.resolution])) throw s = "No image found for resolution: " + this.options.resolution + ".", 
                    new Error(s);
                    h = u.url, window.location.protocol.indexOf("http") >= 0 && !this.options.useHttp && (h = h.replace(/https?:\/\//, "//")), 
                    m.src = h, !0 === this.options.links ? ((t = document.createElement("a")).href = c.link, 
                    t.appendChild(m), a.appendChild(t)) : a.appendChild(m);
                }
                if ("string" == typeof (L = this.options.target) && (L = document.getElementById(L)), 
                null == L) throw s = 'No element with id="' + this.options.target + '" on page.', 
                new Error(s);
                L.appendChild(a), document.getElementsByTagName("head")[0].removeChild(document.getElementById("instafeed-fetcher")), 
                v = "instafeedCache" + this.unique, window[v] = void 0;
                try {
                    delete window[v];
                } catch (e) {
                    e;
                }
            }
            return null != this.options.after && "function" == typeof this.options.after && this.options.after.call(this), 
            !0;
        }, e.prototype._buildUrl = function() {
            var e, t;
            switch ("https://api.instagram.com/v1", this.options.get) {
              case "popular":
                e = "media/popular";
                break;

              case "tagged":
                if (!this.options.tagName) throw new Error("No tag name specified. Use the 'tagName' option.");
                e = "tags/" + this.options.tagName + "/media/recent";
                break;

              case "location":
                if (!this.options.locationId) throw new Error("No location specified. Use the 'locationId' option.");
                e = "locations/" + this.options.locationId + "/media/recent";
                break;

              case "user":
                if (!this.options.userId) throw new Error("No user specified. Use the 'userId' option.");
                e = "users/" + this.options.userId + "/media/recent";
                break;

              default:
                throw new Error("Invalid option for get: '" + this.options.get + "'.");
            }
            return t = "https://api.instagram.com/v1/" + e, t += null != this.options.accessToken ? "?access_token=" + this.options.accessToken : "?client_id=" + this.options.clientId, 
            null != this.options.limit && (t += "&count=" + this.options.limit), t + "&callback=instafeedCache" + this.unique + ".parse";
        }, e.prototype._genKey = function() {
            var e;
            return "" + (e = function() {
                return (65536 * (1 + Math.random()) | 0).toString(16).substring(1);
            })() + e() + e() + e();
        }, e.prototype._makeTemplate = function(e, t) {
            var i, n, o, s, a;
            for (n = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/, i = e; n.test(i); ) s = i.match(n)[1], 
            a = null != (o = this._getObjectProperty(t, s)) ? o : "", i = i.replace(n, function() {
                return "" + a;
            });
            return i;
        }, e.prototype._getObjectProperty = function(e, t) {
            var i, n;
            for (n = (t = t.replace(/\[(\w+)\]/g, ".$1")).split("."); n.length; ) {
                if (i = n.shift(), !(null != e && i in e)) return null;
                e = e[i];
            }
            return e;
        }, e.prototype._sortBy = function(e, t, i) {
            var n;
            return n = function(e, n) {
                var o, s;
                return o = this._getObjectProperty(e, t), s = this._getObjectProperty(n, t), i ? o > s ? 1 : -1 : o < s ? 1 : -1;
            }, e.sort(n.bind(this)), e;
        }, e.prototype._filter = function(e, t) {
            var i, n, o, s;
            for (i = [], n = function(e) {
                if (t(e)) return i.push(e);
            }, o = 0, s = e.length; o < s; o++) n(e[o]);
            return i;
        }, e;
    }(), function(e, t) {
        "function" == typeof define && define.amd ? define([], t) : "object" == typeof module && module.exports ? module.exports = t() : e.Instafeed = t();
    }(this, function() {
        return e;
    });
}.call(this), function() {
    function e() {
        s = void 0, o();
    }
    function t(e) {
        e.relatedTarget && e.target.closest("a") == e.relatedTarget.closest("a") || (a ? (clearTimeout(a), 
        a = void 0) : (s = void 0, o()));
    }
    function i(e) {
        if (e && e.href && s != e.href) {
            const t = new URL(e.href);
            if ((d || t.origin == location.origin || "instant" in e.dataset) && [ "http:", "https:" ].includes(t.protocol) && ("http:" != t.protocol || "https:" != location.protocol) && (h || !t.search || "instant" in e.dataset) && !(t.hash && t.pathname + t.search == location.pathname + location.search || "noInstant" in e.dataset)) return !0;
        }
    }
    function n(e) {
        l.href = e;
    }
    function o() {
        l.removeAttribute("href");
    }
    var s, a, r;
    const l = document.createElement("link"), c = l.relList && l.relList.supports && l.relList.supports("prefetch"), u = navigator.connection && navigator.connection.saveData, h = "instantAllowQueryString" in document.body.dataset, d = "instantAllowExternalLinks" in document.body.dataset;
    if (c && !u) {
        l.rel = "prefetch", document.head.appendChild(l);
        const o = {
            capture: !0,
            passive: !0
        };
        document.addEventListener("touchstart", function(t) {
            r = performance.now();
            const o = t.target.closest("a");
            i(o) && (o.addEventListener("touchcancel", e, {
                passive: !0
            }), o.addEventListener("touchend", e, {
                passive: !0
            }), s = o.href, n(o.href));
        }, o), document.addEventListener("mouseover", function(e) {
            if (!(performance.now() - r < 1100)) {
                const o = e.target.closest("a");
                i(o) && (o.addEventListener("mouseout", t, {
                    passive: !0
                }), s = o.href, a = setTimeout(function() {
                    n(o.href), a = void 0;
                }, 65));
            }
        }, o);
    }
}(), function() {
    "use strict";
    function e() {
        function e(e, t) {
            this.scrollLeft = e, this.scrollTop = t;
        }
        function n(e) {
            if (null === e || "object" != typeof e || void 0 === e.behavior || "auto" === e.behavior || "instant" === e.behavior) return !0;
            if ("object" == typeof e && "smooth" === e.behavior) return !1;
            throw new TypeError("behavior member of ScrollOptions " + e.behavior + " is not a valid value for enumeration ScrollBehavior.");
        }
        function o(e, t) {
            return "Y" === t ? e.clientHeight + h < e.scrollHeight : "X" === t ? e.clientWidth + h < e.scrollWidth : void 0;
        }
        function s(e, i) {
            var n = t.getComputedStyle(e, null)["overflow" + i];
            return "auto" === n || "scroll" === n;
        }
        function a(e) {
            var t = o(e, "Y") && s(e, "Y"), i = o(e, "X") && s(e, "X");
            return t || i;
        }
        function r(e) {
            var i, n, o, s = (m() - e.startTime) / u;
            i = function(e) {
                return .5 * (1 - Math.cos(Math.PI * e));
            }(s = s > 1 ? 1 : s), n = e.startX + (e.x - e.startX) * i, o = e.startY + (e.y - e.startY) * i, 
            e.method.call(e.scrollable, n, o), n === e.x && o === e.y || t.requestAnimationFrame(r.bind(t, e));
        }
        function l(n, o, s) {
            var a, l, c, u, h = m();
            n === i.body ? (a = t, l = t.scrollX || t.pageXOffset, c = t.scrollY || t.pageYOffset, 
            u = d.scroll) : (a = n, l = n.scrollLeft, c = n.scrollTop, u = e), r({
                scrollable: a,
                method: u,
                startTime: h,
                startX: l,
                startY: c,
                x: o,
                y: s
            });
        }
        if (!("scrollBehavior" in i.documentElement.style && !0 !== t.__forceSmoothScrollPolyfill__)) {
            var c = t.HTMLElement || t.Element, u = 468, h = function(e) {
                return new RegExp([ "MSIE ", "Trident/", "Edge/" ].join("|")).test(e);
            }(t.navigator.userAgent) ? 1 : 0, d = {
                scroll: t.scroll || t.scrollTo,
                scrollBy: t.scrollBy,
                elementScroll: c.prototype.scroll || e,
                scrollIntoView: c.prototype.scrollIntoView
            }, m = t.performance && t.performance.now ? t.performance.now.bind(t.performance) : Date.now;
            t.scroll = t.scrollTo = function() {
                if (void 0 !== arguments[0]) return !0 === n(arguments[0]) ? void d.scroll.call(t, void 0 !== arguments[0].left ? arguments[0].left : "object" != typeof arguments[0] ? arguments[0] : t.scrollX || t.pageXOffset, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : t.scrollY || t.pageYOffset) : void l.call(t, i.body, void 0 !== arguments[0].left ? ~~arguments[0].left : t.scrollX || t.pageXOffset, void 0 !== arguments[0].top ? ~~arguments[0].top : t.scrollY || t.pageYOffset);
            }, t.scrollBy = function() {
                if (void 0 !== arguments[0]) return n(arguments[0]) ? void d.scrollBy.call(t, void 0 !== arguments[0].left ? arguments[0].left : "object" != typeof arguments[0] ? arguments[0] : 0, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : 0) : void l.call(t, i.body, ~~arguments[0].left + (t.scrollX || t.pageXOffset), ~~arguments[0].top + (t.scrollY || t.pageYOffset));
            }, c.prototype.scroll = c.prototype.scrollTo = function() {
                if (void 0 !== arguments[0]) {
                    if (!0 === n(arguments[0])) {
                        if ("number" == typeof arguments[0] && void 0 === arguments[1]) throw new SyntaxError("Value couldn't be converted");
                        return void d.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left : "object" != typeof arguments[0] ? ~~arguments[0] : this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top : void 0 !== arguments[1] ? ~~arguments[1] : this.scrollTop);
                    }
                    var e = arguments[0].left, t = arguments[0].top;
                    l.call(this, this, void 0 === e ? this.scrollLeft : ~~e, void 0 === t ? this.scrollTop : ~~t);
                }
            }, c.prototype.scrollBy = function() {
                if (void 0 !== arguments[0]) return !0 === n(arguments[0]) ? void d.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop) : void this.scroll({
                    left: ~~arguments[0].left + this.scrollLeft,
                    top: ~~arguments[0].top + this.scrollTop,
                    behavior: arguments[0].behavior
                });
            }, c.prototype.scrollIntoView = function() {
                if (!0 !== n(arguments[0])) {
                    var e = function(e) {
                        var t;
                        do {
                            t = (e = e.parentNode) === i.body;
                        } while (!1 === t && !1 === a(e));
                        return t = null, e;
                    }(this), o = e.getBoundingClientRect(), s = this.getBoundingClientRect();
                    e !== i.body ? (l.call(this, e, e.scrollLeft + s.left - o.left, e.scrollTop + s.top - o.top), 
                    "fixed" !== t.getComputedStyle(e).position && t.scrollBy({
                        left: o.left,
                        top: o.top,
                        behavior: "smooth"
                    })) : t.scrollBy({
                        left: s.left,
                        top: s.top,
                        behavior: "smooth"
                    });
                } else d.scrollIntoView.call(this, void 0 === arguments[0] || arguments[0]);
            };
        }
    }
    var t = window, i = document;
    "object" == typeof exports ? module.exports = {
        polyfill: e
    } : e();
}();

var _createClass = function() {
    function e(e, t) {
        for (var i = 0; i < t.length; i++) {
            var n = t[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), 
            Object.defineProperty(e, n.key, n);
        }
    }
    return function(t, i, n) {
        return i && e(t.prototype, i), n && e(t, n), t;
    };
}();

function _classCallCheck(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

!function(e) {
    var t = {};
    function i(n) {
        if (t[n]) return t[n].exports;
        var o = t[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return e[n].call(o.exports, o, o.exports, i), o.l = !0, o.exports;
    }
    i.m = e, i.c = t, i.d = function(e, t, n) {
        i.o(e, t) || Object.defineProperty(e, t, {
            configurable: !1,
            enumerable: !0,
            get: n
        });
    }, i.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return i.d(t, "a", t), t;
    }, i.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, i.p = "", i(i.s = 53);
}([ function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e() {
            _classCallCheck(this, e);
        }
        return _createClass(e, null, [ {
            key: "matchesBreakpoint",
            value: function(e) {
                switch (e) {
                  case "phone":
                    return window.matchMedia("screen and (max-width: 640px)").matches;

                  case "tablet":
                    return window.matchMedia("screen and (min-width: 641px) and (max-width: 1023px)").matches;

                  case "tablet-and-up":
                    return window.matchMedia("screen and (min-width: 641px)").matches;

                  case "pocket":
                    return window.matchMedia("screen and (max-width: 1023px)").matches;

                  case "lap":
                    return window.matchMedia("screen and (min-width: 1024px) and (max-width: 1279px)").matches;

                  case "lap-and-up":
                    return window.matchMedia("screen and (min-width: 1024px)").matches;

                  case "desk":
                    return window.matchMedia("screen and (min-width: 1280px)").matches;

                  case "widescreen":
                    return window.matchMedia("screen and (min-width: 1440px)").matches;

                  case "supports-hover":
                    return window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches;
                }
            }
        }, {
            key: "getCurrentBreakpoint",
            value: function() {
                return window.matchMedia("screen and (max-width: 640px)").matches ? "phone" : window.matchMedia("screen and (min-width: 641px) and (max-width: 1023px)").matches ? "tablet" : window.matchMedia("screen and (min-width: 1024px) and (max-width: 1279px)").matches ? "lap" : window.matchMedia("screen and (min-width: 1280px)").matches ? "desk" : void 0;
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e() {
            _classCallCheck(this, e);
        }
        return _createClass(e, null, [ {
            key: "formatMoney",
            value: function(e, t) {
                "string" == typeof e && (e = e.replace(".", ""));
                var i = /\{\{\s*(\w+)\s*\}\}/, n = t || "${{amount}}";
                function o(e, t) {
                    return null == e || e != e ? t : e;
                }
                function s(e, t, i, n) {
                    if (t = o(t, 2), i = o(i, ","), n = o(n, "."), isNaN(e) || null == e) return 0;
                    var s = (e = (e / 100).toFixed(t)).split(".");
                    return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (s[1] ? n + s[1] : "");
                }
                var a = "";
                switch (n.match(i)[1]) {
                  case "amount":
                    a = s(e, 2);
                    break;

                  case "amount_no_decimals":
                    a = s(e, 0);
                    break;

                  case "amount_with_space_separator":
                    a = s(e, 2, " ", ".");
                    break;

                  case "amount_no_decimals_with_comma_separator":
                    a = s(e, 0, ",", ".");
                    break;

                  case "amount_no_decimals_with_space_separator":
                    a = s(e, 0, " ");
                    break;

                  case "amount_with_comma_separator":
                    a = s(e, 2, ".", ",");
                }
                return -1 !== n.indexOf("with_comma_separator") ? n.replace(i, a).replace(",00", "") : n.replace(i, a).replace(".00", "");
            }
        }, {
            key: "convertAll",
            value: function(e) {
                var t = this, i = {
                    USD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} USD"
                    },
                    EUR: {
                        money_format: "&euro;{{amount}}",
                        money_with_currency_format: "&euro;{{amount}} EUR"
                    },
                    GBP: {
                        money_format: "&pound;{{amount}}",
                        money_with_currency_format: "&pound;{{amount}} GBP"
                    },
                    CAD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} CAD"
                    },
                    ALL: {
                        money_format: "Lek {{amount}}",
                        money_with_currency_format: "Lek {{amount}} ALL"
                    },
                    DZD: {
                        money_format: "DA {{amount}}",
                        money_with_currency_format: "DA {{amount}} DZD"
                    },
                    AOA: {
                        money_format: "Kz{{amount}}",
                        money_with_currency_format: "Kz{{amount}} AOA"
                    },
                    ARS: {
                        money_format: "${{amount_with_comma_separator}}",
                        money_with_currency_format: "${{amount_with_comma_separator}} ARS"
                    },
                    AMD: {
                        money_format: "{{amount}} AMD",
                        money_with_currency_format: "{{amount}} AMD"
                    },
                    AWG: {
                        money_format: "Afl{{amount}}",
                        money_with_currency_format: "Afl{{amount}} AWG"
                    },
                    AUD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} AUD"
                    },
                    BBD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} Bds"
                    },
                    AZN: {
                        money_format: "m.{{amount}}",
                        money_with_currency_format: "m.{{amount}} AZN"
                    },
                    BDT: {
                        money_format: "Tk {{amount}}",
                        money_with_currency_format: "Tk {{amount}} BDT"
                    },
                    BSD: {
                        money_format: "BS${{amount}}",
                        money_with_currency_format: "BS${{amount}} BSD"
                    },
                    BHD: {
                        money_format: "{{amount}} BD",
                        money_with_currency_format: "{{amount}} BHD"
                    },
                    BYR: {
                        money_format: "Br {{amount}}",
                        money_with_currency_format: "Br {{amount}} BYR"
                    },
                    BZD: {
                        money_format: "BZ${{amount}}",
                        money_with_currency_format: "BZ${{amount}} BZD"
                    },
                    BTN: {
                        money_format: "Nu {{amount}}",
                        money_with_currency_format: "Nu {{amount}} BTN"
                    },
                    BAM: {
                        money_format: "KM {{amount_with_comma_separator}}",
                        money_with_currency_format: "KM {{amount_with_comma_separator}} BAM"
                    },
                    BRL: {
                        money_format: "R$ {{amount_with_comma_separator}}",
                        money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL"
                    },
                    BOB: {
                        money_format: "Bs{{amount_with_comma_separator}}",
                        money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB"
                    },
                    BWP: {
                        money_format: "P{{amount}}",
                        money_with_currency_format: "P{{amount}} BWP"
                    },
                    BND: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} BND"
                    },
                    BGN: {
                        money_format: "{{amount}} Ð»Ð²",
                        money_with_currency_format: "{{amount}} Ð»Ð² BGN"
                    },
                    MMK: {
                        money_format: "K{{amount}}",
                        money_with_currency_format: "K{{amount}} MMK"
                    },
                    KHR: {
                        money_format: "KHR{{amount}}",
                        money_with_currency_format: "KHR{{amount}}"
                    },
                    KYD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} KYD"
                    },
                    XAF: {
                        money_format: "FCFA{{amount}}",
                        money_with_currency_format: "FCFA{{amount}} XAF"
                    },
                    CLP: {
                        money_format: "${{amount_no_decimals}}",
                        money_with_currency_format: "${{amount_no_decimals}} CLP"
                    },
                    CNY: {
                        money_format: "&#165;{{amount}}",
                        money_with_currency_format: "&#165;{{amount}} CNY"
                    },
                    COP: {
                        money_format: "${{amount_with_comma_separator}}",
                        money_with_currency_format: "${{amount_with_comma_separator}} COP"
                    },
                    CRC: {
                        money_format: "&#8353; {{amount_with_comma_separator}}",
                        money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC"
                    },
                    HRK: {
                        money_format: "{{amount_with_comma_separator}} kn",
                        money_with_currency_format: "{{amount_with_comma_separator}} kn HRK"
                    },
                    CZK: {
                        money_format: "{{amount_with_comma_separator}} K&#269;",
                        money_with_currency_format: "{{amount_with_comma_separator}} K&#269;"
                    },
                    DKK: {
                        money_format: "{{amount_with_comma_separator}}",
                        money_with_currency_format: "kr.{{amount_with_comma_separator}}"
                    },
                    DOP: {
                        money_format: "RD$ {{amount}}",
                        money_with_currency_format: "RD$ {{amount}}"
                    },
                    XCD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "EC${{amount}}"
                    },
                    EGP: {
                        money_format: "LE {{amount}}",
                        money_with_currency_format: "LE {{amount}} EGP"
                    },
                    ETB: {
                        money_format: "Br{{amount}}",
                        money_with_currency_format: "Br{{amount}} ETB"
                    },
                    XPF: {
                        money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
                        money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF"
                    },
                    FJD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "FJ${{amount}}"
                    },
                    GMD: {
                        money_format: "D {{amount}}",
                        money_with_currency_format: "D {{amount}} GMD"
                    },
                    GHS: {
                        money_format: "GH&#8373;{{amount}}",
                        money_with_currency_format: "GH&#8373;{{amount}}"
                    },
                    GTQ: {
                        money_format: "Q{{amount}}",
                        money_with_currency_format: "{{amount}} GTQ"
                    },
                    GYD: {
                        money_format: "G${{amount}}",
                        money_with_currency_format: "${{amount}} GYD"
                    },
                    GEL: {
                        money_format: "{{amount}} GEL",
                        money_with_currency_format: "{{amount}} GEL"
                    },
                    HNL: {
                        money_format: "L {{amount}}",
                        money_with_currency_format: "L {{amount}} HNL"
                    },
                    HKD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "HK${{amount}}"
                    },
                    HUF: {
                        money_format: "{{amount_no_decimals_with_comma_separator}}",
                        money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft"
                    },
                    ISK: {
                        money_format: "{{amount_no_decimals}} kr",
                        money_with_currency_format: "{{amount_no_decimals}} kr ISK"
                    },
                    INR: {
                        money_format: "Rs. {{amount}}",
                        money_with_currency_format: "Rs. {{amount}}"
                    },
                    IDR: {
                        money_format: "{{amount_with_comma_separator}}",
                        money_with_currency_format: "Rp {{amount_with_comma_separator}}"
                    },
                    ILS: {
                        money_format: "{{amount}} NIS",
                        money_with_currency_format: "{{amount}} NIS"
                    },
                    JMD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} JMD"
                    },
                    JPY: {
                        money_format: "&#165;{{amount_no_decimals}}",
                        money_with_currency_format: "&#165;{{amount_no_decimals}} JPY"
                    },
                    JEP: {
                        money_format: "&pound;{{amount}}",
                        money_with_currency_format: "&pound;{{amount}} JEP"
                    },
                    JOD: {
                        money_format: "{{amount}} JD",
                        money_with_currency_format: "{{amount}} JOD"
                    },
                    KZT: {
                        money_format: "{{amount}} KZT",
                        money_with_currency_format: "{{amount}} KZT"
                    },
                    KES: {
                        money_format: "KSh{{amount}}",
                        money_with_currency_format: "KSh{{amount}}"
                    },
                    KWD: {
                        money_format: "{{amount}} KD",
                        money_with_currency_format: "{{amount}} KWD"
                    },
                    KGS: {
                        money_format: "Ð»Ð²{{amount}}",
                        money_with_currency_format: "Ð»Ð²{{amount}}"
                    },
                    LVL: {
                        money_format: "Ls {{amount}}",
                        money_with_currency_format: "Ls {{amount}} LVL"
                    },
                    LBP: {
                        money_format: "L&pound;{{amount}}",
                        money_with_currency_format: "L&pound;{{amount}} LBP"
                    },
                    LTL: {
                        money_format: "{{amount}} Lt",
                        money_with_currency_format: "{{amount}} Lt"
                    },
                    MGA: {
                        money_format: "Ar {{amount}}",
                        money_with_currency_format: "Ar {{amount}} MGA"
                    },
                    MKD: {
                        money_format: "Ð´ÐµÐ½ {{amount}}",
                        money_with_currency_format: "Ð´ÐµÐ½ {{amount}} MKD"
                    },
                    MOP: {
                        money_format: "MOP${{amount}}",
                        money_with_currency_format: "MOP${{amount}}"
                    },
                    MVR: {
                        money_format: "Rf{{amount}}",
                        money_with_currency_format: "Rf{{amount}} MRf"
                    },
                    MXN: {
                        money_format: "$ {{amount}}",
                        money_with_currency_format: "$ {{amount}} MXN"
                    },
                    MYR: {
                        money_format: "RM{{amount}} MYR",
                        money_with_currency_format: "RM{{amount}} MYR"
                    },
                    MUR: {
                        money_format: "Rs {{amount}}",
                        money_with_currency_format: "Rs {{amount}} MUR"
                    },
                    MDL: {
                        money_format: "{{amount}} MDL",
                        money_with_currency_format: "{{amount}} MDL"
                    },
                    MAD: {
                        money_format: "{{amount}} dh",
                        money_with_currency_format: "Dh {{amount}} MAD"
                    },
                    MNT: {
                        money_format: "{{amount_no_decimals}} &#8366",
                        money_with_currency_format: "{{amount_no_decimals}} MNT"
                    },
                    MZN: {
                        money_format: "{{amount}} Mt",
                        money_with_currency_format: "Mt {{amount}} MZN"
                    },
                    NAD: {
                        money_format: "N${{amount}}",
                        money_with_currency_format: "N${{amount}} NAD"
                    },
                    NPR: {
                        money_format: "Rs{{amount}}",
                        money_with_currency_format: "Rs{{amount}} NPR"
                    },
                    ANG: {
                        money_format: "&fnof;{{amount}}",
                        money_with_currency_format: "{{amount}} NA&fnof;"
                    },
                    NZD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} NZD"
                    },
                    NIO: {
                        money_format: "C${{amount}}",
                        money_with_currency_format: "C${{amount}} NIO"
                    },
                    NGN: {
                        money_format: "&#8358;{{amount}}",
                        money_with_currency_format: "&#8358;{{amount}} NGN"
                    },
                    NOK: {
                        money_format: "kr {{amount_with_comma_separator}}",
                        money_with_currency_format: "kr {{amount_with_comma_separator}} NOK"
                    },
                    OMR: {
                        money_format: "{{amount_with_comma_separator}} OMR",
                        money_with_currency_format: "{{amount_with_comma_separator}} OMR"
                    },
                    PKR: {
                        money_format: "Rs.{{amount}}",
                        money_with_currency_format: "Rs.{{amount}} PKR"
                    },
                    PGK: {
                        money_format: "K {{amount}}",
                        money_with_currency_format: "K {{amount}} PGK"
                    },
                    PYG: {
                        money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
                        money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
                    },
                    PEN: {
                        money_format: "S/. {{amount}}",
                        money_with_currency_format: "S/. {{amount}} PEN"
                    },
                    PHP: {
                        money_format: "&#8369;{{amount}}",
                        money_with_currency_format: "&#8369;{{amount}} PHP"
                    },
                    PLN: {
                        money_format: "{{amount_with_comma_separator}} zl",
                        money_with_currency_format: "{{amount_with_comma_separator}} zl PLN"
                    },
                    QAR: {
                        money_format: "QAR {{amount_with_comma_separator}}",
                        money_with_currency_format: "QAR {{amount_with_comma_separator}}"
                    },
                    RON: {
                        money_format: "{{amount_with_comma_separator}} lei",
                        money_with_currency_format: "{{amount_with_comma_separator}} lei RON"
                    },
                    RUB: {
                        money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
                        money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
                    },
                    RWF: {
                        money_format: "{{amount_no_decimals}} RF",
                        money_with_currency_format: "{{amount_no_decimals}} RWF"
                    },
                    WST: {
                        money_format: "WS$ {{amount}}",
                        money_with_currency_format: "WS$ {{amount}} WST"
                    },
                    SAR: {
                        money_format: "{{amount}} SR",
                        money_with_currency_format: "{{amount}} SAR"
                    },
                    STD: {
                        money_format: "Db {{amount}}",
                        money_with_currency_format: "Db {{amount}} STD"
                    },
                    RSD: {
                        money_format: "{{amount}} RSD",
                        money_with_currency_format: "{{amount}} RSD"
                    },
                    SCR: {
                        money_format: "Rs {{amount}}",
                        money_with_currency_format: "Rs {{amount}} SCR"
                    },
                    SGD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} SGD"
                    },
                    SYP: {
                        money_format: "S&pound;{{amount}}",
                        money_with_currency_format: "S&pound;{{amount}} SYP"
                    },
                    ZAR: {
                        money_format: "R {{amount}}",
                        money_with_currency_format: "R {{amount}} ZAR"
                    },
                    KRW: {
                        money_format: "&#8361;{{amount_no_decimals}}",
                        money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW"
                    },
                    LKR: {
                        money_format: "Rs {{amount}}",
                        money_with_currency_format: "Rs {{amount}} LKR"
                    },
                    SEK: {
                        money_format: "{{amount_no_decimals}} kr",
                        money_with_currency_format: "{{amount_no_decimals}} kr SEK"
                    },
                    CHF: {
                        money_format: "{{amount}} CHF",
                        money_with_currency_format: "{{amount}} CHF"
                    },
                    TWD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} TWD"
                    },
                    THB: {
                        money_format: "{{amount}} &#xe3f;",
                        money_with_currency_format: "{{amount}} &#xe3f; THB"
                    },
                    TZS: {
                        money_format: "{{amount}} TZS",
                        money_with_currency_format: "{{amount}} TZS"
                    },
                    TTD: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}} TTD"
                    },
                    TND: {
                        money_format: "{{amount}}",
                        money_with_currency_format: "{{amount}} DT"
                    },
                    TRY: {
                        money_format: "{{amount}}TL",
                        money_with_currency_format: "{{amount}}TL"
                    },
                    UGX: {
                        money_format: "Ush {{amount_no_decimals}}",
                        money_with_currency_format: "Ush {{amount_no_decimals}} UGX"
                    },
                    UAH: {
                        money_format: "₴{{amount}}",
                        money_with_currency_format: "{{amount}} UAH"
                    },
                    AED: {
                        money_format: "Dhs. {{amount}}",
                        money_with_currency_format: "Dhs. {{amount}} AED"
                    },
                    UYU: {
                        money_format: "${{amount_with_comma_separator}}",
                        money_with_currency_format: "${{amount_with_comma_separator}} UYU"
                    },
                    VUV: {
                        money_format: "${{amount}}",
                        money_with_currency_format: "${{amount}}VT"
                    },
                    VEF: {
                        money_format: "Bs. {{amount_with_comma_separator}}",
                        money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF"
                    },
                    VND: {
                        money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
                        money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND"
                    },
                    XBT: {
                        money_format: "{{amount_no_decimals}} BTC",
                        money_with_currency_format: "{{amount_no_decimals}} BTC"
                    },
                    XOF: {
                        money_format: "CFA{{amount}}",
                        money_with_currency_format: "CFA{{amount}} XOF"
                    },
                    ZMW: {
                        money_format: "K{{amount_no_decimals_with_comma_separator}}",
                        money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}"
                    }
                }, n = window.theme.shopCurrency, o = document.querySelector(".currency-selector").value;
                (e || document).querySelectorAll("[data-money-convertible]").forEach(function(e) {
                    if (e.hasAttribute("data-currency-" + n) || e.setAttribute("data-currency-" + n, e.innerHTML), 
                    e.getAttribute("data-currency") !== o) {
                        var s = e.getAttribute("data-currency-" + n);
                        if (e.hasAttribute("data-currency-" + o)) e.innerHTML = e.getAttribute("data-currency-" + o); else {
                            var a = i[o][window.theme.currencyConversionMoneyFormat] || "{{amount}}";
                            -1 !== window.theme.moneyFormat.indexOf("with_comma_separator") && (s = s.replace(/[,.]/g, function(e) {
                                return "," === e ? "." : ",";
                            }));
                            var r = window.Currency.convert(100 * parseFloat(s.replace(/^[^0-9]+|[^0-9.]/g, "", ""), 10), n, o);
                            window.theme.currencyConversionRoundAmounts && (r = 100 * Math.round(r / 100));
                            var l = t.formatMoney(r, a);
                            e.innerHTML = l, e.setAttribute("data-currency-" + o, l);
                        }
                        e.setAttribute("data-currency", o);
                    }
                }), localStorage.setItem("currency", o);
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e() {
            _classCallCheck(this, e);
        }
        return _createClass(e, null, [ {
            key: "serialize",
            value: function(t) {
                function i(e, t) {
                    var n = e.lastIndexOf("[");
                    if (-1 === n) {
                        var o = {};
                        return o[e] = t, o;
                    }
                    var s = e.substr(0, n), a = {};
                    return a[e.substring(n + 1, e.length - 1)] = t, i(s, a);
                }
                for (var n = {}, o = 0, s = t.elements.length; o < s; o++) {
                    var a = t.elements[o];
                    if ("" !== a.name && !a.disabled && (a.name && !a.disabled && (a.checked || /select|textarea/i.test(a.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(a.type)))) {
                        var r = i(a.name, a.value);
                        n = e.extend(n, r);
                    }
                }
                return n;
            }
        }, {
            key: "extend",
            value: function() {
                for (var t = {}, i = 0, n = function(i) {
                    for (var n in i) i.hasOwnProperty(n) && ("[object Object]" === Object.prototype.toString.call(i[n]) ? t[n] = e.extend(t[n], i[n]) : t[n] = i[n]);
                }; i < arguments.length; i++) n(arguments[i]);
                return t;
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e() {
            _classCallCheck(this, e);
        }
        return _createClass(e, null, [ {
            key: "getSiblings",
            value: function(e, t) {
                for (var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = [], o = e; o = o.previousElementSibling; ) t && !o.matches(t) || n.push(o);
                for (i && n.push(e), o = e; o = o.nextElementSibling; ) t && !o.matches(t) || n.push(o);
                return n;
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(10), o = i(17), s = i(19), a = i(18), r = i(0), l = function() {
        function e(t) {
            var i = this;
            if (_classCallCheck(this, e), this.element = t, this.delegateElement = new domDelegate.Delegate(this.element), 
            this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this._createCarousel(), 
            this._initShopifyReviews(), this.options.isQuickView && this.options.showPaymentButton && window.Shopify.PaymentButton && Shopify.PaymentButton.init(), 
            this.productVariants = new a.default(this.element, this.options), this.options.showShippingEstimator && (this.shippingEstimator = new n.default(this.element.querySelector(".shipping-estimator"), {
                singleProduct: !0
            })), this.options.showQuantitySelector && (this.quantityPicker = new s.default(this.element.querySelector('select[name="quantity"]'))), 
            this.options.enableImageZoom) {
                this.driftObjects = [];
                var l = this.element.querySelector(".product__zoom-wrapper");
                r.default.matchesBreakpoint("supports-hover") && this.element.querySelectorAll(".product-gallery__image").forEach(function(e) {
                    i.driftObjects.push(new Drift(e, {
                        containInline: "outside" === i.options.zoomEffect,
                        inlinePane: window.innerWidth < 1024 || "outside" !== i.options.zoomEffect,
                        hoverBoundingBox: "outside" === i.options.zoomEffect,
                        handleTouch: !1,
                        inlineOffsetY: window.innerWidth < 1024 ? -85 : 0,
                        paneContainer: l
                    }));
                });
            }
            var c = this.element.querySelector(".product-block-list__item--info .card");
            c && (this.element.querySelector(".product-block-list__wrapper").style.minHeight = c.clientHeight + "px", 
            this.options.infoOverflowScroll && (this.infoOverflowScroller = new o.default(c, {
                offsetTop: document.documentElement.style.getPropertyValue("--header-is-sticky") * parseInt(document.documentElement.style.getPropertyValue("--header-height") + 30),
                offsetBottom: 30
            }))), this._attachListeners();
        }
        return _createClass(e, [ {
            key: "onUnload",
            value: function() {
                this.productVariants.destroy(), this.flickityInstance && this.flickityInstance.destroy(), 
                this.options.showShippingEstimator && this.shippingEstimator.destroy(), this.options.infoOverflowScroll && this.infoOverflowScroller.destroy(), 
                this.options.enableImageZoom && (this.driftObjects.forEach(function(e) {
                    e.destroy();
                }), document.querySelectorAll(".drift-bounding-box, .drift-zoom-pane").forEach(function(e) {
                    e.remove();
                })), this.delegateElement.off(), this.element.removeEventListener("variant:changed", this._onVariantChangedListener);
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this._onVariantChangedListener = this._onVariantChanged.bind(this), this.element.addEventListener("variant:changed", this._onVariantChangedListener);
            }
        }, {
            key: "_initShopifyReviews",
            value: function() {
                var e = this;
                Shopify.designMode && window.SPR && (window.SPR.initDomEls(), window.SPR.loadBadges(), 
                window.SPR.loadProducts()), window.SPRCallbacks = {}, window.SPRCallbacks.onFormSuccess = function() {
                    e.element.querySelector("#shopify-product-reviews .spr-form").classList.add("spr-form-submitted");
                }, this.options.isQuickView && window.SPR && (window.SPR.initDomEls(), window.SPR.loadBadges(), 
                this.options.showPaymentButton && window.Shopify.PaymentButton && Shopify.PaymentButton.init());
            }
        }, {
            key: "_createCarousel",
            value: function() {
                var e = this;
                if (this.productGalleryElement = this.element.querySelector(".product-gallery__carousel"), 
                this.productGalleryCellsElements = this.productGalleryElement ? this.productGalleryElement.querySelectorAll(".product-gallery__carousel-item") : [], 
                this.productGalleryElement && parseInt(this.productGalleryElement.getAttribute("data-image-count")) > 1) {
                    var t = [].slice.call(this.productGalleryCellsElements).filter(function(e) {
                        return !e.classList.contains("is-filtered");
                    }), i = 0;
                    t.forEach(function(t, n) {
                        t.getAttribute("data-image-id") === e.productGalleryElement.getAttribute("data-initial-image-id") && (i = n);
                    }), this.flickityInstance = new Flickity(this.productGalleryElement, {
                        prevNextButtons: !0,
                        pageDots: !1,
                        adaptiveHeight: !0,
                        fade: "fade" === this.options.galleryTransitionEffect,
                        cellSelector: ".product-gallery__carousel-item:not(.is-filtered)",
                        initialIndex: i,
                        freeScroll: !0,
                        wrapAround: !0
                    });
                }
                this.productThumbnailsListElement = this.element.querySelector(".product-gallery__thumbnail-list"), 
                this.productThumbnailsListElement && this.flickityInstance && (this.productThumbnailsCellsElements = this.productThumbnailsListElement.querySelectorAll(".product-gallery__thumbnail"), 
                this.delegateElement.on("click", ".product-gallery__thumbnail", this._onThumbnailClicked.bind(this)), 
                this.flickityInstance.on("select", this._onGallerySlideChanged.bind(this)), this._onGallerySlideChanged(!1));
            }
        }, {
            key: "_onGallerySlideChanged",
            value: function() {
                var e = this, t = (!(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], 
                null), i = null;
                if (this.productThumbnailsCellsElements.forEach(function(n) {
                    n.classList.contains("is-nav-selected") && (t = n), n.getAttribute("data-image-id") === e.flickityInstance.selectedElement.getAttribute("data-image-id") && (i = n);
                }), t.classList.remove("is-nav-selected"), i.classList.add("is-nav-selected"), r.default.matchesBreakpoint("pocket")) i.offsetLeft, 
                this.productThumbnailsListElement.parentNode.clientWidth, i.clientWidth; else i.offsetTop, 
                this.productThumbnailsListElement.clientHeight, i.clientHeight;
            }
        }, {
            key: "_onThumbnailClicked",
            value: function(e, t) {
                t.hasAttribute("data-media-position") ? this.flickityInstance.selectCell('[data-media-position="' + t.getAttribute("data-media-position") + '"]') : this.flickityInstance.selectCell('[data-image-id="' + t.getAttribute("data-image-id") + '"]');
            }
        }, {
            key: "_onVariantChanged",
            value: function(e) {
                var t = this, i = e.detail.variant, n = !1;
                fastdom.mutate(function() {
                    t.productGalleryCellsElements.forEach(function(e, o) {
                        if (e.hasAttribute("data-group-name")) {
                            var s = e.getAttribute("data-group-name");
                            t.options.productOptions.forEach(function(n, a) {
                                n.toLowerCase() === s && (i["option" + (a + 1)].toLowerCase() === e.getAttribute("data-group-value") || i.featured_image && i.featured_image.id === parseInt(e.getAttribute("data-image-id")) ? (e.classList.remove("is-filtered"), 
                                t.productThumbnailsCellsElements[o].classList.remove("is-filtered")) : (e.classList.add("is-filtered"), 
                                t.productThumbnailsCellsElements[o].classList.add("is-filtered")));
                            }), n = !0;
                        }
                    }), n && (t.flickityInstance.deactivate(), t.flickityInstance.activate()), i && i.featured_image && t.flickityInstance.selectCell('[data-image-id="' + i.featured_image.id + '"]');
                });
            }
        } ]), e;
    }();
    t.default = l;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = {}, o = function() {
        function e() {
            _classCallCheck(this, e);
        }
        return _createClass(e, null, [ {
            key: "slideUp",
            value: function(e, t) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "height";
                e.style[i] = e.scrollHeight + "px", e.offsetHeight, e.style[i] = 0, n[e.id] && (e.removeEventListener("transitionend", n[e.id]), 
                delete n[e.id]);
                e.addEventListener("transitionend", function i(n) {
                    "height" === n.propertyName && (e.removeEventListener("transitionend", i), (t || function() {})());
                });
            }
        }, {
            key: "slideDown",
            value: function(e, t) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "height";
                e.style[i] = e.scrollHeight + "px";
                var o = function o(s) {
                    if (s.propertyName === i) {
                        var a = "auto";
                        "max-height" === i && (a = "none"), e.style[i] = a, e.removeEventListener("transitionend", o), 
                        delete n[e.id], (t || function() {})();
                    }
                };
                e.addEventListener("transitionend", o), n[e.id] = o;
            }
        } ]), e;
    }();
    t.default = o;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.delegateElement = new domDelegate.Delegate(this.element), 
            this._attachListeners(), this.recalculateSwatches();
        }
        return _createClass(e, [ {
            key: "destroy",
            value: function() {
                this.delegateElement.off(), window.removeEventListener("resize", this._recalculateSwatchesListener);
            }
        }, {
            key: "recalculateSwatches",
            value: function() {
                var e = this;
                fastdom.measure(function() {
                    e.element.querySelectorAll(".product-item__swatch-list").forEach(function(e) {
                        var t = e.clientWidth, i = parseInt(Math.min(t, 200)), n = Math.floor(i / 30);
                        fastdom.mutate(function() {
                            var t = e.querySelectorAll(".color-swatch");
                            t.forEach(function(e, i) {
                                e.classList.remove("color-swatch--view-more"), n === i + 1 && n !== t.length && e.classList.add("color-swatch--view-more");
                            });
                        });
                    });
                });
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this._recalculateSwatchesListener = this.recalculateSwatches.bind(this), this.delegateElement.on("change", ".product-item__swatch-list .color-swatch__radio", this._colorChanged.bind(this)), 
                window.addEventListener("resize", this._recalculateSwatchesListener);
            }
        }, {
            key: "_colorChanged",
            value: function(e, t) {
                var i = t.closest(".product-item"), n = t.getAttribute("data-variant-url");
                i.querySelector(".product-item__image-wrapper").setAttribute("href", n), i.querySelector(".product-item__title").setAttribute("href", n);
                var o = i.querySelector(".product-item__primary-image");
                if (t.hasAttribute("data-image-url") && t.getAttribute("data-image-id") !== o.getAttribute("data-image-id")) {
                    var s = document.createElement("img");
                    s.className = "product-item__primary-image lazyload image--fade-in", s.setAttribute("data-image-id", t.getAttribute("data-image-id")), 
                    s.setAttribute("data-src", t.getAttribute("data-image-url")), s.setAttribute("data-widths", t.getAttribute("data-image-widths")), 
                    s.setAttribute("data-sizes", "auto"), o.parentNode.style.paddingBottom = 100 / s.getAttribute("data-image-aspect-ratio") + "%", 
                    o.parentNode.replaceChild(s, o);
                }
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(0), o = function() {
        function e(t) {
            var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            _classCallCheck(this, e), this.id = t, this.delegateRoot = new domDelegate.Delegate(document.documentElement), 
            this.isOpen = !1, this.togglerElement = document.querySelector('[data-action="open-value-picker"][aria-controls="' + this.id + '"]'), 
            this.onSelect = i.onValueSelect || function() {}, this._attachListeners();
        }
        return _createClass(e, [ {
            key: "destroy",
            value: function() {
                this.delegateRoot.off();
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this.delegateRoot.on("click", '[data-action="open-value-picker"][aria-controls="' + this.id + '"]', this._toggle.bind(this)), 
                this.delegateRoot.on("click", '[data-action="close-value-picker"][aria-controls="' + this.id + '"]', this._toggle.bind(this)), 
                this.delegateRoot.on("click", "#" + this.id + ' [data-action="select-value"]', this._selectValue.bind(this)), 
                this.delegateRoot.on("click", this._detectOutsideClick.bind(this), !0);
            }
        }, {
            key: "_toggle",
            value: function(e) {
                this.isOpen ? this._close(e) : this._open(e);
            }
        }, {
            key: "_open",
            value: function(e) {
                (document.querySelector('[data-action="open-value-picker"][aria-controls="' + this.id + '"]').setAttribute("aria-expanded", "true"), 
                document.getElementById(this.id).setAttribute("aria-hidden", "false"), n.default.matchesBreakpoint("phone")) && (document.getElementById("shopify-section-header").style.zIndex = "3");
                this.isOpen = !0;
            }
        }, {
            key: "_close",
            value: function(e) {
                document.querySelector('[data-action="open-value-picker"][aria-controls="' + this.id + '"]').setAttribute("aria-expanded", "false"), 
                document.getElementById(this.id).setAttribute("aria-hidden", "true"), document.getElementById("shopify-section-header").style.zIndex = "", 
                this.isOpen = !1;
            }
        }, {
            key: "_selectValue",
            value: function(e, t) {
                this.onSelect(t.getAttribute("data-value")), this._close();
            }
        }, {
            key: "_detectOutsideClick",
            value: function(e) {
                this.isOpen && this.togglerElement !== e.target && !this.togglerElement.contains(e.target) && !e.target.closest(".value-picker__inner") && this.isOpen && this._close(e);
            }
        } ]), e;
    }();
    t.default = o;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e() {
            _classCallCheck(this, e);
        }
        return _createClass(e, null, [ {
            key: "trapFocus",
            value: function(e, t) {
                this.listeners = this.listeners || {};
                var i = e.querySelector("[autofocus]") || e;
                e.setAttribute("tabindex", "-1"), i.focus(), this.listeners[t] = function(t) {
                    e === t.target || e.contains(t.target) || i.focus();
                }, document.addEventListener("focusin", this.listeners[t]);
            }
        }, {
            key: "removeTrapFocus",
            value: function(e, t) {
                e && e.removeAttribute("tabindex"), document.removeEventListener("focusin", this.listeners[t]);
            }
        }, {
            key: "clearTrapFocus",
            value: function() {
                for (var e in this.listeners) this.listeners.hasOwnProperty(e) && document.removeEventListener("focusin", this.listeners[e]);
                this.listeners = {};
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e(t, i) {
            _classCallCheck(this, e), this.countrySelect = t, this.provinceSelect = i, this.countrySelect && this.provinceSelect && (this._attachListeners(), 
            this._initSelectors());
        }
        return _createClass(e, [ {
            key: "destroy",
            value: function() {
                this.countrySelect && this.countrySelect.removeEventListener("change", this._onCountryChangedListener);
            }
        }, {
            key: "_initSelectors",
            value: function() {
                var e = this.countrySelect.getAttribute("data-default");
                if (e) {
                    for (var t = 0; t !== this.countrySelect.options.length; ++t) if (this.countrySelect.options[t].text === e) {
                        this.countrySelect.selectedIndex = t;
                        break;
                    }
                } else this.countrySelect.selectedIndex = 0;
                var i = new Event("change", {
                    bubbles: !0
                });
                this.countrySelect.dispatchEvent(i);
                var n = this.provinceSelect.getAttribute("data-default");
                n && (this.provinceSelect.value = n);
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this._onCountryChangedListener = this._onCountryChanged.bind(this), this.countrySelect.addEventListener("change", this._onCountryChangedListener);
            }
        }, {
            key: "_onCountryChanged",
            value: function() {
                var e = this, t = this.countrySelect.options[this.countrySelect.selectedIndex];
                if (t) {
                    var i = JSON.parse(t.getAttribute("data-provinces") || "[]");
                    this.provinceSelect.innerHTML = "", 0 !== i.length ? (i.forEach(function(t) {
                        e.provinceSelect.options.add(new Option(t[1], t[0]));
                    }), this.provinceSelect.closest(".form__input-wrapper").style.display = "block") : this.provinceSelect.closest(".form__input-wrapper").style.display = "none";
                }
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(9), o = i(1), s = i(2), a = function() {
        function e(t, i) {
            _classCallCheck(this, e), this.element = t, this.delegateElement = new domDelegate.Delegate(this.element), 
            this.options = i, this.countrySelector = new n.default(this.element.querySelector('[name="country"]'), this.element.querySelector('[name="province"]')), 
            this._attachListeners();
        }
        return _createClass(e, [ {
            key: "destroy",
            value: function() {
                this.delegateElement.off("click"), this.countrySelector.destroy();
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this.delegateElement.on("click", '[data-action="estimate-shipping"]', this._fetchRates.bind(this));
            }
        }, {
            key: "_fetchRates",
            value: function() {
                document.dispatchEvent(new CustomEvent("theme:loading:start")), this.options.singleProduct ? this._fetchRatesForProduct() : this._fetchRatesForCart();
            }
        }, {
            key: "_fetchRatesForCart",
            value: function() {
                var e = this, t = this.element.querySelector('[name="country"]').value, i = this.element.querySelector('[name="province"]').value, n = this.element.querySelector('[name="zip"]').value;
                fetch(window.theme.localeRootUrl + "/cart/shipping_rates.json?shipping_address[zip]=" + n + "&shipping_address[country]=" + t + "&shipping_address[province]=" + i, {
                    credentials: "same-origin",
                    method: "GET"
                }).then(function(t) {
                    document.dispatchEvent(new CustomEvent("theme:loading:end")), t.json().then(function(i) {
                        e._formatResults(t.ok, i);
                    });
                });
            }
        }, {
            key: "_fetchRatesForProduct",
            value: function() {
                var e = this, t = this._getCookie("cart"), i = "temp-cart-cookie___" + Date.now() + parseInt(1e3 * Math.random()), n = "fake-cart-cookie___" + Date.now() + parseInt(1e3 * Math.random());
                if (t || (this._updateCartCookie(i), t = this._getCookie("cart")), !(t.length < 32)) {
                    this._updateCartCookie(n);
                    var o = document.querySelector('form[action*="/cart/add"]');
                    fetch(window.theme.localeRootUrl + "/cart/add.js", {
                        body: JSON.stringify(s.default.serialize(o)),
                        credentials: "same-origin",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest"
                        },
                        method: "POST"
                    }).then(function(i) {
                        i.json().then(function() {
                            var i = e.element.querySelector('[name="country"]').value, n = e.element.querySelector('[name="province"]').value, o = e.element.querySelector('[name="zip"]').value;
                            fetch(window.theme.localeRootUrl + "/cart/shipping_rates.json?shipping_address[zip]=" + o + "&shipping_address[country]=" + i + "&shipping_address[province]=" + n, {
                                credentials: "same-origin",
                                method: "GET"
                            }).then(function(i) {
                                document.dispatchEvent(new CustomEvent("theme:loading:end")), i.json().then(function(t) {
                                    e._formatResults(i.ok, t);
                                }), e._updateCartCookie(t);
                            }).catch(function() {
                                e._updateCartCookie(t);
                            });
                        }).catch(function() {
                            e._updateCartCookie(t), document.dispatchEvent(new CustomEvent("theme:loading:end"));
                        });
                    });
                }
            }
        }, {
            key: "_formatResults",
            value: function(e, t) {
                var i = this.element.querySelector(".shipping-estimator__results");
                if (i.innerHTML = "", e) {
                    var n = t.shipping_rates;
                    if (0 === n.length) i.innerHTML = "<p>" + window.languages.shippingEstimatorNoResults + "</p>"; else {
                        1 === n.length ? i.innerHTML = "<p>" + window.languages.shippingEstimatorOneResult + "</p>" : i.innerHTML = "<p>" + window.languages.shippingEstimatorMultipleResults.replace("{{count}}", n.length) + "</p>";
                        var s = "";
                        n.forEach(function(e) {
                            s += "<li>" + e.name + ": " + o.default.formatMoney(e.price, window.theme.moneyFormat) + "</li>";
                        }), i.innerHTML += "<ul>" + s + "</ul>";
                    }
                } else {
                    i.innerHTML = "<p>" + window.languages.shippingEstimatorErrors + "</p>";
                    var a = "";
                    Object.keys(t).forEach(function(e) {
                        a += '<li class="alert__list-item">' + e + " " + t[e] + "</li>";
                    }), i.innerHTML += "<ul>" + a + "</ul>";
                }
                i.style.display = "block";
            }
        }, {
            key: "_getCookie",
            value: function(e) {
                var t = ("; " + document.cookie).split("; " + e + "=");
                if (2 === t.length) return t.pop().split(";").shift();
            }
        }, {
            key: "_updateCartCookie",
            value: function(e) {
                var t = new Date();
                t.setTime(t.getTime() + 12096e5), document.cookie = "cart=" + e + "; expires=" + t.toUTCString() + "; path=/";
            }
        } ]), e;
    }();
    t.default = a;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(0), o = i(1), s = function() {
        function e(t, i) {
            _classCallCheck(this, e), this.element = t, this.delegateElement = new domDelegate.Delegate(this.element), 
            this.delegateRoot = new domDelegate.Delegate(document.documentElement), this.options = i, 
            this.miniCartElement = this.element.querySelector(".mini-cart"), this.isMiniCartOpen = !1, 
            "cart" !== window.theme.template && this.miniCartElement && (this.miniCartToggleElement = this.element.querySelector('[aria-controls="' + this.miniCartElement.id + '"]'), 
            this._checkMiniCartScrollability()), this.itemCount = window.theme.cartCount, this._attachListeners();
        }
        return _createClass(e, [ {
            key: "destroy",
            value: function() {
                this.delegateElement.off(), this.delegateRoot.off(), window.removeEventListener("resize", this._calculateMiniCartHeightListener);
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this._calculateMiniCartHeightListener = this._calculateMiniCartHeight.bind(this), 
                "cart" !== window.theme.template && (this.delegateElement.on("click", '[data-action="toggle-mini-cart"]', this._toggleMiniCart.bind(this)), 
                this.delegateRoot.on("click", this._onClick.bind(this)), window.addEventListener("resize", this._calculateMiniCartHeightListener)), 
                this.delegateRoot.on("click", '[data-action="decrease-quantity"]', this._updateQuantity.bind(this)), 
                this.delegateRoot.on("click", '[data-action="increase-quantity"]', this._updateQuantity.bind(this)), 
                this.delegateRoot.on("change", ".quantity-selector__value", this._updateQuantity.bind(this)), 
                this.delegateRoot.on("keyup", ".quantity-selector__value", this._updateQuantitySize.bind(this)), 
                this.delegateRoot.on("product:added", this._onProductAdded.bind(this)), this.delegateRoot.on("cart:refresh", this._onCartRefresh.bind(this));
            }
        }, {
            key: "_toggleMiniCart",
            value: function(e) {
                e && e.preventDefault(), this.isMiniCartOpen ? this._closeMiniCart() : this._openMiniCart();
            }
        }, {
            key: "_openMiniCart",
            value: function() {
                this.miniCartToggleElement.setAttribute("aria-expanded", "true"), "phone" === n.default.getCurrentBreakpoint() && this.miniCartToggleElement.querySelector(".header__cart-icon").setAttribute("aria-expanded", "true"), 
                this.miniCartElement.setAttribute("aria-hidden", "false"), this.isMiniCartOpen = !0, 
                this._calculateMiniCartHeight();
            }
        }, {
            key: "_closeMiniCart",
            value: function() {
                this.miniCartToggleElement.setAttribute("aria-expanded", "false"), "phone" === n.default.getCurrentBreakpoint() && (this.miniCartToggleElement.querySelector(".header__cart-icon").setAttribute("aria-expanded", "false"), 
                this.miniCartElement.style.maxHeight = ""), this.miniCartElement.setAttribute("aria-hidden", "true"), 
                this.isMiniCartOpen = !1;
            }
        }, {
            key: "_calculateMiniCartHeight",
            value: function() {
                if ("phone" === n.default.getCurrentBreakpoint()) if (this.isMiniCartOpen) {
                    var e = window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom;
                    this.miniCartElement.style.maxHeight = e + "px";
                    var t = this.miniCartElement.querySelector(".mini-cart__content"), i = this.miniCartElement.querySelector(".mini-cart__recap");
                    i && (t.style.maxHeight = e - i.clientHeight + "px");
                } else this.miniCartElement.style.maxHeight = "", this.miniCartElement.querySelector(".mini-cart__content").style.maxHeight = ""; else this.miniCartElement.style.maxHeight = "", 
                this.miniCartElement.querySelector(".mini-cart__content").style.maxHeight = "";
            }
        }, {
            key: "_updateQuantity",
            value: function(e, t) {
                var i = this, n = 1;
                n = "INPUT" === t.tagName ? parseInt(t.value) : parseInt(t.getAttribute("data-quantity")), 
                document.dispatchEvent(new CustomEvent("theme:loading:start")), fetch(window.theme.localeRootUrl + "/cart/change.js", {
                    body: JSON.stringify({
                        id: t.getAttribute("data-line-id"),
                        quantity: n
                    }),
                    credentials: "same-origin",
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Requested-With": "XMLHttpRequest"
                    }
                }).then(function(e) {
                    e.json().then(function(e) {
                        i.itemCount = e.item_count, i._rerender(!1).then(function() {
                            document.dispatchEvent(new CustomEvent("theme:loading:end"));
                        }), jQuery(".header__cart-count").text(i.itemCount);
                    });
                }), e.preventDefault();
            }
        }, {
            key: "_updateQuantitySize",
            value: function(e, t) {
                t.setAttribute("size", Math.max(t.value.length, 2));
            }
        }, {
            key: "_rerender",
            value: function() {
                var e = this, t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], i = "";
                return i = "cart" !== window.theme.template ? window.theme.localeRootUrl + "/cart?view=mini-cart&timestamp=" + Date.now() : window.theme.localeRootUrl + "/cart?timestamp=" + Date.now(), 
                fetch(i, {
                    credentials: "same-origin",
                    method: "GET"
                }).then(function(i) {
                    e.element.querySelector(".header__cart-count").textContent = e.itemCount, "cart" !== window.theme.template ? i.text().then(function(t) {
                        var i = document.createElement("div");
                        i.innerHTML = t;
                        var n = e.miniCartElement.querySelector(".mini-cart__line-item-list"), o = null;
                        n && (o = n.scrollTop), e.miniCartElement.innerHTML = i.querySelector(".mini-cart").innerHTML;
                        var s = e.miniCartElement.querySelector(".mini-cart__line-item-list");
                        s && null !== o && (s.scrollTop = o), e._checkMiniCartScrollability(), e._calculateMiniCartHeight(), 
                        e.element.dispatchEvent(new CustomEvent("cart:rerendered"));
                    }) : i.text().then(function(i) {
                        var n = document.createElement("div");
                        n.innerHTML = i, document.querySelector('[data-section-type="cart"]').innerHTML = n.querySelector('[data-section-type="cart"]').innerHTML, 
                        t && window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        }), window.SPR && (window.SPR.initDomEls(), window.SPR.loadBadges()), e.element.dispatchEvent(new CustomEvent("cart:rerendered", {
                            bubbles: !0
                        }));
                    }), window.theme.currencyConversionEnabled && o.default.convertAll(e.element);
                });
            }
        }, {
            key: "_checkMiniCartScrollability",
            value: function() {
                var e = this.miniCartElement.querySelector(".mini-cart__line-item-list");
                e && e.scrollHeight > e.clientHeight && e.classList.add("is-scrollable");
            }
        }, {
            key: "_onProductAdded",
            value: function(e) {
                var t = this;
                this.itemCount += e.detail.quantity, this._onCartRefresh().then(function() {
                    t.options.useStickyHeader && "cart" !== window.theme.template && t._openMiniCart();
                });
            }
        }, {
            key: "_onCartRefresh",
            value: function() {
                return this._rerender().then(function() {
                    document.dispatchEvent(new CustomEvent("theme:loading:end"));
                });
            }
        }, {
            key: "_onClick",
            value: function(e) {
                this.miniCartElement && !this.element.contains(e.target) && this._closeMiniCart();
            }
        } ]), e;
    }();
    t.default = s;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = document.getElementById("mobile-collection-filters"), 
            this.delegateRoot = new domDelegate.Delegate(document.documentElement), this.options = t, 
            this.element && this._attachListeners();
        }
        return _createClass(e, [ {
            key: "destroy",
            value: function() {
                this.delegateRoot.off();
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this.delegateRoot.on("click", '[aria-controls="mobile-collection-filters"][data-action="open-drawer"]', this.open.bind(this)), 
                this.delegateRoot.on("click", '#mobile-collection-filters [data-action="close-drawer"]', this.close.bind(this)), 
                document.addEventListener("collection-filter:close", this.close.bind(this)), document.addEventListener("click", this._detectOutsideClick.bind(this)), 
                window.addEventListener("resize", this._computeDrawerHeight.bind(this));
            }
        }, {
            key: "open",
            value: function(e) {
                e && e.stopPropagation(), this._computeDrawerHeight(), document.querySelector('[aria-controls="mobile-collection-filters"]').setAttribute("aria-expanded", "true"), 
                document.getElementById("mobile-collection-filters").setAttribute("aria-hidden", "false");
            }
        }, {
            key: "close",
            value: function(e) {
                e && e.stopPropagation(), document.querySelector('[aria-controls="mobile-collection-filters"]').setAttribute("aria-expanded", "false"), 
                document.getElementById("mobile-collection-filters").setAttribute("aria-hidden", "true");
            }
        }, {
            key: "_computeDrawerHeight",
            value: function() {
                document.getElementById("mobile-collection-filters").querySelector(".collection-drawer").style.maxHeight = window.innerHeight + "px";
            }
        }, {
            key: "_filtersHaveChanged",
            value: function(e) {
                var t = this;
                this.element && fastdom.mutate(function() {
                    var i = t.element.querySelector(".collection-drawer__filter-count");
                    i.innerText = "(" + e.length + ")", i.style.display = 0 === e.length ? "none" : "inline", 
                    t.element.querySelector('[data-action="clear-tags"]').style.display = 0 === e.length ? "none" : "block", 
                    $("#filter-section").load(location.href + " #filter-section"), "group" === t.options.filterType && t.element.querySelectorAll(".collection__filter-item-active").forEach(function(e) {
                        var t = e.closest(".collection__filter-group").querySelector(".is-selected[data-tag]");
                        t ? (e.style.display = "block", e.innerText = t.getAttribute("data-tag-user")) : e.style.display = "none";
                    });
                });
            }
        }, {
            key: "_detectOutsideClick",
            value: function(e) {
                e.target.closest(".collection-drawer__inner") || this.close();
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(3), o = i(0), s = function() {
        function e(t, i, n) {
            _classCallCheck(this, e), this.element = t, this.delegateElement = new domDelegate.Delegate(this.element), 
            this.delegateRoot = new domDelegate.Delegate(document.documentElement), this.useInlineNavigation = "inline" === i, 
            this.isNavigationVisible = this.useInlineNavigation, this.openTrigger = n, o.default.matchesBreakpoint("supports-hover") || (this.openTrigger = "click"), 
            this.openItems = [], this.dropdownActivationTimeouts = {}, this.dropdownDeactivationTimeouts = {}, 
            this.DROPDOWN_TIMEOUT = 180, this._attachListeners(), this.useInlineNavigation && this._setupInlineNavigation();
        }
        return _createClass(e, [ {
            key: "destroy",
            value: function() {
                this.delegateElement.off(), this.delegateRoot.off();
            }
        }, {
            key: "onBlockSelect",
            value: function(e) {
                var t = this;
                this.useInlineNavigation || this._openNavigation(), n.default.getSiblings(e.target.parentNode, ".is-dropdown-open").forEach(function(i) {
                    t._deactivateDropdown(e, i.querySelector('[role="menuitem"][aria-haspopup]'));
                }), this._activateDropdown(e, e.target.previousElementSibling);
            }
        }, {
            key: "onBlockDeselect",
            value: function(e) {
                this.useInlineNavigation || this._closeNavigation(), this._deactivateDropdown(e, e.target.parentNode);
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this.delegateElement.on("focusout", this._onFocusOut.bind(this)), this.delegateRoot.on("click", this._onClick.bind(this)), 
                this.delegateElement.on("click", '[data-action="toggle-menu"]', this._toggleNavigation.bind(this)), 
                "hover" === this.openTrigger ? (this.delegateElement.on("focusin", '[role="menuitem"][aria-haspopup]', this._activateDropdown.bind(this)), 
                this.delegateElement.on("mouseover", '[role="menuitem"][aria-haspopup]', this._activateDropdown.bind(this)), 
                this.delegateElement.on("mouseover", '[role="menu"][aria-hidden="false"]', this._blockDropdownDeactivation.bind(this)), 
                this.delegateElement.on("focusout", ".is-dropdown-open", this._deactivateDropdown.bind(this)), 
                this.delegateElement.on("mouseout", ".is-dropdown-open", this._deactivateDropdown.bind(this))) : this.delegateElement.on("click", '[role="menuitem"][aria-haspopup]', this._toggleDropdown.bind(this));
            }
        }, {
            key: "_onFocusOut",
            value: function(e) {
                null === e.relatedTarget || this.element.contains(e.relatedTarget) || this._closeNavigation();
            }
        }, {
            key: "_onClick",
            value: function(e) {
                this.element.contains(e.target) || this._closeNavigation();
            }
        }, {
            key: "_openNavigation",
            value: function() {
                this.useInlineNavigation || (this.element.querySelector('[data-action="toggle-menu"]').setAttribute("aria-expanded", "true"), 
                this.element.querySelector('[role="menu"]').setAttribute("aria-hidden", "false"), 
                this.isNavigationVisible = !0);
            }
        }, {
            key: "_closeNavigation",
            value: function() {
                var e = this;
                (this.useInlineNavigation || (this.element.querySelector('[data-action="toggle-menu"]').setAttribute("aria-expanded", "false"), 
                this.element.querySelector('[role="menu"]').setAttribute("aria-hidden", "true")), 
                this.isNavigationVisible = !1, "click" === this.openTrigger) && this.openItems.slice(0).forEach(function(t) {
                    e._deactivateDropdown(event, t);
                });
            }
        }, {
            key: "_toggleNavigation",
            value: function(e) {
                this.isNavigationVisible ? this._closeNavigation() : this._openNavigation();
            }
        }, {
            key: "_toggleDropdown",
            value: function(e, t) {
                "false" === t.getAttribute("aria-expanded") && e.preventDefault(), "true" === t.getAttribute("aria-expanded") ? "#" === t.getAttribute("href") && (e.preventDefault(), 
                this._deactivateDropdown(e, t.closest(".is-dropdown-open"))) : this._activateDropdown(e, t);
            }
        }, {
            key: "_activateDropdown",
            value: function(e, t) {}
        }, {
            key: "_deactivateDropdown",
            value: function(e, t) {}
        }, {
            key: "_blockDropdownDeactivation",
            value: function(e, t) {
                if (void 0 !== this.dropdownDeactivationTimeouts[t.id]) for (var i in clearTimeout(this.dropdownDeactivationTimeouts[t.id]), 
                delete this.dropdownDeactivationTimeouts[t.id], this.dropdownActivationTimeouts) this.dropdownActivationTimeouts.hasOwnProperty(i) && (clearTimeout(this.dropdownActivationTimeouts[i]), 
                delete this.dropdownActivationTimeouts[i]);
            }
        }, {
            key: "_setupMegaMenu",
            value: function(e) {
                if (!this.useInlineNavigation) {
                    var t = e.closest(".nav-dropdown").clientWidth;
                    e.style.maxWidth = Math.min(1400 - t, parseInt(window.innerWidth - t - 80)) + "px";
                }
            }
        }, {
            key: "_setupInlineNavigation",
            value: function() {
                this.element.querySelectorAll(".mega-menu").forEach(function(e) {
                    e.closest(".nav-bar__item").classList.add("nav-bar__item--static");
                });
            }
        } ]), e;
    }();
    t.default = s;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(0), o = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.delegateElement = new domDelegate.Delegate(this.element), 
            this.options = JSON.parse(t.getAttribute("data-popup-settings")), this.hasOpenOnceInCurrentPage = !1;
            try {
                "#exit-popup" === window.location.hash && this._openPopup();
            } catch (e) {}
            this._attachListeners();
        }
        return _createClass(e, [ {
            key: "destroy",
            value: function() {
                this.delegateElement.off();
            }
        }, {
            key: "_attachListeners",
            value: function() {
                var e = this;
                n.default.matchesBreakpoint("supports-hover") && (this.delegateElement.on("click", '[data-action="close-popup"]', this._closePopup.bind(this)), 
                document.addEventListener("mouseleave", function() {
                    e.hasOpenOnceInCurrentPage || (!e.options.showOnlyOnce || e.options.showOnlyOnce && null === localStorage.getItem("themeExitPopup")) && e._openPopup();
                }), this._clickOutsideListener = this._checkClickOutside.bind(this));
            }
        }, {
            key: "_openPopup",
            value: function() {
                window.theme.isNewsletterPopupOpen || (this.element.setAttribute("aria-hidden", "false"), 
                localStorage.setItem("themeExitPopup", "true"), this.hasOpenOnceInCurrentPage = !0, 
                window.theme.isExitPopupOpen = !0, this.delegateElement.on("click", this._clickOutsideListener));
            }
        }, {
            key: "_closePopup",
            value: function() {
                this.element.setAttribute("aria-hidden", "true"), window.theme.isExitPopupOpen = !1, 
                this.delegateElement.off("click", this._clickOutsideListener);
            }
        }, {
            key: "_checkClickOutside",
            value: function(e) {
                this.element.contains(e.target) && this.element !== e.target || this._closePopup();
            }
        } ]), e;
    }();
    t.default = o;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.delegateElement = new domDelegate.Delegate(this.element), 
            this.delegateRoot = new domDelegate.Delegate(document.documentElement), this.mobileMenuElement = this.element.querySelector(".mobile-menu"), 
            this.mobileMenuToggleElement = this.element.querySelector('[aria-controls="' + this.mobileMenuElement.id + '"]'), 
            this.isOpen = !1, this._attachListeners();
        }
        return _createClass(e, [ {
            key: "destroy",
            value: function() {
                this.delegateElement.off(), this.delegateRoot.off(), window.removeEventListener("resize", this._calculatMaxHeightListener);
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this._calculatMaxHeightListener = this._calculateMaxHeight.bind(this), this.delegateElement.on("click", '[data-action="toggle-menu"]', this._toggleMenu.bind(this)), 
                this.delegateElement.on("click", '[data-action="open-panel"]', this._openPanel.bind(this)), 
                this.delegateElement.on("click", '[data-action="close-panel"]', this._closePanel.bind(this)), 
                this.delegateRoot.on("click", this._onWindowClick.bind(this)), window.addEventListener("resize", this._calculatMaxHeightListener);
            }
        }, {
            key: "_toggleMenu",
            value: function() {
                this.isOpen = !this.isOpen, this.mobileMenuToggleElement.setAttribute("aria-expanded", this.isOpen ? "true" : "false"), 
                this.mobileMenuElement.setAttribute("aria-hidden", this.isOpen ? "false" : "true"), 
                this.isOpen ? this._calculateMaxHeight() : (this.mobileMenuElement.style.maxHeight = "", 
                this.element.querySelectorAll(".mobile-menu__panel.is-open").forEach(function(e) {
                    e.classList.remove("is-open");
                }));
            }
        }, {
            key: "_openPanel",
            value: function(e, t) {
                t.setAttribute("aria-expanded", "true"), this.element.querySelector("#" + t.getAttribute("aria-controls")).classList.add("is-open");
            }
        }, {
            key: "_closePanel",
            value: function(e, t) {
                var i = t.closest(".mobile-menu__panel.is-open");
                i.classList.remove("is-open"), this.element.querySelector('[aria-controls="' + i.id + '"]').setAttribute("aria-expanded", "false");
            }
        }, {
            key: "_calculateMaxHeight",
            value: function() {
                this.isOpen && (this.mobileMenuElement.style.maxHeight = window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom + "px");
            }
        }, {
            key: "_onWindowClick",
            value: function(e) {
                this.isOpen && !this.element.contains(e.target) && this._toggleMenu();
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.delegateElement = new domDelegate.Delegate(this.element), 
            this.options = JSON.parse(t.getAttribute("data-popup-settings"));
            try {
                "#newsletter-popup" === window.location.hash ? this._openPopup() : (!this.options.showOnlyOnce || this.options.showOnlyOnce && null === localStorage.getItem("themePopup")) && setTimeout(this._openPopup.bind(this), 1e3 * this.options.apparitionDelay);
            } catch (e) {}
            this._attachListeners();
        }
        return _createClass(e, [ {
            key: "destroy",
            value: function() {
                this.delegateElement.off();
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this.delegateElement.on("click", '[data-action="close-popup"]', this._closePopup.bind(this)), 
                this._clickOutsideListener = this._checkClickOutside.bind(this);
            }
        }, {
            key: "_openPopup",
            value: function() {
                window.theme.isExitPopupOpen || (this.element.setAttribute("aria-hidden", "false"), 
                localStorage.setItem("themePopup", "true"), window.theme.isNewsletterPopupOpen = !0, 
                this.delegateElement.on("click", this._clickOutsideListener));
            }
        }, {
            key: "_closePopup",
            value: function() {
                this.element.setAttribute("aria-hidden", "true"), window.theme.isNewsletterPopupOpen = !1, 
                this.delegateElement.off("click");
            }
        }, {
            key: "_checkClickOutside",
            value: function(e) {
                this.element.contains(e.target) && this.element !== e.target || this._closePopup();
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e(t, i) {
            _classCallCheck(this, e), t && (this.element = t, this.options = i, this.lastKnownY = window.scrollY, 
            this.currentTop = 0, this.initialTopOffset = i.offsetTop || parseInt(window.getComputedStyle(this.element).top), 
            this._attachListeners());
        }
        return _createClass(e, [ {
            key: "destroy",
            value: function() {
                window.removeEventListener("scroll", this._checkPositionListener);
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this._checkPositionListener = this._checkPosition.bind(this), window.addEventListener("scroll", this._checkPositionListener);
            }
        }, {
            key: "_checkPosition",
            value: function() {
                var e = this;
                fastdom.measure(function() {
                    var t = e.element.getBoundingClientRect().top + window.scrollY - e.element.offsetTop + e.initialTopOffset, i = e.element.clientHeight - window.innerHeight + (e.options.offsetBottom || 0);
                    window.scrollY < e.lastKnownY ? e.currentTop -= window.scrollY - e.lastKnownY : e.currentTop += e.lastKnownY - window.scrollY, 
                    e.currentTop = Math.min(Math.max(e.currentTop, -i), t, e.initialTopOffset), e.lastKnownY = window.scrollY;
                }), fastdom.mutate(function() {
                    e.element.style.top = e.currentTop + "px";
                });
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(1), o = i(2), s = i(5), a = function() {
        function e(t, i) {
            var n = this;
            _classCallCheck(this, e), this.element = t, this.delegateElement = new domDelegate.Delegate(this.element), 
            this.options = i;
            var o = this.element.querySelector("[data-product-json]");
            if (o) {
                var s = JSON.parse(o.innerHTML);
                this.productData = s.product, this.productOptionsWithValues = s.options_with_values, 
                this.variantsInventories = s.inventories || {}, this.variantSelectors = this.element.querySelectorAll(".product-form__option[data-selector-type]"), 
                this.masterSelector = this.element.querySelector("#product-select-" + this.productData.id), 
                this.productData.variants.forEach(function(e) {
                    e.id === s.selected_variant_id && (n.currentVariant = e, n.option1 = e.option1, 
                    n.option2 = e.option2, n.option3 = e.option3);
                });
            }
            this._updateSelectors(this.currentVariant), this._setupStockCountdown(), this._attachListeners();
        }
        return _createClass(e, [ {
            key: "destroy",
            value: function() {
                this.delegateElement.off("click");
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this.delegateElement.on("change", ".product-form__single-selector", this._onOptionChanged.bind(this)), 
                this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this));
            }
        }, {
            key: "_onVariantChanged",
            value: function(e, t) {
                this._updateProductPrices(t, e), this._updateInventory(t, e), this._updateSku(t, e), 
                this._updateDiscountLabel(t, e), this._updateSelectors(t, e), this._updateAddToCartButton(t, e), 
                window.theme.currencyConversionEnabled && n.default.convertAll(this.element), this.element.dispatchEvent(new CustomEvent("variant:changed", {
                    bubbles: !0,
                    detail: {
                        variant: t,
                        previousVariant: e
                    }
                }));
            }
        }, {
            key: "_updateProductPrices",
            value: function(e, t) {
                var i = this.element.querySelector(".price-list");
                if (e) {
                    if (t && t.price === e.price && t.compare_at_price === e.compare_at_price) return;
                    i.innerHTML = "", e.compare_at_price > e.price ? (i.innerHTML += '<span class="price price--highlight" data-money-convertible>' + n.default.formatMoney(e.price, window.theme.moneyFormat) + "</span>", 
                    i.innerHTML += '<span class="price price--compare" data-money-convertible>' + n.default.formatMoney(e.compare_at_price, window.theme.moneyFormat) + "</span>") : i.innerHTML += '<span class="price" data-money-convertible>' + n.default.formatMoney(e.price, window.theme.moneyFormat) + "</span>", 
                    i.style.display = "";
                } else i.style.display = "none";
            }
        }, {
            key: "_updateInventory",
            value: function(e) {
                if (this.options.showInventoryQuantity && e) {
                    var t = this.element.querySelector(".product-form__inventory"), i = this.variantsInventories[e.id].inventory_management, n = this.variantsInventories[e.id].inventory_policy, o = this.variantsInventories[e.id].inventory_quantity, s = this.variantsInventories[e.id].inventory_message;
                    t.classList.remove("inventory--high"), t.classList.remove("inventory--low"), e.available && (null !== i && "deny" === n && this.options.lowInventoryThreshold > 0 && o <= this.options.lowInventoryThreshold ? t.classList.add("inventory--low") : t.classList.add("inventory--high"));
                    var a = this.element.querySelector(".inventory-bar");
                    if (a) {
                        var r = Math.min(Math.max(o / parseInt(a.getAttribute("data-stock-countdown-max")) * 100, 0), 100);
                        a.classList.toggle("inventory-bar--hidden", 0 === r), a.firstElementChild.style.width = r + "%";
                    }
                    t.innerHTML = s;
                }
            }
        }, {
            key: "_updateSku",
            value: function(e, t) {
                var i = this.element.querySelector(".product-meta__sku-number");
                if (i) if (e) {
                    if (t && t.sku === e.sku) return;
                    i.innerHTML = e.sku, i.style.display = "";
                } else i.style.display = "none";
            }
        }, {
            key: "_updateDiscountLabel",
            value: function(e, t) {
                if (window.theme.showDiscount) {
                    var i = this.element.querySelector(".product-meta .product-label--on-sale");
                    if (e && e.price < e.compare_at_price) {
                        var o = null;
                        o = "percentage" === window.theme.discountMode ? Math.round(100 * (e.compare_at_price - e.price) / e.compare_at_price) + "%" : "<span data-money-convertible>" + n.default.formatMoney(e.compare_at_price - e.price, window.theme.moneyFormat) + "</span>", 
                        i.innerHTML = "" + window.languages.collectionOnSaleLabel.replace("{{savings}}", o), 
                        i.style.display = "inline-block";
                    } else i.style.display = "none";
                }
            }
        }, {
            key: "_updateSelectors",
            value: function(e) {
                var t = this;
                if (e) {
                    var i = e.option1, n = e.option2, o = e.option3, s = this.productData.variants.length;
                    this.variantSelectors.forEach(function(e, a) {
                        var r = e.getAttribute("data-selector-type");
                        if ("select" !== r) {
                            var l = a + 1;
                            t.productOptionsWithValues[a].values.forEach(function(a, c) {
                                var u = !1;
                                if (1 === l) for (var h = 0; h !== s; ++h) {
                                    var d = t.productData.variants[h];
                                    if (d.option1 === a && d.option2 === n && d.option3 === o) {
                                        u = d.available;
                                        break;
                                    }
                                } else if (2 === l) for (var m = 0; m !== s; ++m) {
                                    var p = t.productData.variants[m];
                                    if (p.option1 === i && p.option2 === a && p.option3 === o) {
                                        u = p.available;
                                        break;
                                    }
                                } else if (3 === l) for (var f = 0; f !== s; ++f) {
                                    var g = t.productData.variants[f];
                                    if (g.option1 === i && g.option2 === n && g.option3 === a) {
                                        u = g.available;
                                        break;
                                    }
                                }
                                switch (r) {
                                  case "color":
                                    e.querySelector(".color-swatch:nth-child(" + (c + 1) + ")").classList.toggle("color-swatch--disabled", !u);
                                    break;

                                  case "variant":
                                    e.querySelector(".variant-swatch:nth-child(" + (c + 1) + ")").classList.toggle("variant-swatch--disabled", !u);
                                    break;

                                  case "block":
                                    e.querySelector(".block-swatch:nth-child(" + (c + 1) + ")").classList.toggle("block-swatch--disabled", !u);
                                }
                            });
                        }
                    });
                }
            }
        }, {
            key: "_updateAddToCartButton",
            value: function(e) {
                var t = this.element.querySelector(".product-form__add-button"), i = this.element.querySelector(".product-form__info-list");
                if (e ? (i.style.display = "block", e.available ? (t.removeAttribute("disabled"), 
                t.classList.remove("button--disabled"), t.classList.add("button--primary"), t.setAttribute("data-action", "add-to-cart"), 
                t.innerHTML = window.languages.productFormAddToCart) : (t.setAttribute("disabled", "disabled"), 
                t.classList.add("button--disabled"), t.classList.remove("button--primary"), t.removeAttribute("data-action"), 
                t.innerHTML = window.languages.productFormSoldOut)) : (t.setAttribute("disabled", "disabled"), 
                t.classList.add("button--disabled"), t.classList.remove("button--primary"), t.removeAttribute("data-action"), 
                t.innerHTML = window.languages.productFormUnavailable, i.style.display = "none"), 
                this.options.showPaymentButton) {
                    var n = this.element.querySelector(".shopify-payment-button");
                    e && e.available ? n.style.display = "block" : n.style.display = "none";
                }
            }
        }, {
            key: "_onOptionChanged",
            value: function(e, t) {
                this["option" + t.getAttribute("data-option-position")] = t.value;
                var i = t.closest(".product-form__option").querySelector(".product-form__selected-value");
                i && (i.innerHTML = t.value);
                var n = this.currentVariant;
                if (this.currentVariant = this._getCurrentVariantFromOptions(), this._onVariantChanged(n, this.currentVariant), 
                this.currentVariant) {
                    if (this.options.enableHistoryState && history.replaceState) {
                        var o = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + this.currentVariant.id;
                        window.history.replaceState({
                            path: o
                        }, "", o);
                    }
                    this.masterSelector.querySelector("[selected]").removeAttribute("selected"), this.masterSelector.querySelector('[value="' + this.currentVariant.id + '"]').setAttribute("selected", "selected");
                }
            }
        }, {
            key: "_getCurrentVariantFromOptions",
            value: function() {
                var e = this, t = !1;
                return this.productData.variants.forEach(function(i) {
                    i.option1 === e.option1 && i.option2 === e.option2 && i.option3 === e.option3 && (t = i);
                }), t || null;
            }
        }, {
            key: "_addToCart",
            value: function(e, t) {
                var i = this;
                if ("page" !== window.theme.cartType) {
                    e.preventDefault(), e.stopPropagation(), t.setAttribute("disabled", "disabled"), 
                    document.dispatchEvent(new CustomEvent("theme:loading:start"));
                    var n = this.element.querySelector('form[action*="/cart/add"]');
                    fetch(window.theme.localeRootUrl + "/cart/add.js", {
                        body: JSON.stringify(o.default.serialize(n)),
                        credentials: "same-origin",
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    }).then(function(e) {
                        if (document.dispatchEvent(new CustomEvent("theme:loading:end")), e.ok) {
                            t.removeAttribute("disabled");
                            var o = n.querySelector('[name="quantity"]').value, a = jQuery(".header-mini-cart-count").text(), r = parseInt(o) + parseInt(a);
                            jQuery(".header__cart-count").text(r), jQuery("#AjaxifyModal").addClass("is-visible"), 
                            jQuery("html, body").animate({
                                scrollTop: 0
                            }, 250, "swing"), i.element.dispatchEvent(new CustomEvent("product:added", {
                                bubbles: !0,
                                detail: {
                                    variant: i.currentVariant,
                                    quantity: parseInt(n.querySelector('[name="quantity"]').value)
                                }
                            })), i.options.isQuickView && document.dispatchEvent(new CustomEvent("modal:close"));
                        } else e.json().then(function(e) {
                            var i = document.createElement("div");
                            i.className = "product-form__error", i.innerHTML = '<p class="alert alert--error">' + e.description + "</p>", 
                            t.removeAttribute("disabled"), t.parentNode.insertAdjacentElement("afterend", i), 
                            s.default.slideDown(i), setTimeout(function() {
                                s.default.slideUp(i, function() {
                                    i.remove();
                                });
                            }, 5500);
                        });
                    }), e.preventDefault();
                }
            }
        }, {
            key: "_setupStockCountdown",
            value: function() {
                var e = this, t = this.element.querySelector(".inventory-bar");
                if (t) {
                    var i = new IntersectionObserver(function(n) {
                        n.forEach(function(n) {
                            if (n.isIntersecting) {
                                var o = e.variantsInventories[e.currentVariant.id].inventory_quantity, s = Math.min(Math.max(o / parseInt(t.getAttribute("data-stock-countdown-max")) * 100, 0), 100);
                                t.classList.toggle("inventory-bar--hidden", 0 === s), t.firstElementChild.style.width = s + "%", 
                                i.disconnect();
                            }
                        });
                    });
                    i.observe(t);
                }
            }
        } ]), e;
    }();
    t.default = a;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this._attachListeners();
        }
        return _createClass(e, [ {
            key: "_attachListeners",
            value: function() {
                this.element.addEventListener("change", this._onSelectValueChanged.bind(this));
            }
        }, {
            key: "_onSelectValueChanged",
            value: function(e) {
                if (10 === parseInt(e.target.value)) {
                    var t = e.target.closest(".select-wrapper"), i = document.createElement("input");
                    i.id = e.target.id, i.className = "product-form__quantity form__field form__field--small form__field--text", 
                    i.pattern = "[0-9]*", i.name = "quantity", i.value = "10", t.parentNode.replaceChild(i, t), 
                    i.focus(), i.addEventListener("keyup", this._onInputValueChanged.bind(this));
                }
            }
        }, {
            key: "_onInputValueChanged",
            value: function(e) {
                e.target.value = Math.max(1, parseInt(e.target.value) || 1);
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e() {
            _classCallCheck(this, e);
        }
        return _createClass(e, null, [ {
            key: "getSizedImageUrl",
            value: function(e, t) {
                if (null === t) return e;
                if ("master" === t) return e.replace(/http(s)?:/, "");
                var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                if (i) {
                    var n = e.split(i[0]), o = i[0];
                    return (n[0] + "_" + t + o).replace(/http(s)?:/, "");
                }
                return null;
            }
        }, {
            key: "getSupportedSizes",
            value: function(e, t) {
                var i = [], n = e.width;
                return t.forEach(function(e) {
                    n >= e && i.push(e);
                }), i;
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(8);
    i.d(t, "AccessibilityHelper", function() {
        return n.default;
    });
    var o = i(5);
    i.d(t, "AnimationHelper", function() {
        return o.default;
    });
    var s = i(1);
    i.d(t, "CurrencyHelper", function() {
        return s.default;
    });
    var a = i(3);
    i.d(t, "DomHelper", function() {
        return a.default;
    });
    var r = i(20);
    i.d(t, "ImageHelper", function() {
        return r.default;
    });
    var l = i(0);
    i.d(t, "ResponsiveHelper", function() {
        return l.default;
    });
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(5), o = i(3), s = function() {
        function e() {
            _classCallCheck(this, e), this.domDelegate = new domDelegate.Delegate(document.body), 
            this._attachListeners();
        }
        return _createClass(e, [ {
            key: "_attachListeners",
            value: function() {
                this.domDelegate.on("click", '[data-action="toggle-collapsible"]:not([disabled])', this._toggleCollapsible.bind(this)), 
                document.addEventListener("collapsible:toggle", this._toggleCollapsible.bind(this));
            }
        }, {
            key: "_toggleCollapsible",
            value: function(e, t) {
                var i = this;
                !t && e.detail && (t = document.querySelector('[aria-controls="' + e.detail.id + '"]'));
                var n = "true" === t.getAttribute("aria-expanded"), s = t.parentNode;
                n ? this._close(s) : this._open(s), "false" !== t.getAttribute("data-close-siblings") && o.default.getSiblings(s).forEach(function(e) {
                    return i._close(e);
                });
            }
        }, {
            key: "_open",
            value: function(e) {
                var t = e.querySelector("[aria-controls]");
                if (t && "true" !== t.getAttribute("aria-expanded")) {
                    var i = e.querySelector("#" + t.getAttribute("aria-controls"));
                    t.setAttribute("aria-expanded", "true"), i.hasAttribute("aria-hidden") && i.setAttribute("aria-hidden", "false"), 
                    n.default.slideDown(i, function() {
                        t.hasAttribute("data-collapsible-force-overflow") && (i.style.overflow = "visible");
                        var e = i.querySelector("[autofocus]");
                        e && e.focus();
                    });
                }
            }
        }, {
            key: "_close",
            value: function(e) {
                var t = e.querySelector("[aria-controls]");
                if (t && "false" !== t.getAttribute("aria-expanded")) {
                    var i = e.querySelector("#" + t.getAttribute("aria-controls"));
                    t.hasAttribute("data-collapsible-force-overflow") && (i.style.overflow = "hidden"), 
                    i.hasAttribute("aria-hidden") && i.setAttribute("aria-hidden", "true"), t.setAttribute("aria-expanded", "false"), 
                    n.default.slideUp(i);
                }
            }
        } ]), e;
    }();
    t.default = s;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e() {
            _classCallCheck(this, e), this.element = document.querySelector(".loading-bar"), 
            this.element && (document.addEventListener("theme:loading:start", this._onLoadingStart.bind(this)), 
            document.addEventListener("theme:loading:end", this._onLoadingEnd.bind(this)), this.element.addEventListener("transitionend", this._onTransitionEnd.bind(this)));
        }
        return _createClass(e, [ {
            key: "_onLoadingStart",
            value: function() {
                this.element.classList.add("is-visible"), this.element.style.width = "40%";
            }
        }, {
            key: "_onLoadingEnd",
            value: function() {
                this.element.style.width = "100%", this.element.classList.add("is-finished");
            }
        }, {
            key: "_onTransitionEnd",
            value: function(e) {
                "width" === e.propertyName && this.element.classList.contains("is-finished") && (this.element.classList.remove("is-visible"), 
                this.element.classList.remove("is-finished"), this.element.style.width = "0");
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(8), o = function() {
        function e() {
            _classCallCheck(this, e), this.domDelegate = new domDelegate.Delegate(document.body), 
            this.activeModal = document.querySelector('.modal[aria-hidden="false"]'), this._attachListeners();
        }
        return _createClass(e, [ {
            key: "_attachListeners",
            value: function() {
                this.domDelegate.on("click", '[data-action="open-modal"]', this._openModal.bind(this)), 
                this.domDelegate.on("click", '[data-action="close-modal"]', this._closeModal.bind(this)), 
                document.addEventListener("modal:close", this._closeModal.bind(this)), this._clickOutsideListener = this._checkClickOutside.bind(this), 
                this.activeModal && (document.documentElement.classList.add("is-locked"), this.domDelegate.on("click", this._clickOutsideListener));
            }
        }, {
            key: "_openModal",
            value: function(e, t) {
                var i = this, o = document.querySelector("#" + t.getAttribute("aria-controls"));
                if (o) {
                    return o.addEventListener("transitionend", function e(t) {
                        "visibility" === t.propertyName && (o.removeEventListener("transitionend", e), n.default.trapFocus(o, "modal"), 
                        i.activeModal = o);
                    }), o.setAttribute("aria-hidden", "false"), document.documentElement.classList.add("is-locked"), 
                    this.domDelegate.on("click", this._clickOutsideListener), !1;
                }
            }
        }, {
            key: "_closeModal",
            value: function() {
                var e = this;
                if (this.activeModal) {
                    this.activeModal.addEventListener("transitionend", function t(i) {
                        "visibility" === i.propertyName && (e.activeModal.removeEventListener("transitionend", t), 
                        n.default.removeTrapFocus(e.activeModal, "modal"), e.activeModal = null);
                    }), this.activeModal.setAttribute("aria-hidden", "true"), document.documentElement.classList.remove("is-locked"), 
                    this.domDelegate.off("click", this._clickOutsideListener);
                }
            }
        }, {
            key: "_checkClickOutside",
            value: function(e) {
                !this.activeModal || this.activeModal.contains(e.target) && this.activeModal !== e.target || this._closeModal();
            }
        } ]), e;
    }();
    t.default = o;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(0), o = function() {
        function e() {
            _classCallCheck(this, e), this.delegateElement = new domDelegate.Delegate(document.body), 
            this.delegateRoot = new domDelegate.Delegate(document.documentElement), this.activePopover = null, 
            this._attachListeners();
        }
        return _createClass(e, [ {
            key: "_attachListeners",
            value: function() {
                this.delegateElement.on("click", '[data-action="toggle-popover"]', this._togglePopover.bind(this)), 
                this.delegateElement.on("click", '[data-action="show-popover-panel"]', this._showPanel.bind(this)), 
                this.delegateRoot.on("click", this._onWindowClick.bind(this)), document.addEventListener("popover:close", this._closeActivePopover.bind(this)), 
                window.addEventListener("resize", this._windowResized.bind(this));
            }
        }, {
            key: "_togglePopover",
            value: function(e, t) {
                var i = null !== this.activePopover, o = this.activePopover ? this.activePopover.id : null;
                t.hasAttribute("data-follow-link") && n.default.matchesBreakpoint(t.getAttribute("data-follow-link")) || (i && this._closeActivePopover(), 
                (!i || i && t.getAttribute("aria-controls") !== o) && this._openPopover(t), e.preventDefault());
            }
        }, {
            key: "_closeActivePopover",
            value: function() {
                this.activePopover.setAttribute("aria-hidden", "true"), document.querySelector('[aria-controls="' + this.activePopover.id + '"]').setAttribute("aria-expanded", "false"), 
                this.activePopover = null;
            }
        }, {
            key: "_openPopover",
            value: function(e) {
                var t = document.getElementById(e.getAttribute("aria-controls"));
                if (e.setAttribute("aria-expanded", "true"), t.setAttribute("aria-hidden", "false"), 
                "phone" === n.default.getCurrentBreakpoint()) t.style.height = window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom + "px"; else {
                    t.style.height = "";
                    var i = t.querySelector(".popover__panel-list");
                    i && (i.style.height = i.clientHeight + "px");
                }
                this.activePopover = t;
            }
        }, {
            key: "_showPanel",
            value: function(e, t) {
                this.activePopover && this.activePopover.querySelectorAll(".popover__panel").forEach(function(e) {
                    e.id === t.getAttribute("aria-controls") ? (e.classList.add("is-selected"), e.closest(".popover__panel-list").style.height = e.clientHeight + "px") : e.classList.remove("is-selected");
                });
            }
        }, {
            key: "_onWindowClick",
            value: function(e) {
                "toggle-popover" === e.target.getAttribute("data-action") || e.target.closest('[data-action="toggle-popover"]') || this.activePopover && !this.activePopover.contains(e.target) && this._closeActivePopover();
            }
        }, {
            key: "_windowResized",
            value: function() {
                "phone" === n.default.getCurrentBreakpoint() && this.activePopover && (this.activePopover.style.height = window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom + "px");
            }
        } ]), e;
    }();
    t.default = o;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(1), o = i(0), s = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.delegateElement = new domDelegate.Delegate(this.element), 
            this.headerElement = this.element.closest(".header"), this.searchBarElement = this.element.querySelector(".search-bar"), 
            this.inputElement = this.element.querySelector('[name="q"]'), this.searchMenuElement = this.element.querySelector(".search-bar__menu-wrapper"), 
            this.searchResultsElement = this.element.querySelector(".search-bar__results"), 
            this.closeButtonElement = this.element.querySelector(".search-bar__close-button"), 
            this.productTypeFilter = "", this.isSearchOpen = !1, this._attachListeners();
        }
        return _createClass(e, [ {
            key: "destroy",
            value: function() {
                this.delegateElement.off();
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this.delegateElement.on("click", '[data-action="clear-input"]', this._clearInput.bind(this)), 
                this.delegateElement.on("click", '[data-action="unfix-search"]', this._unfixMobileSearch.bind(this)), 
                this.delegateElement.on("focusin", '[name="q"]', this._onInputFocus.bind(this)), 
                this.delegateElement.on("focusout", this._onFocusOut.bind(this)), this.delegateElement.on("keydown", '[name="q"]', this._handleTab.bind(this)), 
                this.delegateElement.on("input", '[name="q"]', this._debounce(this._doSearch.bind(this), 250)), 
                this.delegateElement.on("change", '[name="product_type"]', this._productTypeChanged.bind(this)), 
                this.delegateElement.on("submit", this._onFormSubmit.bind(this));
            }
        }, {
            key: "toggleMobileSearch",
            value: function() {
                this.isSearchOpen ? (this.headerElement.classList.remove("header--search-expanded"), 
                this.element.classList.remove("is-visible")) : (this.headerElement.classList.add("header--search-expanded"), 
                this.element.classList.add("is-visible")), this.isSearchOpen = !this.isSearchOpen;
            }
        }, {
            key: "_unfixMobileSearch",
            value: function() {
                this.closeButtonElement.style.width = "", this.searchBarElement.classList.remove("is-expanded"), 
                this.searchResultsElement.setAttribute("aria-hidden", "true"), this.inputElement.classList.remove("is-filled"), 
                this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "true");
            }
        }, {
            key: "_clearInput",
            value: function() {
                this.inputElement.value = "", this.inputElement.classList.remove("is-filled"), this.searchResultsElement.setAttribute("aria-hidden", "true"), 
                this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "false");
            }
        }, {
            key: "_onInputFocus",
            value: function() {
                this.closeButtonElement.style.width = this.closeButtonElement.firstElementChild.offsetWidth + "px", 
                "" === this.inputElement.value ? (this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "false"), 
                this.searchResultsElement.setAttribute("aria-hidden", "true")) : (this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "true"), 
                this.searchResultsElement.setAttribute("aria-hidden", "false"), this.inputElement.classList.add("is-filled"), 
                this.searchBarElement.classList.add("is-expanded")), this.searchMenuElement && this.searchBarElement.classList.add("is-expanded");
            }
        }, {
            key: "_onFocusOut",
            value: function(e) {
                o.default.matchesBreakpoint("phone") || (this.element.classList.remove("is-fixed"), 
                this.element.contains(e.relatedTarget) || (this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "true"), 
                this.searchResultsElement.setAttribute("aria-hidden", "true"), this.searchBarElement.classList.remove("is-expanded")));
            }
        }, {
            key: "_handleTab",
            value: function(e) {
                if (9 === e.keyCode) {
                    var t = this.searchResultsElement.querySelector("a");
                    t && (t.focus(), e.preventDefault());
                }
            }
        }, {
            key: "_doSearch",
            value: function() {
                var e = this, t = this.inputElement.value;
                if (this.lastInputValue = t, "" === t) this.searchMenuElement ? this.searchMenuElement.setAttribute("aria-hidden", "false") : this.searchBarElement.classList.remove("is-expanded"), 
                this.searchResultsElement.setAttribute("aria-hidden", "true"); else {
                    this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "true"), 
                    this.searchResultsElement.setAttribute("aria-hidden", "false"), this.searchBarElement.classList.add("is-expanded", "is-loading");
                    var i = "NOT tag:__gift AND " + ("" !== this.productTypeFilter ? "product_type:" + this.productTypeFilter + " AND " : "") + this.lastInputValue + "*";
                    fetch("/search?view=ajax&q=" + i + "&type=" + window.theme.searchMode, {
                        method: "GET",
                        credentials: "same-origin"
                    }).then(function(i) {
                        e.lastInputValue === t && i.text().then(function(t) {
                            e.searchBarElement.classList.remove("is-loading"), e.searchBarElement.querySelector(".search-bar__results-inner").innerHTML = t, 
                            window.theme.currencyConversionEnabled && n.default.convertAll(e.element);
                        });
                    });
                }
            }
        }, {
            key: "_productTypeChanged",
            value: function(e, t) {
                t.closest(".search-bar__filter").querySelector(".search-bar__filter-active").innerText = t.options[t.selectedIndex].innerText, 
                this.productTypeFilter = t.value, "" !== this.inputElement.value && this._doSearch();
            }
        }, {
            key: "_onFormSubmit",
            value: function(e) {
                if ("" === this.inputElement.value) e.preventDefault(); else {
                    var t = this.inputElement.cloneNode();
                    t.setAttribute("type", "hidden"), t.value = "NOT tag:__gift AND " + this.inputElement.value + "*", 
                    this.inputElement.removeAttribute("name"), this.inputElement.insertAdjacentElement("afterend", t);
                }
            }
        }, {
            key: "_debounce",
            value: function(e, t) {
                var i = this, n = null;
                return function() {
                    for (var o = arguments.length, s = Array(o), a = 0; a < o; a++) s[a] = arguments[a];
                    clearTimeout(n), n = setTimeout(function() {
                        e.apply(i, s);
                    }, t);
                };
            }
        } ]), e;
    }();
    t.default = s;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(22);
    i.d(t, "CollapsibleManager", function() {
        return n.default;
    });
    var o = i(9);
    i.d(t, "CountrySelector", function() {
        return o.default;
    });
    var s = i(13);
    i.d(t, "DesktopNavigation", function() {
        return s.default;
    });
    var a = i(12);
    i.d(t, "CollectionFilterDrawer", function() {
        return a.default;
    });
    var r = i(14);
    i.d(t, "ExitPopup", function() {
        return r.default;
    });
    var l = i(23);
    i.d(t, "LoadingBar", function() {
        return l.default;
    });
    var c = i(11);
    i.d(t, "Cart", function() {
        return c.default;
    });
    var u = i(15);
    i.d(t, "MobileNavigation", function() {
        return u.default;
    });
    var h = i(24);
    i.d(t, "ModalManager", function() {
        return h.default;
    });
    var d = i(16);
    i.d(t, "NewsletterPopup", function() {
        return d.default;
    });
    var m = i(17);
    i.d(t, "OverflowScroller", function() {
        return m.default;
    });
    var p = i(25);
    i.d(t, "PopoverManager", function() {
        return p.default;
    });
    var f = i(6);
    i.d(t, "ProductItemColorSwatch", function() {
        return f.default;
    });
    var g = i(18);
    i.d(t, "ProductVariants", function() {
        return g.default;
    });
    var v = i(19);
    i.d(t, "QuantityPicker", function() {
        return v.default;
    });
    var y = i(10);
    i.d(t, "ShippingEstimator", function() {
        return y.default;
    });
    var _ = i(7);
    i.d(t, "ValuePicker", function() {
        return _.default;
    });
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(9), o = i(7), s = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.domDelegate = new domDelegate.Delegate(this.element), 
            this.element.querySelectorAll('[action*="/account/addresses"]').forEach(function(e) {
                new n.default(e.querySelector('[name="address[country]"]'), e.querySelector('[name="address[province]"]'));
            }), this.pageSelector = new o.default("account-selector");
        }
        return _createClass(e, [ {
            key: "_onUnload",
            value: function() {
                this.pageSelector.destroy();
            }
        } ]), e;
    }();
    t.default = s;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(8), o = i(5), s = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.domDelegate = new domDelegate.Delegate(this.element), 
            this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.isOpen = !1, 
            this.options.showNewsletter ? document.documentElement.style.setProperty("--announcement-bar-button-width", this.element.querySelector(".announcement-bar__button").clientWidth + "px") : document.documentElement.style.removeProperty("--announcement-bar-button-width"), 
            this._attachListeners();
        }
        return _createClass(e, [ {
            key: "onSelect",
            value: function() {
                this.options.showNewsletter && !this.isOpen && this._toggleNewsletter();
            }
        }, {
            key: "onDeselect",
            value: function() {
                this.options.showNewsletter && this.isOpen && this._toggleNewsletter();
            }
        }, {
            key: "onUnload",
            value: function() {
                this.domDelegate.off();
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this.domDelegate.on("click", '[data-action="toggle-newsletter"]', this._toggleNewsletter.bind(this)), 
                this.domDelegate.on("keyup", this._handleKey.bind(this));
            }
        }, {
            key: "_toggleNewsletter",
            value: function() {
                var e = this.element.querySelector(".announcement-bar__button"), t = this.element.querySelector(".announcement-bar__newsletter");
                "false" === e.getAttribute("aria-expanded") ? (e.setAttribute("aria-expanded", "true"), 
                t.setAttribute("aria-hidden", "false"), o.default.slideDown(t, function() {
                    n.default.trapFocus(t, "announcement-bar");
                })) : (e.setAttribute("aria-expanded", "false"), t.setAttribute("aria-hidden", "true"), 
                o.default.slideUp(t), n.default.removeTrapFocus(t, "announcement-bar")), this.isOpen = !this.isOpen;
            }
        }, {
            key: "_handleKey",
            value: function(e) {
                27 === e.keyCode && this.isOpen && this._toggleNewsletter();
            }
        } ]), e;
    }();
    t.default = s;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    t.default = function e(t) {
        if (_classCallCheck(this, e), this.element = t, Shopify.designMode) {
            var i = this.element.querySelector(".page__header");
            i && (document.querySelector(".blog-container").previousElementSibling.remove(), 
            document.querySelector(".blog-container").insertAdjacentElement("beforebegin", i));
        }
    };
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(7), o = function() {
        function e(t) {
            if (_classCallCheck(this, e), this.element = t, this.blogTagSelector = new n.default("blog-tag-selector"), 
            Shopify.designMode) {
                var i = this.element.querySelector(".page__header");
                i && (console.log(document.querySelector(".blog-container").previousElementSibling), 
                document.querySelector(".blog-container").previousElementSibling.remove(), document.querySelector(".blog-container").insertAdjacentElement("beforebegin", i));
            }
        }
        return _createClass(e, [ {
            key: "onUnload",
            value: function() {
                this.blogTagSelector.destroy();
            }
        } ]), e;
    }();
    t.default = o;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, Shopify.designMode && window.SPR && (window.SPR.initDomEls(), 
            window.SPR.loadBadges()), "blog" === window.theme.template && this._fixItemsPerRow();
        }
        return _createClass(e, [ {
            key: "_fixItemsPerRow",
            value: function() {
                0 === this.element.querySelectorAll(".blog-sidebar__item").length ? (document.querySelector(".blog-container").classList.add("blog-container--without-sidebar"), 
                document.querySelectorAll(".shopify-section__blog-posts .block-list__item").forEach(function(e) {
                    e.classList.contains("1/2--lap-and-up") && (e.classList.remove("1/2--lap-and-up"), 
                    e.classList.add("1/3--lap-and-up"));
                })) : (document.querySelector(".blog-container").classList.remove("blog-container--without-sidebar"), 
                document.querySelectorAll(".shopify-section__blog-posts .block-list__item").forEach(function(e) {
                    e.classList.contains("1/3--lap-and-up") && (e.classList.remove("1/3--lap-and-up"), 
                    e.classList.add("1/2--lap-and-up"));
                }));
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(10), o = i(2), s = i(4), a = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.domDelegate = new domDelegate.Delegate(this.element), 
            this.delegateRoot = new domDelegate.Delegate(document.documentElement), this.options = JSON.parse(this.element.getAttribute("data-section-settings")), 
            this.options.showShippingEstimator && (this.shippingEstimator = new n.default(this.element.querySelector(".shipping-estimator"), {
                singleProduct: !1
            })), this._attachListeners(), this._enforceMinimumHeight();
        }
        return _createClass(e, [ {
            key: "onUnload",
            value: function() {
                this.options.showShippingEstimator && this.shippingEstimator.destroy();
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this.domDelegate.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)), 
                this.domDelegate.on("click", '[data-action="save-note"]', this._saveNote.bind(this)), 
                this.domDelegate.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this)), 
                this.delegateRoot.on("cart:rerendered", this._onCartRerendered.bind(this));
            }
        }, {
            key: "_saveNote",
            value: function() {
                var e = this.element.querySelector('[name="cart[note]"]').value;
                fetch(window.theme.localeRootUrl + "/cart/update.js", {
                    body: JSON.stringify({
                        note: e
                    }),
                    credentials: "same-origin",
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Requested-With": "XMLHttpRequest"
                    }
                }), this.element.querySelector(".cart-recap__note-edit").classList.toggle("is-visible", "" !== e), 
                document.dispatchEvent(new CustomEvent("collapsible:toggle", {
                    detail: {
                        id: "order-note"
                    }
                }));
            }
        }, {
            key: "_addToCart",
            value: function(e, t) {
                var i = this;
                if ("page" !== window.theme.cartType) {
                    e.preventDefault(), e.stopPropagation(), t.setAttribute("disabled", "disabled"), 
                    document.dispatchEvent(new CustomEvent("theme:loading:start"));
                    var n = t.closest('form[action*="/cart/add"]');
                    fetch(window.theme.localeRootUrl + "/cart/add.js", {
                        body: JSON.stringify(o.default.serialize(n)),
                        credentials: "same-origin",
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    }).then(function(e) {
                        e.ok ? (t.removeAttribute("disabled"), i.element.dispatchEvent(new CustomEvent("product:added", {
                            bubbles: !0,
                            detail: {
                                variant: null,
                                quantity: parseInt(n.querySelector('[name="quantity"]').value)
                            }
                        }))) : t.removeAttribute("disabled");
                    }), e.preventDefault();
                }
            }
        }, {
            key: "_openQuickView",
            value: function(e, t) {
                var i = document.getElementById(t.getAttribute("aria-controls"));
                i.classList.add("is-loading"), fetch(t.getAttribute("data-product-url") + "?view=quick-view", {
                    credentials: "same-origin",
                    method: "GET"
                }).then(function(e) {
                    e.text().then(function(e) {
                        i.querySelector(".modal__inner").innerHTML = e, i.classList.remove("is-loading"), 
                        new s.default(i.querySelector('[data-section-type="product"]'));
                    });
                });
            }
        }, {
            key: "_enforceMinimumHeight",
            value: function() {
                var e = this.element.querySelector(".cart-wrapper"), t = this.element.querySelector(".cart-recap__scroller");
                e && t && (e.style.minHeight = t.clientHeight + "px", window.ResizeObserver && new ResizeObserver(function(t) {
                    var i = !0, n = !1, o = void 0;
                    try {
                        for (var s, a = t[Symbol.iterator](); !(i = (s = a.next()).done); i = !0) {
                            var r = s.value;
                            e.style.minHeight = parseInt(r.contentRect.height) + "px";
                        }
                    } catch (e) {
                        n = !0, o = e;
                    } finally {
                        try {
                            !i && a.return && a.return();
                        } finally {
                            if (n) throw o;
                        }
                    }
                }).observe(t));
            }
        }, {
            key: "_onCartRerendered",
            value: function() {
                this.options.showShippingEstimator && (this.shippingEstimator.destroy(), this.shippingEstimator = new n.default(this.element.querySelector(".shipping-estimator"), {
                    singleProduct: !1
                }));
            }
        } ]), e;
    }();
    t.default = a;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.flickityInstance = new Flickity(this.element.querySelector(".collection-list"), {
                watchCSS: !0,
                prevNextButtons: !0,
                draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches,
                pageDots: !1,
                cellAlign: "left",
                contain: !0,
                groupCells: !0
            });
        }
        return _createClass(e, [ {
            key: "onUnload",
            value: function() {
                this.flickityInstance.destroy();
            }
        }, {
            key: "onBlockSelect",
            value: function(e) {
                this.flickityInstance.isActive && this.flickityInstance.selectCell(parseInt(e.target.getAttribute("data-collection-index")), null, e.detail.load);
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(3), o = i(1), s = i(2), a = i(0), r = i(7), l = i(12), c = i(6), u = i(4), h = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.delegateElement = new domDelegate.Delegate(this.element), 
            this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.collectionFilterTagElements = this.element.querySelectorAll("[data-tag]"), 
            this.currentUrl = new URL(window.location.href), this.currentTags = this.options.currentTags, 
            Shopify.designMode && window.SPR && (window.SPR.initDomEls(), window.SPR.loadBadges()), 
            this.mobileFilterDrawer = new l.default(this.options), this.displayByValuePicker = new r.default("display-by-selector", {
                onValueSelect: this._showingCountChanged.bind(this)
            }), this.sortByValuePicker = new r.default("sort-by-selector", {
                onValueSelect: this._sortByChanged.bind(this)
            }), this.productItemColorSwatch = new c.default(this.element), this._attachListeners();
        }
        return _createClass(e, [ {
            key: "onUnload",
            value: function() {
                this.delegateElement.off(), this.mobileFilterDrawer.destroy(), this.displayByValuePicker.destroy(), 
                this.sortByValuePicker.destroy(), this.productItemColorSwatch.destroy();
            }
        }, {
            key: "onSelect",
            value: function(e) {
                Shopify.designMode && e.detail.load && (this.element.querySelector('.collection__layout-button[data-layout-mode="' + this.options.defaultLayout + '"]').click(), 
                this._showingCountChanged(this.options.defaultProductsPerPage));
            }
        }, {
            key: "_attachListeners",
            value: function() {
                var e = this;
                this.delegateElement.on("click", '[data-action="change-layout"]', this._changeLayout.bind(this)), 
                this.delegateElement.on("change", "#mobile-sort-by, #desktop-sort-by", this._sortByChanged.bind(this)), 
                this.delegateElement.on("change", "#showing-count", this._showingCountChanged.bind(this)), 
                this.delegateElement.on("click", ".pagination [data-page]", this._paginationPageChanged.bind(this)), 
                this.delegateElement.on("click", '[data-action="toggle-tag"]', this._tagToggled.bind(this)), 
                this.delegateElement.on("click", '[data-action="clear-tags"]', this._clearTags.bind(this)), 
                this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this)), 
                this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)), 
                window.addEventListener("popstate", function(t) {
                    t.state.path && (e.currentUrl = new URL(t.state.path), e._reload(!1));
                });
            }
        }, {
            key: "_openQuickView",
            value: function(e, t) {
                var i = new URL("" + window.location.origin + t.getAttribute("data-product-url"));
                if (a.default.matchesBreakpoint("phone") || a.default.matchesBreakpoint("tablet")) return window.location.href = i.href, 
                !1;
                var n = document.getElementById(t.getAttribute("aria-controls"));
                n.classList.add("is-loading"), i.searchParams.set("view", "quick-view"), fetch(i.href, {
                    credentials: "same-origin",
                    method: "GET"
                }).then(function(e) {
                    e.text().then(function(e) {
                        n.querySelector(".modal__inner").innerHTML = e, n.classList.remove("is-loading"), 
                        new u.default(n.querySelector('[data-section-type="product"]'));
                    });
                });
            }
        }, {
            key: "_changeLayout",
            value: function(e, t) {
                var i = this;
                if (!t.classList.contains("is-selected")) {
                    var o = t.getAttribute("data-layout-mode");
                    fetch(window.theme.localeRootUrl + "/cart/update.js", {
                        body: JSON.stringify({
                            attributes: {
                                collection_layout: o
                            }
                        }),
                        credentials: "same-origin",
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    }), fastdom.mutate(function() {
                        n.default.getSiblings(t, ".is-selected").forEach(function(e) {
                            return e.classList.remove("is-selected");
                        }), t.classList.add("is-selected"), i.element.querySelectorAll(".product-item").forEach(function(e) {
                            e.className = "grid" === o ? "product-item product-item--vertical " + i.options.gridClasses : "product-item product-item--list";
                        }), i.productItemColorSwatch.recalculateSwatches();
                    });
                }
            }
        }, {
            key: "_sortByChanged",
            value: function(e) {
                this.currentUrl.searchParams.set("sort_by", e), this.currentUrl.searchParams.delete("page"), 
                this._reload(!0);
            }
        }, {
            key: "_showingCountChanged",
            value: function(e) {
                var t = this;
                this.currentUrl.searchParams.delete("page"), fetch(window.theme.localeRootUrl + "/cart/update.js", {
                    body: JSON.stringify({
                        attributes: {
                            collection_products_per_page: e
                        }
                    }),
                    credentials: "same-origin",
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Requested-With": "XMLHttpRequest"
                    }
                }).then(function() {
                    t._reload(!0);
                });
            }
        }, {
            key: "_paginationPageChanged",
            value: function(e, t) {
                e.preventDefault(), this.currentUrl.searchParams.set("page", parseInt(t.getAttribute("data-page"))), 
                this._reload(!0);
            }
        }, {
            key: "_tagToggled",
            value: function(e, t) {
                var i = this, n = t.getAttribute("data-tag"), o = this.currentTags.length > 0;
                if (this.currentTags.includes(n)) this.currentTags = this.currentTags.filter(function(e) {
                    return e !== n;
                }); else if ("tag" === this.options.filterType) this.currentTags = [ n ]; else {
                    var s = n.split("_")[0];
                    this.currentTags.forEach(function(e) {
                        e.split("_")[0] === s && (i.currentTags = i.currentTags.filter(function(t) {
                            return t !== e;
                        }));
                    }), this.currentTags.push(n);
                }
                this.currentUrl.searchParams.delete("page"), this._updateTagUrl(o), this._reload(!0);
            }
        }, {
            key: "_clearTags",
            value: function() {
                var e = this.currentTags.length > 0;
                this.currentTags = [], this.currentUrl.searchParams.delete("page"), this._updateTagUrl(e), 
                this._reload(!0).then(function() {
                    document.dispatchEvent(new CustomEvent("collection-filter:close"));
                });
            }
        }, {
            key: "_updateTagUrl",
            value: function(e) {
                var t = this;
                if (fastdom.mutate(function() {
                    t.collectionFilterTagElements.forEach(function(e) {
                        t.currentTags.includes(e.getAttribute("data-tag")) ? (e.classList.add("is-selected"), 
                        "INPUT" === e.tagName && (e.checked = !0)) : (e.classList.remove("is-selected"), 
                        "INPUT" === e.tagName && (e.checked = !1));
                    });
                }), this.options.isAutomatic) 0 === this.currentTags.length ? this.currentUrl.searchParams.delete("constraint") : this.currentUrl.searchParams.set("constraint", this.currentTags.join("+")); else {
                    var i = this.currentTags.join("+"), n = "/" === this.currentUrl.pathname.substr(-1) ? this.currentUrl.pathname.substr(0, this.currentUrl.pathname.length - 1) : this.currentUrl.pathname;
                    if (e) {
                        var o = n.split("/");
                        o.pop(), this.currentUrl.pathname = o.join("/") + "/" + i;
                    } else this.currentUrl.pathname = n + "/" + i;
                }
            }
        }, {
            key: "_reload",
            value: function(e) {
                var t = this;
                e && window.history.pushState({
                    path: this.currentUrl.toString()
                }, "", this.currentUrl.toString()), document.dispatchEvent(new CustomEvent("theme:loading:start")), 
                this.mobileFilterDrawer._filtersHaveChanged(this.currentTags);
                var i = window.getComputedStyle(document.documentElement), n = "";
                return n = this.currentUrl.search ? this.currentUrl.pathname + "/" + this.currentUrl.search + "&section_id=" + this.element.getAttribute("data-section-id") : this.currentUrl.pathname + "?section_id=" + this.element.getAttribute("data-section-id"), 
                fetch(n, {
                    credentials: "same-origin",
                    method: "GET"
                }).then(function(e) {
                    e.text().then(function(e) {
                        var n = document.createElement("div");
                        n.innerHTML = e, t.element.querySelector(".collection__dynamic-part").innerHTML = n.querySelector(".collection__dynamic-part").innerHTML;
                        var s = t.element.querySelector(".collection__active-filters");
                        s && (s.innerHTML = n.querySelector(".collection__active-filters").innerHTML), window.theme.currencyConversionEnabled && o.default.convertAll(t.element), 
                        window.SPR && (window.SPR.initDomEls(), window.SPR.loadBadges()), t.productItemColorSwatch.recalculateSwatches();
                        var a = t.element.querySelector(".collection").getBoundingClientRect().top - 25 - parseInt(i.getPropertyValue("--header-is-sticky")) * parseInt(i.getPropertyValue("--header-height"));
                        a < 0 && window.scrollBy({
                            top: a,
                            behavior: "smooth"
                        }), document.dispatchEvent(new CustomEvent("theme:loading:end"));
                    });
                });
            }
        }, {
            key: "_addToCart",
            value: function(e, t) {
                var i = this;
                if ("page" !== window.theme.cartType) {
                    e.preventDefault(), e.stopPropagation(), t.setAttribute("disabled", "disabled"), 
                    document.dispatchEvent(new CustomEvent("theme:loading:start"));
                    var n = t.closest('form[action*="/cart/add"]');
                    fetch(window.theme.localeRootUrl + "/cart/add.js", {
                        body: JSON.stringify(s.default.serialize(n)),
                        credentials: "same-origin",
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    }).then(function(e) {
                        t.removeAttribute("disabled"), e.ok ? i.element.dispatchEvent(new CustomEvent("product:added", {
                            bubbles: !0,
                            detail: {
                                variant: null,
                                quantity: parseInt(n.querySelector('[name="quantity"]').value)
                            }
                        })) : document.dispatchEvent(new CustomEvent("theme:loading:end"));
                    }), e.preventDefault();
                }
            }
        } ]), e;
    }();
    t.default = h;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(2), o = i(0), s = i(6), a = i(4), r = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.delegateElement = new domDelegate.Delegate(this.element), 
            this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.options.stackable || (this.flickityInstance = new Flickity(this.element.querySelector(".product-list"), {
                watchCSS: !0,
                pageDots: !1,
                prevNextButtons: !0,
                wrapAround: !0,
                dragThreshold: 12,
                contain: !0,
                groupCells: !0,
                cellAlign: "left",
                draggable: !0,
                autoPlay: !!this.options.autoPlay && this.options.cycleSpeed
            })), Shopify.designMode && window.SPR && (window.SPR.initDomEls(), window.SPR.loadBadges()), 
            this.productItemColorSwatch = new s.default(this.element), this._fixSafari(), this._attachListeners();
        }
        return _createClass(e, [ {
            key: "onUnload",
            value: function() {
                this.options.stackable || this.flickityInstance.destroy(), window.removeEventListener("resize", this._fixSafariListener), 
                this.delegateElement.off("change"), this.productItemColorSwatch.destroy();
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this._fixSafariListener = this._fixSafari.bind(this), window.addEventListener("resize", this._fixSafariListener), 
                this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)), 
                this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this));
            }
        }, {
            key: "_fixSafari",
            value: function() {
                var e = window.navigator.userAgent.toLowerCase();
                if (e.includes("safari") && (e.includes("version/10.1") || e.includes("version/10.3") || e.includes("version/11.0"))) {
                    var t = o.default.matchesBreakpoint("phone");
                    this.element.querySelectorAll(".product-item__image-wrapper .aspect-ratio, .product-item__image-wrapper .placeholder-svg").forEach(function(e) {
                        e.parentNode.style.height = t ? null : e.clientHeight + "px";
                    });
                }
            }
        }, {
            key: "_openQuickView",
            value: function(e, t) {
                var i = new URL("" + window.location.origin + t.getAttribute("data-product-url"));
                if (o.default.matchesBreakpoint("phone") || o.default.matchesBreakpoint("tablet")) return window.location.href = i.href, 
                !1;
                var n = document.getElementById(t.getAttribute("aria-controls"));
                n.classList.add("is-loading"), i.searchParams.set("view", "quick-view"), fetch(i.href, {
                    credentials: "same-origin",
                    method: "GET"
                }).then(function(e) {
                    e.text().then(function(e) {
                        n.querySelector(".modal__inner").innerHTML = e, n.classList.remove("is-loading"), 
                        new a.default(n.querySelector('[data-section-type="product"]'));
                    });
                });
            }
        }, {
            key: "_addToCart",
            value: function(e, t) {
                var i = this;
                if ("page" !== window.theme.cartType) {
                    e.preventDefault(), e.stopPropagation(), t.setAttribute("disabled", "disabled"), 
                    document.dispatchEvent(new CustomEvent("theme:loading:start"));
                    var o = t.closest('form[action*="/cart/add"]');
                    fetch(window.theme.localeRootUrl + "/cart/add.js", {
                        body: JSON.stringify(n.default.serialize(o)),
                        credentials: "same-origin",
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    }).then(function(e) {
                        t.removeAttribute("disabled"), e.ok ? i.element.dispatchEvent(new CustomEvent("product:added", {
                            bubbles: !0,
                            detail: {
                                variant: null,
                                quantity: parseInt(o.querySelector('[name="quantity"]').value)
                            }
                        })) : document.dispatchEvent(new CustomEvent("theme:loading:end"));
                    }), e.preventDefault();
                }
            }
        } ]), e;
    }();
    t.default = r;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(0), o = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.domDelegate = new domDelegate.Delegate(this.element), 
            this.cookieBarElement = this.element.querySelector(".cookie-bar"), this.cookieBarElement && this._setupCookieBar(), 
            this._setupCollapsibles(), this._attachListeners();
        }
        return _createClass(e, [ {
            key: "onUnload",
            value: function() {
                window.removeEventListener("resize", this._setupCollapsiblesListener), this.domDelegate.off();
            }
        }, {
            key: "onSelect",
            value: function() {
                this.cookieBarElement && this.cookieBarElement.setAttribute("aria-hidden", "false");
            }
        }, {
            key: "onDeselect",
            value: function() {
                this.cookieBarElement && this.cookieBarElement.setAttribute("aria-hidden", "true");
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this._setupCollapsiblesListener = this._setupCollapsibles.bind(this), window.addEventListener("resize", this._setupCollapsiblesListener), 
                this.domDelegate.on("click", '[data-action="accept-terms"]', this._acceptCookieBarTerms.bind(this));
            }
        }, {
            key: "_setupCollapsibles",
            value: function() {
                var e = this.element.querySelectorAll('[data-action="toggle-collapsible"]'), t = n.default.matchesBreakpoint("phone");
                e.forEach(function(e) {
                    t ? e.removeAttribute("disabled") : (e.setAttribute("disabled", "disabled"), document.getElementById(e.getAttribute("aria-controls")).style.height = "");
                });
            }
        }, {
            key: "_setupCookieBar",
            value: function() {
                try {
                    null === localStorage.getItem("cookieWasAccepted") && this.cookieBarElement.setAttribute("aria-hidden", "false");
                } catch (e) {}
            }
        }, {
            key: "_acceptCookieBarTerms",
            value: function() {
                this.cookieBarElement.setAttribute("aria-hidden", "true");
                try {
                    localStorage.setItem("cookieWasAccepted", "true");
                } catch (e) {}
            }
        } ]), e;
    }();
    t.default = o;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.delegateElement = new domDelegate.Delegate(this.element), 
            this._createQrCode(), this._attachListeners();
        }
        return _createClass(e, [ {
            key: "onUnload",
            value: function() {
                this.delegateElement.off();
            }
        }, {
            key: "_createQrCode",
            value: function() {
                document.querySelectorAll(".gift-card__qr").forEach(function(e) {
                    new QRCode(e, {
                        text: e.getAttribute("data-identifier"),
                        width: 200,
                        height: 200
                    });
                });
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this.delegateElement.on("click", '[data-action="print"]', this._print.bind(this)), 
                this.delegateElement.on("click", '[data-action="select-code"]', this._selectCode.bind(this));
            }
        }, {
            key: "_print",
            value: function() {
                window.print();
            }
        }, {
            key: "_selectCode",
            value: function(e, t) {
                t.select();
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(13), o = i(15), s = i(11), a = i(26), r = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.delegateElement = new domDelegate.Delegate(this.element), 
            this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.searchBar = new a.default(this.element.querySelector(".header__search-bar-wrapper")), 
            this.cart = new s.default(this.element.querySelector(".header__action-item--cart"), {
                useStickyHeader: this.options.useStickyHeader
            });
            var i = this.element.querySelector("inline" === this.options.navigationLayout ? ".nav-bar" : ".header__desktop-nav");
            i && (this.desktopNavigation = new n.default(i, this.options.navigationLayout, this.options.desktopOpenTrigger));
            var r = this.element.querySelector(".header__mobile-nav");
            r && (this.mobileNavigation = new o.default(r)), this._setupCssVariables(), this._attachListeners();
        }
        return _createClass(e, [ {
            key: "onUnload",
            value: function() {
                this.searchBar.destroy(), this.cart.destroy(), this.desktopNavigation && this.desktopNavigation.destroy(), 
                this.mobileNavigation && this.mobileNavigation.destroy(), window.removeEventListener("resize", this._setupCssVariablesListener);
            }
        }, {
            key: "onBlockSelect",
            value: function(e) {
                this.desktopNavigation && this.desktopNavigation.onBlockSelect(e);
            }
        }, {
            key: "onBlockDeselect",
            value: function(e) {
                this.desktopNavigation && this.desktopNavigation.onBlockDeselect(e);
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this._setupCssVariablesListener = this._setupCssVariables.bind(this), window.addEventListener("resize", this._setupCssVariablesListener), 
                this.delegateElement.on("click", '[data-action="toggle-search"]', this._toggleMobileSearch.bind(this));
            }
        }, {
            key: "_setupCssVariables",
            value: function() {
                document.documentElement.style.setProperty("--header-height", this.element.parentNode.clientHeight + "px");
            }
        }, {
            key: "_toggleMobileSearch",
            value: function(e) {
                this.searchBar.toggleMobileSearch(), e.preventDefault();
            }
        } ]), e;
    }();
    t.default = r;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.options = JSON.parse(this.element.getAttribute("data-section-settings")), 
            this._initInstafeed();
        }
        return _createClass(e, [ {
            key: "onUnload",
            value: function() {
                this.carousel.destroy();
            }
        }, {
            key: "_initInstafeed",
            value: function() {
                var e = this, t = {
                    pageDots: !1,
                    prevNextButtons: !1,
                    wrapAround: !0,
                    cellAlign: "center",
                    watchCSS: !0
                };
                this.options.accessToken ? new Instafeed({
                    get: "user",
                    userId: "self",
                    target: this.element.querySelector(".instafeed"),
                    accessToken: this.options.accessToken,
                    sortBy: "most-recent",
                    limit: 6,
                    resolution: "standard_resolution",
                    template: '<a href="{{link}}" target="_blank" rel="nofollow noopener" class="instagram-item"><div class="instagram-item__image lazyload image--fade-in" style="padding-bottom: 100%" data-bg="{{image}}"></div><div class="instagram-item__overlay"><span class="instagram-item__like-count"><svg class="icon icon--heart" viewBox="0 0 17 15" role="presentation"><path d="M15.0349331 1.40485867C14.1287273.49933787 12.9252477 0 11.6443673 0S9.16000731.49933787 8.25448651 1.40417371c-.01164437.01164436-.02328874.02328873-.03493311.03561806-.01164436-.01232933-.02260377-.02328873-.03424813-.0349331C7.2790995.49933787 6.07561989 0 4.79473949 0 3.51385908 0 2.31037947.49933787 1.40417371 1.40485867.49796794 2.31037947 0 3.51385908 0 4.79473949 0 6.07561989.4986529 7.2790995 1.40417371 8.1846203L8.2195534 15l6.8153797-6.8153797c.9055208-.9055208 1.4041737-2.10900041 1.4041737-3.38988081 0-1.28019545-.4986529-2.48436002-1.4041737-3.38988082z"></path></svg>{{likes}}</span><p class="instagram-item__caption">{{caption}}</p><time class="instagram-item__date heading h6">{{model.date}}</time></div></a>',
                    success: function(e) {
                        var t = new Intl.DateTimeFormat(window.theme.locale, {
                            day: "numeric",
                            month: "long",
                            year: "numeric"
                        });
                        e.data.forEach(function(e) {
                            e.date = t.format(new Date(1e3 * parseInt(e.created_time))), 1 === e.likes.count ? e.likes.count = e.likes.count + " like" : e.likes.count = e.likes.count + " likes";
                        });
                    },
                    after: function() {
                        e.element.querySelectorAll(".instagram-item--dummy").forEach(function(e) {
                            e.remove();
                        }), e.carousel = new Flickity(e.element.querySelector(".instafeed"), t);
                    }
                }).run() : this.carousel = new Flickity(this.element.querySelector(".instafeed"), t);
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.domDelegate = new domDelegate.Delegate(this.element), 
            this.customerLoginForm = this.element.querySelector("#customer_login"), this.recoverPasswordForm = this.element.querySelector("#recover_customer_password"), 
            this.domDelegate.on("click", '[data-action="toggle-login-form"]', this._showRecoverPassword.bind(this));
        }
        return _createClass(e, [ {
            key: "_showRecoverPassword",
            value: function() {
                "block" === this.customerLoginForm.style.display ? (this.customerLoginForm.style.display = "none", 
                this.recoverPasswordForm.style.display = "block") : (this.customerLoginForm.style.display = "block", 
                this.recoverPasswordForm.style.display = "none");
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(3), o = i(0), s = i(5), a = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.delegateElement = new domDelegate.Delegate(this.element), 
            this.options = JSON.parse(t.getAttribute("data-section-settings")), this.mapPositions = [], 
            this.desktopMarkers = [], this.desktopMapElement = null, this.mobileMarkers = [], 
            this.mobileMapElements = [], this.options.apiKey && this.options.mapAddresses.length > 0 && this._loadScript().then(this._initMaps.bind(this)), 
            this._attachListeners();
        }
        return _createClass(e, [ {
            key: "onUnload",
            value: function() {
                this.delegateElement.off("click"), this.options.apiKey && this.options.mapAddresses.length > 0 && google.maps.event.clearInstanceListeners(window);
            }
        }, {
            key: "onBlockSelect",
            value: function(e) {
                this._showStore(e.target);
            }
        }, {
            key: "_attachListeners",
            value: function() {
                var e = this;
                this.delegateElement.on("click", '[data-action="toggle-store"]', function(t, i) {
                    e._showStore(i.closest(".map__store-item"));
                });
            }
        }, {
            key: "_showStore",
            value: function(e) {
                var t = this, i = e.querySelector('[data-action="toggle-store"]');
                if ("phone" === o.default.getCurrentBreakpoint() || "true" !== i.getAttribute("aria-expanded")) {
                    "true" === i.getAttribute("aria-expanded") ? (i.setAttribute("aria-expanded", "false"), 
                    s.default.slideUp(e.querySelector(".map__store-collapsible"))) : (i.setAttribute("aria-expanded", "true"), 
                    s.default.slideDown(e.querySelector(".map__store-collapsible"))), n.default.getSiblings(e).forEach(function(e) {
                        e.querySelector('[data-action="toggle-store"]').setAttribute("aria-expanded", "false"), 
                        s.default.slideUp(e.querySelector(".map__store-collapsible"));
                    });
                    var a = parseInt(e.getAttribute("data-store-index"));
                    this.desktopMapElement.panTo(this.mapPositions[a]), this.desktopMarkers.forEach(function(e, i) {
                        e.setMap(t.desktopMapElement), e.icon.fillColor = i === a ? t.options.markerActiveColor : t.options.markerColor;
                    });
                }
            }
        }, {
            key: "_loadScript",
            value: function() {
                var e = this;
                return new Promise(function(t, i) {
                    var n = document.createElement("script");
                    document.body.appendChild(n), n.onload = t, n.onerror = i, n.async = !0, n.src = "https://maps.googleapis.com/maps/api/js?key=" + e.options.apiKey;
                });
            }
        }, {
            key: "_initMaps",
            value: function() {
                var e = this, t = {
                    zoom: this.options.zoom,
                    draggable: this.options.draggableMap,
                    clickableIcons: !1,
                    scrollwheel: this.options.draggableMap,
                    disableDoubleClickZoom: !0,
                    disableDefaultUI: !this.options.showMapControls,
                    styles: JSON.parse(this.element.querySelector("[data-gmap-style]").innerHTML)
                };
                this.desktopMapElement = new google.maps.Map(this.element.querySelector(".map__map-container--desktop .map__gmap"), t), 
                this.mobileMapElements = [], this.element.querySelectorAll(".map__map-container--mobile .map__gmap").forEach(function(i, n) {
                    e.mobileMapElements[n] = new google.maps.Map(i, t);
                }), this._geocodeAddresses(), google.maps.event.addDomListener(window, "resize", function() {
                    var t = e.desktopMapElement.getCenter();
                    google.maps.event.trigger(e.desktopMapElement, "resize"), e.desktopMapElement.setCenter(t), 
                    e.mobileMapElements.forEach(function(e) {
                        var t = e.getCenter();
                        google.maps.event.trigger(e, "resize"), e.setCenter(t);
                    });
                });
            }
        }, {
            key: "_onMarkerClicked",
            value: function(e) {
                window.open("https://www.google.com/maps/search/?api=1&query=" + e, "_blank");
            }
        }, {
            key: "_geocodeAddresses",
            value: function() {
                var e = this, t = new google.maps.Geocoder();
                this.options.mapAddresses.forEach(function(i, n) {
                    t.geocode({
                        address: i
                    }, function(t, o) {
                        if (o !== google.maps.GeocoderStatus.OK) Shopify.designMode; else {
                            var s = t[0].geometry.location;
                            e.mapPositions[n] = s, e.desktopMarkers[n] = new google.maps.Marker({
                                map: 0 === n ? e.desktopMapElement : null,
                                position: s,
                                icon: {
                                    path: "M12.5,0 C6.388889,0 0,4.7304348 0,12.5217391 C0,19.8956522 11.111111,31.1652174 11.527778,31.5826087 C11.805556,31.8608696 12.083333,32 12.5,32 C12.916667,32 13.194444,31.8608696 13.472222,31.5826087 C13.888889,31.1652174 25,19.8956522 25,12.5217391 C25,4.7304348 18.611111,0 12.5,0 Z M12,16 C9.733333,16 8,14.2666667 8,12 C8,9.7333333 9.733333,8 12,8 C14.266667,8 16,9.7333333 16,12 C16,14.2666667 14.266667,16 12,16 Z",
                                    fillColor: 0 === n ? e.options.markerActiveColor : e.options.markerColor,
                                    fillOpacity: 1,
                                    anchor: new google.maps.Point(12, 30),
                                    strokeWeight: 0
                                }
                            }), e.mobileMarkers[n] = new google.maps.Marker({
                                map: e.mobileMapElements[n],
                                position: s,
                                icon: {
                                    path: "M12.5,0 C6.388889,0 0,4.7304348 0,12.5217391 C0,19.8956522 11.111111,31.1652174 11.527778,31.5826087 C11.805556,31.8608696 12.083333,32 12.5,32 C12.916667,32 13.194444,31.8608696 13.472222,31.5826087 C13.888889,31.1652174 25,19.8956522 25,12.5217391 C25,4.7304348 18.611111,0 12.5,0 Z M12,16 C9.733333,16 8,14.2666667 8,12 C8,9.7333333 9.733333,8 12,8 C14.266667,8 16,9.7333333 16,12 C16,14.2666667 14.266667,16 12,16 Z",
                                    fillColor: e.options.markerActiveColor,
                                    fillOpacity: 1,
                                    anchor: new google.maps.Point(12, 30),
                                    strokeWeight: 0
                                }
                            }), e.desktopMarkers[n].addListener("click", e._onMarkerClicked.bind(e, i)), e.mobileMarkers[n].addListener("click", e._onMarkerClicked.bind(e, i)), 
                            0 === n && e.desktopMapElement.setCenter(s), e.mobileMapElements[n].setCenter(s);
                        }
                    });
                });
            }
        } ]), e;
    }();
    t.default = a;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this._setupCssVariables(), this._attachListeners();
        }
        return _createClass(e, [ {
            key: "onUnload",
            value: function() {
                window.removeEventListener("resize", this._setupCssVariablesListener);
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this._setupCssVariablesListener = this._setupCssVariables.bind(this), window.addEventListener("resize", this._setupCssVariablesListener);
            }
        }, {
            key: "_setupCssVariables",
            value: function() {
                document.documentElement.style.setProperty("--header-height", this.element.parentNode.clientHeight + "px");
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(16), o = i(14), s = function() {
        function e(t) {
            var i = this;
            _classCallCheck(this, e), t.querySelectorAll("[data-popup-type]").forEach(function(e) {
                "exit" === e.getAttribute("data-popup-type") ? i.exitPopup = new o.default(e) : "newsletter" === e.getAttribute("data-popup-type") && (i.newsletterPopup = new n.default(e));
            });
        }
        return _createClass(e, [ {
            key: "onUnload",
            value: function() {
                this.exitPopup && this.exitPopup.destroy(), this.newsletterPopup && this.newsletterPopup.destroy();
            }
        }, {
            key: "onBlockSelect",
            value: function(e) {
                "exit" === e.target.getAttribute("data-popup-type") && this.exitPopup ? this.exitPopup._openPopup() : "newsletter" === e.target.getAttribute("data-popup-type") && this.newsletterPopup && this.newsletterPopup._openPopup();
            }
        }, {
            key: "onBlockDeselect",
            value: function() {
                this.exitPopup && this.exitPopup._closePopup(), this.newsletterPopup && this.newsletterPopup._closePopup();
            }
        } ]), e;
    }();
    t.default = s;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(0), o = i(6), s = i(1), a = i(4), r = i(2), l = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.delegateElement = new domDelegate.Delegate(this.element), 
            this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.options.useRecommendations ? this._loadRecommendations().then(this._createSlideshow.bind(this)) : this._createSlideshow(), 
            this.productItemColorSwatch = new o.default(this.element), this._fixSafari(), this._attachListeners();
        }
        return _createClass(e, [ {
            key: "onUnload",
            value: function() {
                this.options.stackable || this.flickityInstance.destroy(), window.removeEventListener("resize", this._fixSafariListener), 
                this.delegateElement.off("change"), this.productItemColorSwatch.destroy();
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this._fixSafariListener = this._fixSafari.bind(this), window.addEventListener("resize", this._fixSafariListener), 
                this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)), 
                this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this));
            }
        }, {
            key: "_fixSafari",
            value: function() {
                var e = window.navigator.userAgent.toLowerCase();
                if (e.includes("safari") && (e.includes("version/10.1") || e.includes("version/10.3") || e.includes("version/11.0"))) {
                    var t = n.default.matchesBreakpoint("phone");
                    this.element.querySelectorAll(".product-item__image-wrapper .aspect-ratio, .product-item__image-wrapper .placeholder-svg").forEach(function(e) {
                        e.parentNode.style.height = t ? null : e.clientHeight + "px";
                    });
                }
            }
        }, {
            key: "_loadRecommendations",
            value: function() {
                var e = this, t = "/recommendations/products?section_id=product-recommendations&product_id=" + this.options.productId + "&limit=" + this.options.recommendationsCount;
                return fetch(t).then(function(t) {
                    return t.text().then(function(t) {
                        var i = document.createElement("div");
                        i.innerHTML = t, e.element.querySelector(".product-recommendations").innerHTML = i.querySelector(".product-recommendations").innerHTML, 
                        e.productItemColorSwatch.recalculateSwatches(), window.theme.currencyConversionEnabled && s.default.convertAll(e.element), 
                        Shopify.designMode && window.SPR && (window.SPR.initDomEls(), window.SPR.loadBadges());
                    });
                });
            }
        }, {
            key: "_createSlideshow",
            value: function() {
                this.options.stackable || (this.flickityInstance = new Flickity(this.element.querySelector(".product-list"), {
                    watchCSS: !0,
                    pageDots: !1,
                    prevNextButtons: !0,
                    contain: !0,
                    groupCells: !0,
                    cellAlign: "left",
                    draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches
                })), Shopify.designMode && window.SPR && (window.SPR.initDomEls(), window.SPR.loadBadges());
            }
        }, {
            key: "_openQuickView",
            value: function(e, t) {
                var i = new URL("" + window.location.origin + t.getAttribute("data-product-url"));
                if (n.default.matchesBreakpoint("phone") || n.default.matchesBreakpoint("tablet")) return window.location.href = i.href, 
                !1;
                var o = document.getElementById(t.getAttribute("aria-controls"));
                o.classList.add("is-loading"), i.searchParams.set("view", "quick-view"), fetch(i.href, {
                    credentials: "same-origin",
                    method: "GET"
                }).then(function(e) {
                    e.text().then(function(e) {
                        o.querySelector(".modal__inner").innerHTML = e, o.classList.remove("is-loading"), 
                        new a.default(o.querySelector('[data-section-type="product"]'));
                    });
                });
            }
        }, {
            key: "_addToCart",
            value: function(e, t) {
                var i = this;
                if ("page" !== window.theme.cartType) {
                    e.preventDefault(), e.stopPropagation(), t.setAttribute("disabled", "disabled"), 
                    document.dispatchEvent(new CustomEvent("theme:loading:start"));
                    var n = t.closest('form[action*="/cart/add"]');
                    fetch(window.theme.localeRootUrl + "/cart/add.js", {
                        body: JSON.stringify(r.default.serialize(n)),
                        credentials: "same-origin",
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    }).then(function(e) {
                        t.removeAttribute("disabled"), e.ok ? i.element.dispatchEvent(new CustomEvent("product:added", {
                            bubbles: !0,
                            detail: {
                                variant: null,
                                quantity: parseInt(n.querySelector('[name="quantity"]').value)
                            }
                        })) : document.dispatchEvent(new CustomEvent("theme:loading:end"));
                    }), e.preventDefault();
                }
            }
        } ]), e;
    }();
    t.default = l;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    t.default = function e(t) {
        _classCallCheck(this, e), this.element = t, Shopify.designMode && this.element.classList.remove("hidden-lap-and-up");
    };
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(1), o = i(6), s = i(0), a = i(4), r = i(2), l = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.delegateElement = new domDelegate.Delegate(this.element), 
            this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.options.currentProductId && this._saveCurrentProduct(), 
            this.productItemColorSwatch = new o.default(this.element), this._fetchProducts(), 
            this._attachListeners();
        }
        return _createClass(e, [ {
            key: "onUnload",
            value: function() {
                this.flickityInstance && this.flickityInstance.destroy(), this.productItemColorSwatch.destroy();
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)), 
                this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this));
            }
        }, {
            key: "_saveCurrentProduct",
            value: function() {
                var e = JSON.parse(localStorage.getItem("recentlyViewedProducts") || "[]"), t = this.options.currentProductId;
                e.includes(t) || e.unshift(t);
                try {
                    localStorage.setItem("recentlyViewedProducts", JSON.stringify(e.slice(0, 18)));
                } catch (e) {}
            }
        }, {
            key: "_fetchProducts",
            value: function() {
                var e = this, t = this._getSearchQueryString();
                if ("" !== t) {
                    var i = "index" === window.theme.template ? "recently-viewed-products" : "static-recently-viewed-products";
                    fetch("/search?view=" + i + "&type=product&q=" + t, {
                        credentials: "same-origin",
                        method: "GET"
                    }).then(function(t) {
                        t.text().then(function(t) {
                            var i = document.createElement("div");
                            i.innerHTML = t, e.element.querySelector(".recently-viewed-products-placeholder").innerHTML = i.querySelector('[data-section-type="recently-viewed-products"] .recently-viewed-products-placeholder').innerHTML, 
                            e.element.parentNode.style.display = "block", e.productItemColorSwatch.recalculateSwatches(), 
                            window.theme.currencyConversionEnabled && n.default.convertAll(e.element), Shopify.designMode && window.SPR && (window.SPR.initDomEls(), 
                            window.SPR.loadBadges()), e.flickityInstance = new Flickity(e.element.querySelector(".product-list"), {
                                watchCSS: !0,
                                pageDots: !1,
                                prevNextButtons: !0,
                                contain: !0,
                                groupCells: !0,
                                cellAlign: "left",
                                draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches
                            });
                        });
                    });
                }
            }
        }, {
            key: "_getSearchQueryString",
            value: function() {
                var e = JSON.parse(localStorage.getItem("recentlyViewedProducts") || "[]");
                return e.includes(this.options.currentProductId) && e.splice(e.indexOf(this.options.currentProductId), 1), 
                e.map(function(e) {
                    return "id:" + e;
                }).join(" OR ");
            }
        }, {
            key: "_openQuickView",
            value: function(e, t) {
                var i = new URL("" + window.location.origin + t.getAttribute("data-product-url"));
                if (s.default.matchesBreakpoint("phone") || s.default.matchesBreakpoint("tablet")) return window.location.href = i.href, 
                !1;
                var n = document.getElementById(t.getAttribute("aria-controls"));
                n.classList.add("is-loading"), i.searchParams.set("view", "quick-view"), fetch(i.href, {
                    credentials: "same-origin",
                    method: "GET"
                }).then(function(e) {
                    e.text().then(function(e) {
                        n.querySelector(".modal__inner").innerHTML = e, n.classList.remove("is-loading"), 
                        new a.default(n.querySelector('[data-section-type="product"]'));
                    });
                });
            }
        }, {
            key: "_addToCart",
            value: function(e, t) {
                var i = this;
                if ("page" !== window.theme.cartType) {
                    e.preventDefault(), e.stopPropagation(), t.setAttribute("disabled", "disabled"), 
                    document.dispatchEvent(new CustomEvent("theme:loading:start"));
                    var n = t.closest('form[action*="/cart/add"]');
                    fetch(window.theme.localeRootUrl + "/cart/add.js", {
                        body: JSON.stringify(r.default.serialize(n)),
                        credentials: "same-origin",
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    }).then(function(e) {
                        t.removeAttribute("disabled"), e.ok ? i.element.dispatchEvent(new CustomEvent("product:added", {
                            bubbles: !0,
                            detail: {
                                variant: null,
                                quantity: parseInt(n.querySelector('[name="quantity"]').value)
                            }
                        })) : document.dispatchEvent(new CustomEvent("theme:loading:end"));
                    }), e.preventDefault();
                }
            }
        } ]), e;
    }();
    t.default = l;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e() {
            _classCallCheck(this, e), this.constructors = [], this.instances = [], this._attachListeners();
        }
        return _createClass(e, [ {
            key: "_attachListeners",
            value: function() {
                document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this)), 
                document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this)), 
                document.addEventListener("shopify:section:select", this._onSelect.bind(this)), 
                document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this)), 
                document.addEventListener("shopify:section:reorder", this._onReorder.bind(this)), 
                document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this)), 
                document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this));
            }
        }, {
            key: "register",
            value: function(e, t) {
                var i = this;
                this.constructors[e] = t, document.querySelectorAll("[data-section-type=" + e + "]").forEach(function(e) {
                    i._createInstance(e, t);
                });
            }
        }, {
            key: "_findInstance",
            value: function(e, t, i) {
                for (var n = 0; n < e.length; n++) if (e[n][t] === i) return e[n];
            }
        }, {
            key: "_removeInstance",
            value: function(e, t, i) {
                for (var n = e.length; n--; ) if (e[n][t] === i) {
                    e.splice(n, 1);
                    break;
                }
                return e;
            }
        }, {
            key: "_onSectionLoad",
            value: function(e) {
                var t = e.target.querySelector("[data-section-id]");
                t && this._createInstance(t);
            }
        }, {
            key: "_onSectionUnload",
            value: function(e) {
                var t = this._findInstance(this.instances, "id", e.detail.sectionId);
                t && ("function" == typeof t.onUnload && t.onUnload(e), this.instances = this._removeInstance(this.instances, "id", e.detail.sectionId));
            }
        }, {
            key: "_onSelect",
            value: function(e) {
                var t = this._findInstance(this.instances, "id", e.detail.sectionId);
                t && "function" == typeof t.onSelect && t.onSelect(e);
            }
        }, {
            key: "_onDeselect",
            value: function(e) {
                var t = this._findInstance(this.instances, "id", e.detail.sectionId);
                t && "function" == typeof t.onDeselect && t.onDeselect(e);
            }
        }, {
            key: "_onReorder",
            value: function(e) {
                var t = this._findInstance(this.instances, "id", e.detail.sectionId);
                t && "function" == typeof t.onReorder && t.onReorder(e);
            }
        }, {
            key: "_onBlockSelect",
            value: function(e) {
                var t = this._findInstance(this.instances, "id", e.detail.sectionId);
                t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
            }
        }, {
            key: "_onBlockDeselect",
            value: function(e) {
                var t = this._findInstance(this.instances, "id", e.detail.sectionId);
                t && "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
            }
        }, {
            key: "_createInstance",
            value: function(e, t) {
                var i = e.getAttribute("data-section-id"), n = e.getAttribute("data-section-type");
                if (void 0 !== (t = t || this.constructors[n])) {
                    var o = Object.assign(new t(e), {
                        id: i,
                        type: n,
                        container: e
                    });
                    this.instances.push(o);
                }
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.options = JSON.parse(this.element.getAttribute("data-section-settings")), 
            this.flickityInstance = new Flickity(t.querySelector(".slideshow"), {
                pageDots: this.options.pageDots,
                prevNextButtons: this.options.prevNextButtons,
                wrapAround: !0,
                dragThreshold: 12,
                fade: "fade" === this.options.transitionEffect,
                setGallerySize: this.options.setGallerySize,
                adaptiveHeight: this.options.adaptiveHeight,
                autoPlay: !!this.options.autoPlay && this.options.cycleSpeed
            });
        }
        return _createClass(e, [ {
            key: "onUnload",
            value: function() {
                this.flickityInstance.destroy();
            }
        }, {
            key: "onBlockSelect",
            value: function(e) {
                this.flickityInstance.isActive && (this.flickityInstance.selectCell(parseInt(e.target.getAttribute("data-block-index")), !1, e.detail.load), 
                this.flickityInstance.pausePlayer());
            }
        }, {
            key: "onBlockDeselect",
            value: function() {
                this.flickityInstance.isActive && this.flickityInstance.unpausePlayer();
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = function() {
        function e(t) {
            _classCallCheck(this, e), this.flickityInstance = new Flickity(t.querySelector(".text-with-icons"), {
                pageDots: !0,
                prevNextButtons: !1,
                wrapAround: !0,
                autoPlay: 5e3,
                watchCSS: !0
            });
        }
        return _createClass(e, [ {
            key: "onUnload",
            value: function() {
                this.flickityInstance.destroy();
            }
        }, {
            key: "onBlockSelect",
            value: function(e) {
                this.flickityInstance.isActive && (this.flickityInstance.selectCell(parseInt(e.target.getAttribute("data-block-index")), !1, e.detail.load), 
                this.flickityInstance.pausePlayer());
            }
        }, {
            key: "onBlockDeselect",
            value: function() {
                this.flickityInstance.isActive && this.flickityInstance.unpausePlayer();
            }
        } ]), e;
    }();
    t.default = n;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(3), o = i(0), s = function() {
        function e(t) {
            _classCallCheck(this, e), this.element = t, this.domDelegate = new domDelegate.Delegate(this.element), 
            this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.videoPreviewList = this.element.querySelector(".video-preview-list"), 
            this.videos = this.element.querySelectorAll(".video-list .video-list__item"), this._attachListeners();
        }
        return _createClass(e, [ {
            key: "onUnload",
            value: function() {
                this.domDelegate.off("click");
            }
        }, {
            key: "onBlockSelect",
            value: function(e) {
                this._selectVideo(e, e.target);
            }
        }, {
            key: "_attachListeners",
            value: function() {
                this.domDelegate.on("click", '[data-action="play-video"]', this._playVideo.bind(this)), 
                this.domDelegate.on("click", '[data-action="select-video"]', this._selectVideo.bind(this));
            }
        }, {
            key: "_playVideo",
            value: function(e, t) {
                var i = t.querySelector("iframe");
                i.src = i.getAttribute("data-src"), t.classList.add("is-playing");
            }
        }, {
            key: "_selectVideo",
            value: function(e, t) {
                var i = this, s = this.videos[parseInt(t.getAttribute("data-video-index"))];
                if (t.classList.add("is-selected"), s.setAttribute("aria-hidden", "false"), this.options.autoplayOnSelect && this._playVideo(null, s), 
                n.default.getSiblings(t, ".is-selected").forEach(function(e) {
                    var t = i.videos[parseInt(e.getAttribute("data-video-index"))];
                    t.setAttribute("aria-hidden", "true"), t.classList.remove("is-playing");
                    var n = t.querySelector("iframe"), o = n.cloneNode(!1);
                    o.removeAttribute("src"), n.parentNode.replaceChild(o, n), e.classList.remove("is-selected");
                }), o.default.matchesBreakpoint("phone")) {
                    var a = t.offsetLeft - (this.videoPreviewList.parentNode.clientWidth - t.clientWidth) / 2;
                    this.videoPreviewList.parentNode.scrollTo({
                        left: a,
                        behavior: "smooth"
                    });
                }
            }
        } ]), e;
    }();
    t.default = s;
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(28);
    i.d(t, "AccountSection", function() {
        return n.default;
    });
    var o = i(29);
    i.d(t, "AnnouncementBarSection", function() {
        return o.default;
    });
    var s = i(31);
    i.d(t, "BlogSection", function() {
        return s.default;
    });
    var a = i(30);
    i.d(t, "BlogPostSection", function() {
        return a.default;
    });
    var r = i(32);
    i.d(t, "BlogSidebarSection", function() {
        return r.default;
    });
    var l = i(33);
    i.d(t, "CartSection", function() {
        return l.default;
    });
    var c = i(34);
    i.d(t, "CollectionListSection", function() {
        return c.default;
    });
    var u = i(35);
    i.d(t, "CollectionSection", function() {
        return u.default;
    });
    var h = i(36);
    i.d(t, "FeaturedCollectionSection", function() {
        return h.default;
    });
    var d = i(38);
    i.d(t, "GiftCardSection", function() {
        return d.default;
    });
    var m = i(37);
    i.d(t, "FooterSection", function() {
        return m.default;
    });
    var p = i(39);
    i.d(t, "HeaderSection", function() {
        return p.default;
    });
    var f = i(40);
    i.d(t, "InstagramSection", function() {
        return f.default;
    });
    var g = i(41);
    i.d(t, "LoginSection", function() {
        return g.default;
    });
    var v = i(42);
    i.d(t, "MapSection", function() {
        return v.default;
    });
    var y = i(43);
    i.d(t, "MinimalHeaderSection", function() {
        return y.default;
    });
    var _ = i(4);
    i.d(t, "ProductSection", function() {
        return _.default;
    });
    var w = i(46);
    i.d(t, "QuickLinksSection", function() {
        return w.default;
    });
    var b = i(44);
    i.d(t, "PopupsSection", function() {
        return b.default;
    });
    var C = i(45);
    i.d(t, "ProductRecommendations", function() {
        return C.default;
    });
    var E = i(47);
    i.d(t, "RecentlyViewedProductsSection", function() {
        return E.default;
    });
    var k = i(48);
    i.d(t, "SectionContainer", function() {
        return k.default;
    });
    var S = i(49);
    i.d(t, "SlideshowSection", function() {
        return S.default;
    });
    var x = i(50);
    i.d(t, "TextWithIconsSection", function() {
        return x.default;
    });
    var L = i(51);
    i.d(t, "VideoSection", function() {
        return L.default;
    });
}, function(e, t, i) {
    i(8), i(5), i(1), i(3), i(2), i(20), i(0), i(21), i(11), i(22), i(12), i(9), i(13), 
    i(14), i(23), i(15), i(24), i(16), i(17), i(25), i(6), i(18), i(19), i(26), i(10), 
    i(7), i(27), i(28), i(29), i(30), i(31), i(32), i(33), i(34), i(35), i(36), i(37), 
    i(38), i(39), i(40), i(41), i(42), i(43), i(44), i(45), i(4), i(46), i(47), i(48), 
    i(49), i(50), i(51), i(52), e.exports = i(54);
}, function(e, t, i) {
    "use strict";
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var n = i(27), o = i(21), s = i(52);
    !function() {
        window.NodeList && !NodeList.prototype.forEach && (NodeList.prototype.forEach = function(e, t) {
            t = t || window;
            for (var i = 0; i < this.length; i++) e.call(t, this[i], i, this);
        }), new n.CollapsibleManager(), new n.LoadingBar(), new n.ModalManager(), new n.PopoverManager();
        var e, t, i, a, r = new s.SectionContainer();
        r.register("account", s.AccountSection), r.register("announcement-bar", s.AnnouncementBarSection), 
        r.register("blog", s.BlogSection), r.register("blog-sidebar", s.BlogSidebarSection), 
        r.register("blog-post", s.BlogPostSection), r.register("cart", s.CartSection), r.register("collection-list", s.CollectionListSection), 
        r.register("collection", s.CollectionSection), r.register("featured-collection", s.FeaturedCollectionSection), 
        r.register("footer", s.FooterSection), r.register("gift-card", s.GiftCardSection), 
        r.register("header", s.HeaderSection), r.register("instagram", s.InstagramSection), 
        r.register("login", s.LoginSection), r.register("map", s.MapSection), r.register("minimal-header", s.MinimalHeaderSection), 
        r.register("popups", s.PopupsSection), r.register("product-recommendations", s.ProductRecommendations), 
        r.register("product", s.ProductSection), r.register("quick-links", s.QuickLinksSection), 
        r.register("recently-viewed-products", s.RecentlyViewedProductsSection), r.register("slideshow", s.SlideshowSection), 
        r.register("text-with-icons", s.TextWithIconsSection), r.register("video", s.VideoSection), 
        function() {
            var e = new domDelegate.Delegate(document.body), t = window.theme.shopCurrency, i = document.querySelectorAll(".currency-selector"), n = document.querySelectorAll(".currency-selector__value");
            if (window.theme.currencyConversionEnabled) {
                var s = function(e) {
                    i.forEach(function(t) {
                        t.value = e;
                    }), n.forEach(function(t) {
                        t.innerHTML = e;
                    }), o.CurrencyHelper.convertAll();
                };
                if (i.length > 0) {
                    var a = function(e) {
                        var t = e.target.value;
                        s(t);
                    };
                    i.forEach(function(e) {
                        e.addEventListener("change", a);
                    }), e.on("click", '[data-action="select-currency"]', function(e, t) {
                        s(t.getAttribute("data-currency-code")), document.dispatchEvent(new CustomEvent("popover:close"));
                    });
                    var r = localStorage.getItem("currency") || t;
                    r !== t && s(r);
                }
            } else if (window.theme.useNativeMultiCurrency) {
                var l = function(e) {
                    var t = new URL(window.location.href);
                    t.searchParams.set("currency", e), window.location.href = t.href;
                };
                e.on("click", '[data-action="select-currency"]', function(e, t) {
                    l(t.getAttribute("data-currency-code"));
                }), e.on("change", ".currency-selector", function(e, t) {
                    l(t.value);
                });
            }
        }(), new domDelegate.Delegate(document.body).on("change", ".locale-selector", function(e, t) {
            window.location.href = t.value;
        }), document.querySelectorAll(".rte table").forEach(function(e) {
            e.outerHTML = '<div class="table-wrapper">' + e.outerHTML + "</div>";
        }), document.querySelectorAll(".rte iframe").forEach(function(e) {
            -1 === e.src.indexOf("youtube") && -1 === e.src.indexOf("youtu.be") && -1 === e.src.indexOf("vimeo") || (e.outerHTML = '<div class="video-wrapper">' + e.outerHTML + "</div>", 
            e.src = e.src);
        }), e = !1, t = void 0, document.body.addEventListener("touchstart", function(i) {
            i.target.closest(".flickity-slider") ? (e = !0, t = {
                x: i.touches[0].pageX,
                y: i.touches[0].pageY
            }) : e = !1;
        }), document.body.addEventListener("touchmove", function(i) {
            if (e && i.cancelable) {
                var n = {
                    x: i.touches[0].pageX - t.x,
                    y: i.touches[0].pageY - t.y
                };
                Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault();
            }
        }, {
            passive: !1
        }), function() {
            new domDelegate.Delegate(document.body).on("click", ".expandable-content__toggle", function(e, t) {
                var i = t.closest(".expandable-content");
                if ("true" === i.getAttribute("aria-expanded")) {
                    i.setAttribute("aria-expanded", "false"), i.style["max-height"] = i.offsetHeight + "px", 
                    i.offsetHeight, i.style["max-height"] = null;
                    var n = t.querySelector(".expandable-content__toggle-text");
                    n.innerHTML = n.getAttribute("data-view-more");
                    var s = i.closest(".card");
                    if (s) {
                        var a = s.getBoundingClientRect().top - 15 - parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height"));
                        window.scrollBy({
                            top: a,
                            behavior: "smooth"
                        });
                    }
                } else {
                    i.setAttribute("aria-expanded", "true"), t.previousElementSibling && (t.previousElementSibling.style["margin-bottom"] = parseInt(t.clientHeight / 1.5) + "px"), 
                    o.AnimationHelper.slideDown(i, null, "max-height");
                    var r = t.querySelector(".expandable-content__toggle-text");
                    r.innerHTML = r.getAttribute("data-view-less");
                }
            });
            var e = function() {
                document.querySelectorAll(".expandable-content[aria-expanded]").forEach(function(e) {
                    e.scrollHeight > e.clientHeight ? e.classList.add("expandable-content--expandable") : e.setAttribute("aria-expanded", "true");
                });
            };
            document.addEventListener("shopify:section:load", function(t) {
                e();
            }), e();
        }(), function() {
            if ("phone" === o.ResponsiveHelper.getCurrentBreakpoint()) for (var e = document.querySelectorAll("input[autofocus]"), t = 0; t < e.length; t++) e[t].blur(), 
            e[t].removeAttribute("autofocus");
        }(), new domDelegate.Delegate(document.body).on("click", '[href^="#"], [data-href]', function(e, t) {
            var i = t.hasAttribute("href") ? t.getAttribute("href") : t.getAttribute("data-href");
            if ("#" !== i) {
                for (var n = document.querySelector(i), o = parseInt(t.getAttribute("data-offset") || 0), s = 0; "BODY" !== n.offsetParent.tagName; ) s += n.offsetTop, 
                n = n.offsetParent;
                s += n.offsetTop, window.scrollTo({
                    behavior: "smooth",
                    top: s - o
                }), e.preventDefault();
            }
        }), function() {
            window.addEventListener("keydown", function e(t) {
                9 === t.keyCode && (document.body.classList.add("is-tabbing"), window.removeEventListener("keydown", e));
            });
        }(), (i = new domDelegate.Delegate(document.body)).on("keyup", "input, textarea", function(e, t) {
            t.classList.toggle("is-filled", "" !== t.value);
        }), i.on("change", "select", function(e, t) {
            t.parentNode.classList.toggle("is-filled", "" !== t.value);
        }), a = document.links, fastdom.mutate(function() {
            for (var e = 0, t = a.length; e < t; e++) a[e].hostname, window.location.hostname;
        });
    }();
} ]), function(e, t, i, n) {
    function o(t, i) {
        this.settings = null, this.options = e.extend({}, o.Defaults, i), this.$element = e(t), 
        this._handlers = {}, this._plugins = {}, this._supress = {}, this._current = null, 
        this._speed = null, this._coordinates = [], this._breakpoint = null, this._width = null, 
        this._items = [], this._clones = [], this._mergers = [], this._widths = [], this._invalidated = {}, 
        this._pipe = [], this._drag = {
            time: null,
            target: null,
            pointer: null,
            stage: {
                start: null,
                current: null
            },
            direction: null
        }, this._states = {
            current: {},
            tags: {
                initializing: [ "busy" ],
                animating: [ "busy" ],
                dragging: [ "interacting" ]
            }
        }, e.each([ "onResize", "onThrottledResize" ], e.proxy(function(t, i) {
            this._handlers[i] = e.proxy(this[i], this);
        }, this)), e.each(o.Plugins, e.proxy(function(e, t) {
            this._plugins[e.charAt(0).toLowerCase() + e.slice(1)] = new t(this);
        }, this)), e.each(o.Workers, e.proxy(function(t, i) {
            this._pipe.push({
                filter: i.filter,
                run: e.proxy(i.run, this)
            });
        }, this)), this.setup(), this.initialize();
    }
    o.Defaults = {
        items: 3,
        loop: !1,
        center: !1,
        rewind: !1,
        checkVisibility: !0,
        mouseDrag: !0,
        touchDrag: !0,
        pullDrag: !0,
        freeDrag: !1,
        margin: 0,
        stagePadding: 0,
        merge: !1,
        mergeFit: !0,
        autoWidth: !1,
        startPosition: 0,
        rtl: !1,
        smartSpeed: 250,
        fluidSpeed: !1,
        dragEndSpeed: !1,
        responsive: {},
        responsiveRefreshRate: 200,
        responsiveBaseElement: t,
        fallbackEasing: "swing",
        slideTransition: "",
        info: !1,
        nestedItemSelector: !1,
        itemElement: "div",
        stageElement: "div",
        refreshClass: "owl-refresh",
        loadedClass: "owl-loaded",
        loadingClass: "owl-loading",
        rtlClass: "owl-rtl",
        responsiveClass: "owl-responsive",
        dragClass: "owl-drag",
        itemClass: "owl-item",
        stageClass: "owl-stage",
        stageOuterClass: "owl-stage-outer",
        grabClass: "owl-grab"
    }, o.Width = {
        Default: "default",
        Inner: "inner",
        Outer: "outer"
    }, o.Type = {
        Event: "event",
        State: "state"
    }, o.Plugins = {}, o.Workers = [ {
        filter: [ "width", "settings" ],
        run: function() {
            this._width = this.$element.width();
        }
    }, {
        filter: [ "width", "items", "settings" ],
        run: function(e) {
            e.current = this._items && this._items[this.relative(this._current)];
        }
    }, {
        filter: [ "items", "settings" ],
        run: function() {
            this.$stage.children(".cloned").remove();
        }
    }, {
        filter: [ "width", "items", "settings" ],
        run: function(e) {
            var t = this.settings.margin || "", i = !this.settings.autoWidth, n = this.settings.rtl, o = {
                width: "auto",
                "margin-left": n ? t : "",
                "margin-right": n ? "" : t
            };
            !i && this.$stage.children().css(o), e.css = o;
        }
    }, {
        filter: [ "width", "items", "settings" ],
        run: function(e) {
            var t = (this.width() / this.settings.items).toFixed(3) - this.settings.margin, i = null, n = this._items.length, o = !this.settings.autoWidth, s = [];
            for (e.items = {
                merge: !1,
                width: t
            }; n--; ) i = this._mergers[n], i = this.settings.mergeFit && Math.min(i, this.settings.items) || i, 
            e.items.merge = i > 1 || e.items.merge, s[n] = o ? t * i : this._items[n].width();
            this._widths = s;
        }
    }, {
        filter: [ "items", "settings" ],
        run: function() {
            var t = [], i = this._items, n = this.settings, o = Math.max(2 * n.items, 4), s = 2 * Math.ceil(i.length / 2), a = n.loop && i.length ? n.rewind ? o : Math.max(o, s) : 0, r = "", l = "";
            for (a /= 2; a > 0; ) t.push(this.normalize(t.length / 2, !0)), r += i[t[t.length - 1]][0].outerHTML, 
            t.push(this.normalize(i.length - 1 - (t.length - 1) / 2, !0)), l = i[t[t.length - 1]][0].outerHTML + l, 
            a -= 1;
            this._clones = t, e(r).addClass("cloned").appendTo(this.$stage), e(l).addClass("cloned").prependTo(this.$stage);
        }
    }, {
        filter: [ "width", "items", "settings" ],
        run: function() {
            for (var e = this.settings.rtl ? 1 : -1, t = this._clones.length + this._items.length, i = -1, n = 0, o = 0, s = []; ++i < t; ) n = s[i - 1] || 0, 
            o = this._widths[this.relative(i)] + this.settings.margin, s.push(n + o * e);
            this._coordinates = s;
        }
    }, {
        filter: [ "width", "items", "settings" ],
        run: function() {
            var e = this.settings.stagePadding, t = this._coordinates, i = {
                width: Math.ceil(Math.abs(t[t.length - 1])) + 2 * e,
                "padding-left": e || "",
                "padding-right": e || ""
            };
            this.$stage.css(i);
        }
    }, {
        filter: [ "width", "items", "settings" ],
        run: function(e) {
            var t = this._coordinates.length, i = !this.settings.autoWidth, n = this.$stage.children();
            if (i && e.items.merge) for (;t--; ) e.css.width = this._widths[this.relative(t)], 
            n.eq(t).css(e.css); else i && (e.css.width = e.items.width, n.css(e.css));
        }
    }, {
        filter: [ "items" ],
        run: function() {
            this._coordinates.length < 1 && this.$stage.removeAttr("style");
        }
    }, {
        filter: [ "width", "items", "settings" ],
        run: function(e) {
            e.current = e.current ? this.$stage.children().index(e.current) : 0, e.current = Math.max(this.minimum(), Math.min(this.maximum(), e.current)), 
            this.reset(e.current);
        }
    }, {
        filter: [ "position" ],
        run: function() {
            this.animate(this.coordinates(this._current));
        }
    }, {
        filter: [ "width", "position", "items", "settings" ],
        run: function() {
            var e, t, i, n, o = this.settings.rtl ? 1 : -1, s = 2 * this.settings.stagePadding, a = this.coordinates(this.current()) + s, r = a + this.width() * o, l = [];
            for (i = 0, n = this._coordinates.length; i < n; i++) e = this._coordinates[i - 1] || 0, 
            t = Math.abs(this._coordinates[i]) + s * o, (this.op(e, "<=", a) && this.op(e, ">", r) || this.op(t, "<", a) && this.op(t, ">", r)) && l.push(i);
            this.$stage.children(".active").removeClass("active"), this.$stage.children(":eq(" + l.join("), :eq(") + ")").addClass("active"), 
            this.$stage.children(".center").removeClass("center"), this.settings.center && this.$stage.children().eq(this.current()).addClass("center");
        }
    } ], o.prototype.initializeStage = function() {
        this.$stage = this.$element.find("." + this.settings.stageClass), this.$stage.length || (this.$element.addClass(this.options.loadingClass), 
        this.$stage = e("<" + this.settings.stageElement + ">", {
            "class": this.settings.stageClass
        }).wrap(e("<div/>", {
            "class": this.settings.stageOuterClass
        })), this.$element.append(this.$stage.parent()));
    }, o.prototype.initializeItems = function() {
        var t = this.$element.find(".owl-item");
        if (t.length) return this._items = t.get().map(function(t) {
            return e(t);
        }), this._mergers = this._items.map(function() {
            return 1;
        }), void this.refresh();
        this.replace(this.$element.children().not(this.$stage.parent())), this.isVisible() ? this.refresh() : this.invalidate("width"), 
        this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass);
    }, o.prototype.initialize = function() {
        var e, t, i;
        (this.enter("initializing"), this.trigger("initialize"), this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl), 
        this.settings.autoWidth && !this.is("pre-loading")) && (e = this.$element.find("img"), 
        t = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : n, 
        i = this.$element.children(t).width(), e.length && i <= 0 && this.preloadAutoWidthImages(e));
        this.initializeStage(), this.initializeItems(), this.registerEventHandlers(), this.leave("initializing"), 
        this.trigger("initialized");
    }, o.prototype.isVisible = function() {
        return !this.settings.checkVisibility || this.$element.is(":visible");
    }, o.prototype.setup = function() {
        var t = this.viewport(), i = this.options.responsive, n = -1, o = null;
        i ? (e.each(i, function(e) {
            e <= t && e > n && (n = Number(e));
        }), "function" == typeof (o = e.extend({}, this.options, i[n])).stagePadding && (o.stagePadding = o.stagePadding()), 
        delete o.responsive, o.responsiveClass && this.$element.attr("class", this.$element.attr("class").replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s", "g"), "$1" + n))) : o = e.extend({}, this.options), 
        this.trigger("change", {
            property: {
                name: "settings",
                value: o
            }
        }), this._breakpoint = n, this.settings = o, this.invalidate("settings"), this.trigger("changed", {
            property: {
                name: "settings",
                value: this.settings
            }
        });
    }, o.prototype.optionsLogic = function() {
        this.settings.autoWidth && (this.settings.stagePadding = !1, this.settings.merge = !1);
    }, o.prototype.prepare = function(t) {
        var i = this.trigger("prepare", {
            content: t
        });
        return i.data || (i.data = e("<" + this.settings.itemElement + "/>").addClass(this.options.itemClass).append(t)), 
        this.trigger("prepared", {
            content: i.data
        }), i.data;
    }, o.prototype.update = function() {
        for (var t = 0, i = this._pipe.length, n = e.proxy(function(e) {
            return this[e];
        }, this._invalidated), o = {}; t < i; ) (this._invalidated.all || e.grep(this._pipe[t].filter, n).length > 0) && this._pipe[t].run(o), 
        t++;
        this._invalidated = {}, !this.is("valid") && this.enter("valid");
    }, o.prototype.width = function(e) {
        switch (e = e || o.Width.Default) {
          case o.Width.Inner:
          case o.Width.Outer:
            return this._width;

          default:
            return this._width - 2 * this.settings.stagePadding + this.settings.margin;
        }
    }, o.prototype.refresh = function() {
        this.enter("refreshing"), this.trigger("refresh"), this.setup(), this.optionsLogic(), 
        this.$element.addClass(this.options.refreshClass), this.update(), this.$element.removeClass(this.options.refreshClass), 
        this.leave("refreshing"), this.trigger("refreshed");
    }, o.prototype.onThrottledResize = function() {
        t.clearTimeout(this.resizeTimer), this.resizeTimer = t.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate);
    }, o.prototype.onResize = function() {
        return !!this._items.length && this._width !== this.$element.width() && !!this.isVisible() && (this.enter("resizing"), 
        this.trigger("resize").isDefaultPrevented() ? (this.leave("resizing"), !1) : (this.invalidate("width"), 
        this.refresh(), this.leave("resizing"), void this.trigger("resized")));
    }, o.prototype.registerEventHandlers = function() {
        e.support.transition && this.$stage.on(e.support.transition.end + ".owl.core", e.proxy(this.onTransitionEnd, this)), 
        !1 !== this.settings.responsive && this.on(t, "resize", this._handlers.onThrottledResize), 
        this.settings.mouseDrag && (this.$element.addClass(this.options.dragClass), this.$stage.on("mousedown.owl.core", e.proxy(this.onDragStart, this)), 
        this.$stage.on("dragstart.owl.core selectstart.owl.core", function() {
            return !1;
        })), this.settings.touchDrag && (this.$stage.on("touchstart.owl.core", e.proxy(this.onDragStart, this)), 
        this.$stage.on("touchcancel.owl.core", e.proxy(this.onDragEnd, this)));
    }, o.prototype.onDragStart = function(t) {
        var n = null;
        3 !== t.which && (e.support.transform ? n = {
            x: (n = this.$stage.css("transform").replace(/.*\(|\)| /g, "").split(","))[16 === n.length ? 12 : 4],
            y: n[16 === n.length ? 13 : 5]
        } : (n = this.$stage.position(), n = {
            x: this.settings.rtl ? n.left + this.$stage.width() - this.width() + this.settings.margin : n.left,
            y: n.top
        }), this.is("animating") && (e.support.transform ? this.animate(n.x) : this.$stage.stop(), 
        this.invalidate("position")), this.$element.toggleClass(this.options.grabClass, "mousedown" === t.type), 
        this.speed(0), this._drag.time = new Date().getTime(), this._drag.target = e(t.target), 
        this._drag.stage.start = n, this._drag.stage.current = n, this._drag.pointer = this.pointer(t), 
        e(i).on("mouseup.owl.core touchend.owl.core", e.proxy(this.onDragEnd, this)), e(i).one("mousemove.owl.core touchmove.owl.core", e.proxy(function(t) {
            var n = this.difference(this._drag.pointer, this.pointer(t));
            e(i).on("mousemove.owl.core touchmove.owl.core", e.proxy(this.onDragMove, this)), 
            Math.abs(n.x) < Math.abs(n.y) && this.is("valid") || (t.preventDefault(), this.enter("dragging"), 
            this.trigger("drag"));
        }, this)));
    }, o.prototype.onDragMove = function(e) {
        var t = null, i = null, n = null, o = this.difference(this._drag.pointer, this.pointer(e)), s = this.difference(this._drag.stage.start, o);
        this.is("dragging") && (e.preventDefault(), this.settings.loop ? (t = this.coordinates(this.minimum()), 
        i = this.coordinates(this.maximum() + 1) - t, s.x = ((s.x - t) % i + i) % i + t) : (t = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum()), 
        i = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum()), 
        n = this.settings.pullDrag ? -1 * o.x / 5 : 0, s.x = Math.max(Math.min(s.x, t + n), i + n)), 
        this._drag.stage.current = s, this.animate(s.x));
    }, o.prototype.onDragEnd = function(t) {
        var n = this.difference(this._drag.pointer, this.pointer(t)), o = this._drag.stage.current, s = n.x > 0 ^ this.settings.rtl ? "left" : "right";
        e(i).off(".owl.core"), this.$element.removeClass(this.options.grabClass), (0 !== n.x && this.is("dragging") || !this.is("valid")) && (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed), 
        this.current(this.closest(o.x, 0 !== n.x ? s : this._drag.direction)), this.invalidate("position"), 
        this.update(), this._drag.direction = s, (Math.abs(n.x) > 3 || new Date().getTime() - this._drag.time > 300) && this._drag.target.one("click.owl.core", function() {
            return !1;
        })), this.is("dragging") && (this.leave("dragging"), this.trigger("dragged"));
    }, o.prototype.closest = function(t, i) {
        var o = -1, s = this.width(), a = this.coordinates();
        return this.settings.freeDrag || e.each(a, e.proxy(function(e, r) {
            return "left" === i && t > r - 30 && t < r + 30 ? o = e : "right" === i && t > r - s - 30 && t < r - s + 30 ? o = e + 1 : this.op(t, "<", r) && this.op(t, ">", a[e + 1] !== n ? a[e + 1] : r - s) && (o = "left" === i ? e + 1 : e), 
            -1 === o;
        }, this)), this.settings.loop || (this.op(t, ">", a[this.minimum()]) ? o = t = this.minimum() : this.op(t, "<", a[this.maximum()]) && (o = t = this.maximum())), 
        o;
    }, o.prototype.animate = function(t) {
        var i = this.speed() > 0;
        this.is("animating") && this.onTransitionEnd(), i && (this.enter("animating"), this.trigger("translate")), 
        e.support.transform3d && e.support.transition ? this.$stage.css({
            transform: "translate3d(" + t + "px,0px,0px)",
            transition: this.speed() / 1e3 + "s" + (this.settings.slideTransition ? " " + this.settings.slideTransition : "")
        }) : i ? this.$stage.animate({
            left: t + "px"
        }, this.speed(), this.settings.fallbackEasing, e.proxy(this.onTransitionEnd, this)) : this.$stage.css({
            left: t + "px"
        });
    }, o.prototype.is = function(e) {
        return this._states.current[e] && this._states.current[e] > 0;
    }, o.prototype.current = function(e) {
        if (e === n) return this._current;
        if (0 === this._items.length) return n;
        if (e = this.normalize(e), this._current !== e) {
            var t = this.trigger("change", {
                property: {
                    name: "position",
                    value: e
                }
            });
            t.data !== n && (e = this.normalize(t.data)), this._current = e, this.invalidate("position"), 
            this.trigger("changed", {
                property: {
                    name: "position",
                    value: this._current
                }
            });
        }
        return this._current;
    }, o.prototype.invalidate = function(t) {
        return "string" === e.type(t) && (this._invalidated[t] = !0, this.is("valid") && this.leave("valid")), 
        e.map(this._invalidated, function(e, t) {
            return t;
        });
    }, o.prototype.reset = function(e) {
        (e = this.normalize(e)) !== n && (this._speed = 0, this._current = e, this.suppress([ "translate", "translated" ]), 
        this.animate(this.coordinates(e)), this.release([ "translate", "translated" ]));
    }, o.prototype.normalize = function(e, t) {
        var i = this._items.length, o = t ? 0 : this._clones.length;
        return !this.isNumeric(e) || i < 1 ? e = n : (e < 0 || e >= i + o) && (e = ((e - o / 2) % i + i) % i + o / 2), 
        e;
    }, o.prototype.relative = function(e) {
        return e -= this._clones.length / 2, this.normalize(e, !0);
    }, o.prototype.maximum = function(e) {
        var t, i, n, o = this.settings, s = this._coordinates.length;
        if (o.loop) s = this._clones.length / 2 + this._items.length - 1; else if (o.autoWidth || o.merge) {
            if (t = this._items.length) for (i = this._items[--t].width(), n = this.$element.width(); t-- && !((i += this._items[t].width() + this.settings.margin) > n); ) ;
            s = t + 1;
        } else s = o.center ? this._items.length - 1 : this._items.length - o.items;
        return e && (s -= this._clones.length / 2), Math.max(s, 0);
    }, o.prototype.minimum = function(e) {
        return e ? 0 : this._clones.length / 2;
    }, o.prototype.items = function(e) {
        return e === n ? this._items.slice() : (e = this.normalize(e, !0), this._items[e]);
    }, o.prototype.mergers = function(e) {
        return e === n ? this._mergers.slice() : (e = this.normalize(e, !0), this._mergers[e]);
    }, o.prototype.clones = function(t) {
        var i = this._clones.length / 2, o = i + this._items.length, s = function(e) {
            return e % 2 == 0 ? o + e / 2 : i - (e + 1) / 2;
        };
        return t === n ? e.map(this._clones, function(e, t) {
            return s(t);
        }) : e.map(this._clones, function(e, i) {
            return e === t ? s(i) : null;
        });
    }, o.prototype.speed = function(e) {
        return e !== n && (this._speed = e), this._speed;
    }, o.prototype.coordinates = function(t) {
        var i, o = 1, s = t - 1;
        return t === n ? e.map(this._coordinates, e.proxy(function(e, t) {
            return this.coordinates(t);
        }, this)) : (this.settings.center ? (this.settings.rtl && (o = -1, s = t + 1), i = this._coordinates[t], 
        i += (this.width() - i + (this._coordinates[s] || 0)) / 2 * o) : i = this._coordinates[s] || 0, 
        i = Math.ceil(i));
    }, o.prototype.duration = function(e, t, i) {
        return 0 === i ? 0 : Math.min(Math.max(Math.abs(t - e), 1), 6) * Math.abs(i || this.settings.smartSpeed);
    }, o.prototype.to = function(e, t) {
        var i = this.current(), n = null, o = e - this.relative(i), s = (o > 0) - (o < 0), a = this._items.length, r = this.minimum(), l = this.maximum();
        this.settings.loop ? (!this.settings.rewind && Math.abs(o) > a / 2 && (o += -1 * s * a), 
        (n = (((e = i + o) - r) % a + a) % a + r) !== e && n - o <= l && n - o > 0 && (i = n - o, 
        e = n, this.reset(i))) : this.settings.rewind ? e = (e % (l += 1) + l) % l : e = Math.max(r, Math.min(l, e)), 
        this.speed(this.duration(i, e, t)), this.current(e), this.isVisible() && this.update();
    }, o.prototype.next = function(e) {
        e = e || !1, this.to(this.relative(this.current()) + 1, e);
    }, o.prototype.prev = function(e) {
        e = e || !1, this.to(this.relative(this.current()) - 1, e);
    }, o.prototype.onTransitionEnd = function(e) {
        if (e !== n && (e.stopPropagation(), (e.target || e.srcElement || e.originalTarget) !== this.$stage.get(0))) return !1;
        this.leave("animating"), this.trigger("translated");
    }, o.prototype.viewport = function() {
        var n;
        return this.options.responsiveBaseElement !== t ? n = e(this.options.responsiveBaseElement).width() : t.innerWidth ? n = t.innerWidth : i.documentElement && i.documentElement.clientWidth ? n = i.documentElement.clientWidth : console.warn("Can not detect viewport width."), 
        n;
    }, o.prototype.replace = function(t) {
        this.$stage.empty(), this._items = [], t && (t = t instanceof jQuery ? t : e(t)), 
        this.settings.nestedItemSelector && (t = t.find("." + this.settings.nestedItemSelector)), 
        t.filter(function() {
            return 1 === this.nodeType;
        }).each(e.proxy(function(e, t) {
            t = this.prepare(t), this.$stage.append(t), this._items.push(t), this._mergers.push(1 * t.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1);
        }, this)), this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0), 
        this.invalidate("items");
    }, o.prototype.add = function(t, i) {
        var o = this.relative(this._current);
        i = i === n ? this._items.length : this.normalize(i, !0), t = t instanceof jQuery ? t : e(t), 
        this.trigger("add", {
            content: t,
            position: i
        }), t = this.prepare(t), 0 === this._items.length || i === this._items.length ? (0 === this._items.length && this.$stage.append(t), 
        0 !== this._items.length && this._items[i - 1].after(t), this._items.push(t), this._mergers.push(1 * t.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)) : (this._items[i].before(t), 
        this._items.splice(i, 0, t), this._mergers.splice(i, 0, 1 * t.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)), 
        this._items[o] && this.reset(this._items[o].index()), this.invalidate("items"), 
        this.trigger("added", {
            content: t,
            position: i
        });
    }, o.prototype.remove = function(e) {
        (e = this.normalize(e, !0)) !== n && (this.trigger("remove", {
            content: this._items[e],
            position: e
        }), this._items[e].remove(), this._items.splice(e, 1), this._mergers.splice(e, 1), 
        this.invalidate("items"), this.trigger("removed", {
            content: null,
            position: e
        }));
    }, o.prototype.preloadAutoWidthImages = function(t) {
        t.each(e.proxy(function(t, i) {
            this.enter("pre-loading"), i = e(i), e(new Image()).one("load", e.proxy(function(e) {
                i.attr("src", e.target.src), i.css("opacity", 1), this.leave("pre-loading"), !this.is("pre-loading") && !this.is("initializing") && this.refresh();
            }, this)).attr("src", i.attr("src") || i.attr("data-src") || i.attr("data-src-retina"));
        }, this));
    }, o.prototype.destroy = function() {
        for (var n in this.$element.off(".owl.core"), this.$stage.off(".owl.core"), e(i).off(".owl.core"), 
        !1 !== this.settings.responsive && (t.clearTimeout(this.resizeTimer), this.off(t, "resize", this._handlers.onThrottledResize)), 
        this._plugins) this._plugins[n].destroy();
        this.$stage.children(".cloned").remove(), this.$stage.unwrap(), this.$stage.children().contents().unwrap(), 
        this.$stage.children().unwrap(), this.$stage.remove(), this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class", this.$element.attr("class").replace(new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"), "")).removeData("owl.carousel");
    }, o.prototype.op = function(e, t, i) {
        var n = this.settings.rtl;
        switch (t) {
          case "<":
            return n ? e > i : e < i;

          case ">":
            return n ? e < i : e > i;

          case ">=":
            return n ? e <= i : e >= i;

          case "<=":
            return n ? e >= i : e <= i;
        }
    }, o.prototype.on = function(e, t, i, n) {
        e.addEventListener ? e.addEventListener(t, i, n) : e.attachEvent && e.attachEvent("on" + t, i);
    }, o.prototype.off = function(e, t, i, n) {
        e.removeEventListener ? e.removeEventListener(t, i, n) : e.detachEvent && e.detachEvent("on" + t, i);
    }, o.prototype.trigger = function(t, i, n, s, a) {
        var r = {
            item: {
                count: this._items.length,
                index: this.current()
            }
        }, l = e.camelCase(e.grep([ "on", t, n ], function(e) {
            return e;
        }).join("-").toLowerCase()), c = e.Event([ t, "owl", n || "carousel" ].join(".").toLowerCase(), e.extend({
            relatedTarget: this
        }, r, i));
        return this._supress[t] || (e.each(this._plugins, function(e, t) {
            t.onTrigger && t.onTrigger(c);
        }), this.register({
            type: o.Type.Event,
            name: t
        }), this.$element.trigger(c), this.settings && "function" == typeof this.settings[l] && this.settings[l].call(this, c)), 
        c;
    }, o.prototype.enter = function(t) {
        e.each([ t ].concat(this._states.tags[t] || []), e.proxy(function(e, t) {
            this._states.current[t] === n && (this._states.current[t] = 0), this._states.current[t]++;
        }, this));
    }, o.prototype.leave = function(t) {
        e.each([ t ].concat(this._states.tags[t] || []), e.proxy(function(e, t) {
            this._states.current[t]--;
        }, this));
    }, o.prototype.register = function(t) {
        if (t.type === o.Type.Event) {
            if (e.event.special[t.name] || (e.event.special[t.name] = {}), !e.event.special[t.name].owl) {
                var i = e.event.special[t.name]._default;
                e.event.special[t.name]._default = function(e) {
                    return !i || !i.apply || e.namespace && -1 !== e.namespace.indexOf("owl") ? e.namespace && e.namespace.indexOf("owl") > -1 : i.apply(this, arguments);
                }, e.event.special[t.name].owl = !0;
            }
        } else t.type === o.Type.State && (this._states.tags[t.name] ? this._states.tags[t.name] = this._states.tags[t.name].concat(t.tags) : this._states.tags[t.name] = t.tags, 
        this._states.tags[t.name] = e.grep(this._states.tags[t.name], e.proxy(function(i, n) {
            return e.inArray(i, this._states.tags[t.name]) === n;
        }, this)));
    }, o.prototype.suppress = function(t) {
        e.each(t, e.proxy(function(e, t) {
            this._supress[t] = !0;
        }, this));
    }, o.prototype.release = function(t) {
        e.each(t, e.proxy(function(e, t) {
            delete this._supress[t];
        }, this));
    }, o.prototype.pointer = function(e) {
        var i = {
            x: null,
            y: null
        };
        return (e = (e = e.originalEvent || e || t.event).touches && e.touches.length ? e.touches[0] : e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e).pageX ? (i.x = e.pageX, 
        i.y = e.pageY) : (i.x = e.clientX, i.y = e.clientY), i;
    }, o.prototype.isNumeric = function(e) {
        return !isNaN(parseFloat(e));
    }, o.prototype.difference = function(e, t) {
        return {
            x: e.x - t.x,
            y: e.y - t.y
        };
    }, e.fn.owlCarousel = function(t) {
        var i = Array.prototype.slice.call(arguments, 1);
        return this.each(function() {
            var n = e(this), s = n.data("owl.carousel");
            s || (s = new o(this, "object" == typeof t && t), n.data("owl.carousel", s), e.each([ "next", "prev", "to", "destroy", "refresh", "replace", "add", "remove" ], function(t, i) {
                s.register({
                    type: o.Type.Event,
                    name: i
                }), s.$element.on(i + ".owl.carousel.core", e.proxy(function(e) {
                    e.namespace && e.relatedTarget !== this && (this.suppress([ i ]), s[i].apply(this, [].slice.call(arguments, 1)), 
                    this.release([ i ]));
                }, s));
            })), "string" == typeof t && "_" !== t.charAt(0) && s[t].apply(s, i);
        });
    }, e.fn.owlCarousel.Constructor = o;
}(window.Zepto || window.jQuery, window, document), function(e, t, i, n) {
    var o = function(t) {
        this._core = t, this._interval = null, this._visible = null, this._handlers = {
            "initialized.owl.carousel": e.proxy(function(e) {
                e.namespace && this._core.settings.autoRefresh && this.watch();
            }, this)
        }, this._core.options = e.extend({}, o.Defaults, this._core.options), this._core.$element.on(this._handlers);
    };
    o.Defaults = {
        autoRefresh: !0,
        autoRefreshInterval: 500
    }, o.prototype.watch = function() {
        this._interval || (this._visible = this._core.isVisible(), this._interval = t.setInterval(e.proxy(this.refresh, this), this._core.settings.autoRefreshInterval));
    }, o.prototype.refresh = function() {
        this._core.isVisible() !== this._visible && (this._visible = !this._visible, this._core.$element.toggleClass("owl-hidden", !this._visible), 
        this._visible && this._core.invalidate("width") && this._core.refresh());
    }, o.prototype.destroy = function() {
        var e, i;
        for (e in t.clearInterval(this._interval), this._handlers) this._core.$element.off(e, this._handlers[e]);
        for (i in Object.getOwnPropertyNames(this)) "function" != typeof this[i] && (this[i] = null);
    }, e.fn.owlCarousel.Constructor.Plugins.AutoRefresh = o;
}(window.Zepto || window.jQuery, window, document), function(e, t, i, n) {
    var o = function(t) {
        this._core = t, this._loaded = [], this._handlers = {
            "initialized.owl.carousel change.owl.carousel resized.owl.carousel": e.proxy(function(t) {
                if (t.namespace && this._core.settings && this._core.settings.lazyLoad && (t.property && "position" == t.property.name || "initialized" == t.type)) {
                    var i = this._core.settings, n = i.center && Math.ceil(i.items / 2) || i.items, o = i.center && -1 * n || 0, s = (t.property && void 0 !== t.property.value ? t.property.value : this._core.current()) + o, a = this._core.clones().length, r = e.proxy(function(e, t) {
                        this.load(t);
                    }, this);
                    for (i.lazyLoadEager > 0 && (n += i.lazyLoadEager, i.loop && (s -= i.lazyLoadEager, 
                    n++)); o++ < n; ) this.load(a / 2 + this._core.relative(s)), a && e.each(this._core.clones(this._core.relative(s)), r), 
                    s++;
                }
            }, this)
        }, this._core.options = e.extend({}, o.Defaults, this._core.options), this._core.$element.on(this._handlers);
    };
    o.Defaults = {
        lazyLoad: !1,
        lazyLoadEager: 0
    }, o.prototype.load = function(i) {
        var n = this._core.$stage.children().eq(i), o = n && n.find(".owl-lazy");
        !o || e.inArray(n.get(0), this._loaded) > -1 || (o.each(e.proxy(function(i, n) {
            var o, s = e(n), a = t.devicePixelRatio > 1 && s.attr("data-src-retina") || s.attr("data-src") || s.attr("data-srcset");
            this._core.trigger("load", {
                element: s,
                url: a
            }, "lazy"), s.is("img") ? s.one("load.owl.lazy", e.proxy(function() {
                s.css("opacity", 1), this._core.trigger("loaded", {
                    element: s,
                    url: a
                }, "lazy");
            }, this)).attr("src", a) : s.is("source") ? s.one("load.owl.lazy", e.proxy(function() {
                this._core.trigger("loaded", {
                    element: s,
                    url: a
                }, "lazy");
            }, this)).attr("srcset", a) : ((o = new Image()).onload = e.proxy(function() {
                s.css({
                    "background-image": 'url("' + a + '")',
                    opacity: "1"
                }), this._core.trigger("loaded", {
                    element: s,
                    url: a
                }, "lazy");
            }, this), o.src = a);
        }, this)), this._loaded.push(n.get(0)));
    }, o.prototype.destroy = function() {
        var e, t;
        for (e in this.handlers) this._core.$element.off(e, this.handlers[e]);
        for (t in Object.getOwnPropertyNames(this)) "function" != typeof this[t] && (this[t] = null);
    }, e.fn.owlCarousel.Constructor.Plugins.Lazy = o;
}(window.Zepto || window.jQuery, window, document), function(e, t, i, n) {
    var o = function(i) {
        this._core = i, this._previousHeight = null, this._handlers = {
            "initialized.owl.carousel refreshed.owl.carousel": e.proxy(function(e) {
                e.namespace && this._core.settings.autoHeight && this.update();
            }, this),
            "changed.owl.carousel": e.proxy(function(e) {
                e.namespace && this._core.settings.autoHeight && "position" === e.property.name && this.update();
            }, this),
            "loaded.owl.lazy": e.proxy(function(e) {
                e.namespace && this._core.settings.autoHeight && e.element.closest("." + this._core.settings.itemClass).index() === this._core.current() && this.update();
            }, this)
        }, this._core.options = e.extend({}, o.Defaults, this._core.options), this._core.$element.on(this._handlers), 
        this._intervalId = null;
        var n = this;
        e(t).on("load", function() {
            n._core.settings.autoHeight && n.update();
        }), e(t).resize(function() {
            n._core.settings.autoHeight && (null != n._intervalId && clearTimeout(n._intervalId), 
            n._intervalId = setTimeout(function() {
                n.update();
            }, 250));
        });
    };
    o.Defaults = {
        autoHeight: !1,
        autoHeightClass: "owl-height"
    }, o.prototype.update = function() {
        var t = this._core._current, i = t + this._core.settings.items, n = this._core.settings.lazyLoad, o = this._core.$stage.children().toArray().slice(t, i), s = [], a = 0;
        e.each(o, function(t, i) {
            s.push(e(i).height());
        }), (a = Math.max.apply(null, s)) <= 1 && n && this._previousHeight && (a = this._previousHeight), 
        this._previousHeight = a, this._core.$stage.parent().height(a).addClass(this._core.settings.autoHeightClass);
    }, o.prototype.destroy = function() {
        var e, t;
        for (e in this._handlers) this._core.$element.off(e, this._handlers[e]);
        for (t in Object.getOwnPropertyNames(this)) "function" != typeof this[t] && (this[t] = null);
    }, e.fn.owlCarousel.Constructor.Plugins.AutoHeight = o;
}(window.Zepto || window.jQuery, window, document), function(e, t, i, n) {
    var o = function(t) {
        this._core = t, this._videos = {}, this._playing = null, this._handlers = {
            "initialized.owl.carousel": e.proxy(function(e) {
                e.namespace && this._core.register({
                    type: "state",
                    name: "playing",
                    tags: [ "interacting" ]
                });
            }, this),
            "resize.owl.carousel": e.proxy(function(e) {
                e.namespace && this._core.settings.video && this.isInFullScreen() && e.preventDefault();
            }, this),
            "refreshed.owl.carousel": e.proxy(function(e) {
                e.namespace && this._core.is("resizing") && this._core.$stage.find(".cloned .owl-video-frame").remove();
            }, this),
            "changed.owl.carousel": e.proxy(function(e) {
                e.namespace && "position" === e.property.name && this._playing && this.stop();
            }, this),
            "prepared.owl.carousel": e.proxy(function(t) {
                if (t.namespace) {
                    var i = e(t.content).find(".owl-video");
                    i.length && (i.css("display", "none"), this.fetch(i, e(t.content)));
                }
            }, this)
        }, this._core.options = e.extend({}, o.Defaults, this._core.options), this._core.$element.on(this._handlers), 
        this._core.$element.on("click.owl.video", ".owl-video-play-icon", e.proxy(function(e) {
            this.play(e);
        }, this));
    };
    o.Defaults = {
        video: !1,
        videoHeight: !1,
        videoWidth: !1
    }, o.prototype.fetch = function(e, t) {
        var i = e.attr("data-vimeo-id") ? "vimeo" : e.attr("data-vzaar-id") ? "vzaar" : "youtube", n = e.attr("data-vimeo-id") || e.attr("data-youtube-id") || e.attr("data-vzaar-id"), o = e.attr("data-width") || this._core.settings.videoWidth, s = e.attr("data-height") || this._core.settings.videoHeight, a = e.attr("href");
        if (!a) throw new Error("Missing video URL.");
        if ((n = a.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/))[3].indexOf("youtu") > -1) i = "youtube"; else if (n[3].indexOf("vimeo") > -1) i = "vimeo"; else {
            if (!(n[3].indexOf("vzaar") > -1)) throw new Error("Video URL not supported.");
            i = "vzaar";
        }
        n = n[6], this._videos[a] = {
            type: i,
            id: n,
            width: o,
            height: s
        }, t.attr("data-video", a), this.thumbnail(e, this._videos[a]);
    }, o.prototype.thumbnail = function(t, i) {
        var n, o, s = i.width && i.height ? "width:" + i.width + "px;height:" + i.height + "px;" : "", a = t.find("img"), r = "src", l = "", c = this._core.settings, u = function(i) {
            '<div class="owl-video-play-icon"></div>', n = c.lazyLoad ? e("<div/>", {
                "class": "owl-video-tn " + l,
                srcType: i
            }) : e("<div/>", {
                "class": "owl-video-tn",
                style: "opacity:1;background-image:url(" + i + ")"
            }), t.after(n), t.after('<div class="owl-video-play-icon"></div>');
        };
        if (t.wrap(e("<div/>", {
            "class": "owl-video-wrapper",
            style: s
        })), this._core.settings.lazyLoad && (r = "data-src", l = "owl-lazy"), a.length) return u(a.attr(r)), 
        a.remove(), !1;
        "youtube" === i.type ? (o = "//img.youtube.com/vi/" + i.id + "/hqdefault.jpg", u(o)) : "vimeo" === i.type ? e.ajax({
            type: "GET",
            url: "//vimeo.com/api/v2/video/" + i.id + ".json",
            jsonp: "callback",
            dataType: "jsonp",
            success: function(e) {
                o = e[0].thumbnail_large, u(o);
            }
        }) : "vzaar" === i.type && e.ajax({
            type: "GET",
            url: "//vzaar.com/api/videos/" + i.id + ".json",
            jsonp: "callback",
            dataType: "jsonp",
            success: function(e) {
                o = e.framegrab_url, u(o);
            }
        });
    }, o.prototype.stop = function() {
        this._core.trigger("stop", null, "video"), this._playing.find(".owl-video-frame").remove(), 
        this._playing.removeClass("owl-video-playing"), this._playing = null, this._core.leave("playing"), 
        this._core.trigger("stopped", null, "video");
    }, o.prototype.play = function(t) {
        var i, n = e(t.target).closest("." + this._core.settings.itemClass), o = this._videos[n.attr("data-video")], s = o.width || "100%", a = o.height || this._core.$stage.height();
        this._playing || (this._core.enter("playing"), this._core.trigger("play", null, "video"), 
        n = this._core.items(this._core.relative(n.index())), this._core.reset(n.index()), 
        (i = e('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>')).attr("height", a), 
        i.attr("width", s), "youtube" === o.type ? i.attr("src", "//www.youtube.com/embed/" + o.id + "?autoplay=1&rel=0&v=" + o.id) : "vimeo" === o.type ? i.attr("src", "//player.vimeo.com/video/" + o.id + "?autoplay=1") : "vzaar" === o.type && i.attr("src", "//view.vzaar.com/" + o.id + "/player?autoplay=true"), 
        e(i).wrap('<div class="owl-video-frame" />').insertAfter(n.find(".owl-video")), 
        this._playing = n.addClass("owl-video-playing"));
    }, o.prototype.isInFullScreen = function() {
        var t = i.fullscreenElement || i.mozFullScreenElement || i.webkitFullscreenElement;
        return t && e(t).parent().hasClass("owl-video-frame");
    }, o.prototype.destroy = function() {
        var e, t;
        for (e in this._core.$element.off("click.owl.video"), this._handlers) this._core.$element.off(e, this._handlers[e]);
        for (t in Object.getOwnPropertyNames(this)) "function" != typeof this[t] && (this[t] = null);
    }, e.fn.owlCarousel.Constructor.Plugins.Video = o;
}(window.Zepto || window.jQuery, window, document), function(e, t, i, n) {
    var o = function(t) {
        this.core = t, this.core.options = e.extend({}, o.Defaults, this.core.options), 
        this.swapping = !0, this.previous = n, this.next = n, this.handlers = {
            "change.owl.carousel": e.proxy(function(e) {
                e.namespace && "position" == e.property.name && (this.previous = this.core.current(), 
                this.next = e.property.value);
            }, this),
            "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": e.proxy(function(e) {
                e.namespace && (this.swapping = "translated" == e.type);
            }, this),
            "translate.owl.carousel": e.proxy(function(e) {
                e.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap();
            }, this)
        }, this.core.$element.on(this.handlers);
    };
    o.Defaults = {
        animateOut: !1,
        animateIn: !1
    }, o.prototype.swap = function() {
        if (1 === this.core.settings.items && e.support.animation && e.support.transition) {
            this.core.speed(0);
            var t, i = e.proxy(this.clear, this), n = this.core.$stage.children().eq(this.previous), o = this.core.$stage.children().eq(this.next), s = this.core.settings.animateIn, a = this.core.settings.animateOut;
            this.core.current() !== this.previous && (a && (t = this.core.coordinates(this.previous) - this.core.coordinates(this.next), 
            n.one(e.support.animation.end, i).css({
                left: t + "px"
            }).addClass("animated owl-animated-out").addClass(a)), s && o.one(e.support.animation.end, i).addClass("animated owl-animated-in").addClass(s));
        }
    }, o.prototype.clear = function(t) {
        e(t.target).css({
            left: ""
        }).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), 
        this.core.onTransitionEnd();
    }, o.prototype.destroy = function() {
        var e, t;
        for (e in this.handlers) this.core.$element.off(e, this.handlers[e]);
        for (t in Object.getOwnPropertyNames(this)) "function" != typeof this[t] && (this[t] = null);
    }, e.fn.owlCarousel.Constructor.Plugins.Animate = o;
}(window.Zepto || window.jQuery, window, document), function(e, t, i, n) {
    var o = function(t) {
        this._core = t, this._call = null, this._time = 0, this._timeout = 0, this._paused = !0, 
        this._handlers = {
            "changed.owl.carousel": e.proxy(function(e) {
                e.namespace && "settings" === e.property.name ? this._core.settings.autoplay ? this.play() : this.stop() : e.namespace && "position" === e.property.name && this._paused && (this._time = 0);
            }, this),
            "initialized.owl.carousel": e.proxy(function(e) {
                e.namespace && this._core.settings.autoplay && this.play();
            }, this),
            "play.owl.autoplay": e.proxy(function(e, t, i) {
                e.namespace && this.play(t, i);
            }, this),
            "stop.owl.autoplay": e.proxy(function(e) {
                e.namespace && this.stop();
            }, this),
            "mouseover.owl.autoplay": e.proxy(function() {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause();
            }, this),
            "mouseleave.owl.autoplay": e.proxy(function() {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play();
            }, this),
            "touchstart.owl.core": e.proxy(function() {
                this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause();
            }, this),
            "touchend.owl.core": e.proxy(function() {
                this._core.settings.autoplayHoverPause && this.play();
            }, this)
        }, this._core.$element.on(this._handlers), this._core.options = e.extend({}, o.Defaults, this._core.options);
    };
    o.Defaults = {
        autoplay: !1,
        autoplayTimeout: 5e3,
        autoplayHoverPause: !1,
        autoplaySpeed: !1
    }, o.prototype._next = function(n) {
        this._call = t.setTimeout(e.proxy(this._next, this, n), this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()), 
        this._core.is("interacting") || i.hidden || this._core.next(n || this._core.settings.autoplaySpeed);
    }, o.prototype.read = function() {
        return new Date().getTime() - this._time;
    }, o.prototype.play = function(i, n) {
        var o;
        this._core.is("rotating") || this._core.enter("rotating"), i = i || this._core.settings.autoplayTimeout, 
        o = Math.min(this._time % (this._timeout || i), i), this._paused ? (this._time = this.read(), 
        this._paused = !1) : t.clearTimeout(this._call), this._time += this.read() % i - o, 
        this._timeout = i, this._call = t.setTimeout(e.proxy(this._next, this, n), i - o);
    }, o.prototype.stop = function() {
        this._core.is("rotating") && (this._time = 0, this._paused = !0, t.clearTimeout(this._call), 
        this._core.leave("rotating"));
    }, o.prototype.pause = function() {
        this._core.is("rotating") && !this._paused && (this._time = this.read(), this._paused = !0, 
        t.clearTimeout(this._call));
    }, o.prototype.destroy = function() {
        var e, t;
        for (e in this.stop(), this._handlers) this._core.$element.off(e, this._handlers[e]);
        for (t in Object.getOwnPropertyNames(this)) "function" != typeof this[t] && (this[t] = null);
    }, e.fn.owlCarousel.Constructor.Plugins.autoplay = o;
}(window.Zepto || window.jQuery, window, document), function(e, t, i, n) {
    "use strict";
    var o = function(t) {
        this._core = t, this._initialized = !1, this._pages = [], this._controls = {}, this._templates = [], 
        this.$element = this._core.$element, this._overrides = {
            next: this._core.next,
            prev: this._core.prev,
            to: this._core.to
        }, this._handlers = {
            "prepared.owl.carousel": e.proxy(function(t) {
                t.namespace && this._core.settings.dotsData && this._templates.push('<div class="' + this._core.settings.dotClass + '">' + e(t.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") + "</div>");
            }, this),
            "added.owl.carousel": e.proxy(function(e) {
                e.namespace && this._core.settings.dotsData && this._templates.splice(e.position, 0, this._templates.pop());
            }, this),
            "remove.owl.carousel": e.proxy(function(e) {
                e.namespace && this._core.settings.dotsData && this._templates.splice(e.position, 1);
            }, this),
            "changed.owl.carousel": e.proxy(function(e) {
                e.namespace && "position" == e.property.name && this.draw();
            }, this),
            "initialized.owl.carousel": e.proxy(function(e) {
                e.namespace && !this._initialized && (this._core.trigger("initialize", null, "navigation"), 
                this.initialize(), this.update(), this.draw(), this._initialized = !0, this._core.trigger("initialized", null, "navigation"));
            }, this),
            "refreshed.owl.carousel": e.proxy(function(e) {
                e.namespace && this._initialized && (this._core.trigger("refresh", null, "navigation"), 
                this.update(), this.draw(), this._core.trigger("refreshed", null, "navigation"));
            }, this)
        }, this._core.options = e.extend({}, o.Defaults, this._core.options), this.$element.on(this._handlers);
    };
    o.Defaults = {
        nav: !1,
        navText: [ '<span aria-label="Previous">&#x2039;</span>', '<span aria-label="Next">&#x203a;</span>' ],
        navSpeed: !1,
        navElement: 'button type="button" role="presentation"',
        navContainer: !1,
        navContainerClass: "owl-nav",
        navClass: [ "owl-prev", "owl-next" ],
        slideBy: 1,
        dotClass: "owl-dot",
        dotsClass: "owl-dots",
        dots: !0,
        dotsEach: !1,
        dotsData: !1,
        dotsSpeed: !1,
        dotsContainer: !1
    }, o.prototype.initialize = function() {
        var t, i = this._core.settings;
        for (t in this._controls.$relative = (i.navContainer ? e(i.navContainer) : e("<div>").addClass(i.navContainerClass).appendTo(this.$element)).addClass("disabled"), 
        this._controls.$previous = e("<" + i.navElement + ">").addClass(i.navClass[0]).html(i.navText[0]).prependTo(this._controls.$relative).on("click", e.proxy(function(e) {
            this.prev(i.navSpeed);
        }, this)), this._controls.$next = e("<" + i.navElement + ">").addClass(i.navClass[1]).html(i.navText[1]).appendTo(this._controls.$relative).on("click", e.proxy(function(e) {
            this.next(i.navSpeed);
        }, this)), i.dotsData || (this._templates = [ e('<button role="button">').addClass(i.dotClass).append(e("<span>")).prop("outerHTML") ]), 
        this._controls.$absolute = (i.dotsContainer ? e(i.dotsContainer) : e("<div>").addClass(i.dotsClass).appendTo(this.$element)).addClass("disabled"), 
        this._controls.$absolute.on("click", "button", e.proxy(function(t) {
            var n = e(t.target).parent().is(this._controls.$absolute) ? e(t.target).index() : e(t.target).parent().index();
            t.preventDefault(), this.to(n, i.dotsSpeed);
        }, this)), this._overrides) this._core[t] = e.proxy(this[t], this);
    }, o.prototype.destroy = function() {
        var e, t, i, n, o;
        for (e in o = this._core.settings, this._handlers) this.$element.off(e, this._handlers[e]);
        for (t in this._controls) "$relative" === t && o.navContainer ? this._controls[t].html("") : this._controls[t].remove();
        for (n in this.overides) this._core[n] = this._overrides[n];
        for (i in Object.getOwnPropertyNames(this)) "function" != typeof this[i] && (this[i] = null);
    }, o.prototype.update = function() {
        var e, t, i = this._core.clones().length / 2, n = i + this._core.items().length, o = this._core.maximum(!0), s = this._core.settings, a = s.center || s.autoWidth || s.dotsData ? 1 : s.dotsEach || s.items;
        if ("page" !== s.slideBy && (s.slideBy = Math.min(s.slideBy, s.items)), s.dots || "page" == s.slideBy) for (this._pages = [], 
        e = i, t = 0, 0; e < n; e++) {
            if (t >= a || 0 === t) {
                if (this._pages.push({
                    start: Math.min(o, e - i),
                    end: e - i + a - 1
                }), Math.min(o, e - i) === o) break;
                t = 0, 0;
            }
            t += this._core.mergers(this._core.relative(e));
        }
    }, o.prototype.draw = function() {
        var t, i = this._core.settings, n = this._core.items().length <= i.items, o = this._core.relative(this._core.current()), s = i.loop || i.rewind;
        this._controls.$relative.toggleClass("disabled", !i.nav || n), i.nav && (this._controls.$previous.toggleClass("disabled", !s && o <= this._core.minimum(!0)), 
        this._controls.$next.toggleClass("disabled", !s && o >= this._core.maximum(!0))), 
        this._controls.$absolute.toggleClass("disabled", !i.dots || n), i.dots && (t = this._pages.length - this._controls.$absolute.children().length, 
        i.dotsData && 0 !== t ? this._controls.$absolute.html(this._templates.join("")) : t > 0 ? this._controls.$absolute.append(new Array(t + 1).join(this._templates[0])) : t < 0 && this._controls.$absolute.children().slice(t).remove(), 
        this._controls.$absolute.find(".active").removeClass("active"), this._controls.$absolute.children().eq(e.inArray(this.current(), this._pages)).addClass("active"));
    }, o.prototype.onTrigger = function(t) {
        var i = this._core.settings;
        t.page = {
            index: e.inArray(this.current(), this._pages),
            count: this._pages.length,
            size: i && (i.center || i.autoWidth || i.dotsData ? 1 : i.dotsEach || i.items)
        };
    }, o.prototype.current = function() {
        var t = this._core.relative(this._core.current());
        return e.grep(this._pages, e.proxy(function(e, i) {
            return e.start <= t && e.end >= t;
        }, this)).pop();
    }, o.prototype.getPosition = function(t) {
        var i, n, o = this._core.settings;
        return "page" == o.slideBy ? (i = e.inArray(this.current(), this._pages), n = this._pages.length, 
        t ? ++i : --i, i = this._pages[(i % n + n) % n].start) : (i = this._core.relative(this._core.current()), 
        n = this._core.items().length, t ? i += o.slideBy : i -= o.slideBy), i;
    }, o.prototype.next = function(t) {
        e.proxy(this._overrides.to, this._core)(this.getPosition(!0), t);
    }, o.prototype.prev = function(t) {
        e.proxy(this._overrides.to, this._core)(this.getPosition(!1), t);
    }, o.prototype.to = function(t, i, n) {
        var o;
        !n && this._pages.length ? (o = this._pages.length, e.proxy(this._overrides.to, this._core)(this._pages[(t % o + o) % o].start, i)) : e.proxy(this._overrides.to, this._core)(t, i);
    }, e.fn.owlCarousel.Constructor.Plugins.Navigation = o;
}(window.Zepto || window.jQuery, window, document), function(e, t, i, n) {
    "use strict";
    var o = function(i) {
        this._core = i, this._hashes = {}, this.$element = this._core.$element, this._handlers = {
            "initialized.owl.carousel": e.proxy(function(i) {
                i.namespace && "URLHash" === this._core.settings.startPosition && e(t).trigger("hashchange.owl.navigation");
            }, this),
            "prepared.owl.carousel": e.proxy(function(t) {
                if (t.namespace) {
                    var i = e(t.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");
                    if (!i) return;
                    this._hashes[i] = t.content;
                }
            }, this),
            "changed.owl.carousel": e.proxy(function(i) {
                if (i.namespace && "position" === i.property.name) {
                    var n = this._core.items(this._core.relative(this._core.current())), o = e.map(this._hashes, function(e, t) {
                        return e === n ? t : null;
                    }).join();
                    if (!o || t.location.hash.slice(1) === o) return;
                    t.location.hash = o;
                }
            }, this)
        }, this._core.options = e.extend({}, o.Defaults, this._core.options), this.$element.on(this._handlers), 
        e(t).on("hashchange.owl.navigation", e.proxy(function(e) {
            var i = t.location.hash.substring(1), n = this._core.$stage.children(), o = this._hashes[i] && n.index(this._hashes[i]);
            void 0 !== o && o !== this._core.current() && this._core.to(this._core.relative(o), !1, !0);
        }, this));
    };
    o.Defaults = {
        URLhashListener: !1
    }, o.prototype.destroy = function() {
        var i, n;
        for (i in e(t).off("hashchange.owl.navigation"), this._handlers) this._core.$element.off(i, this._handlers[i]);
        for (n in Object.getOwnPropertyNames(this)) "function" != typeof this[n] && (this[n] = null);
    }, e.fn.owlCarousel.Constructor.Plugins.Hash = o;
}(window.Zepto || window.jQuery, window, document), function(e, t, i, n) {
    function o(t, i) {
        var o = !1, s = t.charAt(0).toUpperCase() + t.slice(1);
        return e.each((t + " " + r.join(s + " ") + s).split(" "), function(e, t) {
            if (a[t] !== n) return o = !i || t, !1;
        }), o;
    }
    function s(e) {
        return o(e, !0);
    }
    var a = e("<support>").get(0).style, r = "Webkit Moz O ms".split(" "), l = {
        transition: {
            end: {
                WebkitTransition: "webkitTransitionEnd",
                MozTransition: "transitionend",
                OTransition: "oTransitionEnd",
                transition: "transitionend"
            }
        },
        animation: {
            end: {
                WebkitAnimation: "webkitAnimationEnd",
                MozAnimation: "animationend",
                OAnimation: "oAnimationEnd",
                animation: "animationend"
            }
        }
    }, c = function() {
        return !!o("transform");
    }, u = function() {
        return !!o("perspective");
    }, h = function() {
        return !!o("animation");
    };
    (function() {
        return !!o("transition");
    })() && (e.support.transition = new String(s("transition")), e.support.transition.end = l.transition.end[e.support.transition]), 
    h() && (e.support.animation = new String(s("animation")), e.support.animation.end = l.animation.end[e.support.animation]), 
    c() && (e.support.transform = new String(s("transform")), e.support.transform3d = u());
}(window.Zepto || window.jQuery, window, document), function(e) {
    e(".filter-products .products").owlCarousel({
        items: 6,
        slideBy: 2,
        smartSpeed: 300,
        margin: 10,
        autoplay: !1,
        nav: true,
        loop: true,
        navigationText: [ "<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>" ],
        navText:['<button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>','<button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>'],
  
  responsive: {
    0: {
      items: 1
    },
    640: {
      items: 2
    },
    768: {
      items: 3
    },
    992: {
      items: 4
    },
    1200: {
      items: 5
    },
    1300: {
      items: 6
    },
    1600: {
      items: 6
    }
  }
    });
    //e(".filter-products .brands-slider-demo");
    e(".filter-products .brands-slider-demo").owlCarousel({
        items: 5,
        slideBy: 1,
        margin: 10,
        smartSpeed: 700,
        //rtl: !0,
        autoplay: !0,
        nav: true,
        loop: !0,
        navigationText: [ "<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>" ],
        navText:['<button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>','<button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>'],
        responsiveClass: !0,
        responsive: {
            0: {
                items: 1
            },
            480: {
                items: 2
            },
            640: {
                items: 3
            },
            768: {
                items: 3
            },
            992: {
                items: 5
            }
        }
    });
    var t = e("#shopify-section-header").height();
  var anbar = e("#shopify-section-announcement-bar").height();
  var tt = e(".nav-bar").height();
  var t = t + anbar - tt;
  
    e(window).scroll(function() {
      
      if(e(window).scrollTop() > t) 
      {
        //e(".stick-logo").show();
        e('.nav-bar__inner').removeClass('not-logo');
      } else {
        //e(".stick-logo").hide();
        e('.nav-bar__inner').addClass('not-logo');
      }	

      e(window).scrollTop() > t ? e("header").addClass('fixedheader_top') : e("header").removeClass('fixedheader_top');
      e(window).scrollTop() > t ? e('main#main').addClass('fixedheader_top_padd') : e('main#main').removeClass('fixedheader_top_padd');
    }), 
  e(".header__mobile-nav-toggle").click(function() {
        parseInt(screen.height);
        e("#mobile-menu").css({
            left: "-250px"
        }), e("body").css({
            left: "250px",
            position: "fixed"
        }), e(".mobile-menu__inner").css("height", screen.height + "px"), e(".mobile-menu-wrapper").show();
    }), e(".mobile-menu-wrapper").click(function() {
        e(".header__mobile-nav-toggle").trigger("click"), e("#mobile-menu").css({
            left: "-500px"
        }), e("body").css({
            left: "0px",
            position: "relative"
        }), e(".mobile-menu__inner").css("height", "auto"), e(".mobile-menu-wrapper").hide();
    }), e(".ajaxcart__close").click(function() {
        e("#AjaxifyModal").removeClass("is-visible");
    }), e(".ajaxcart__overlay").click(function() {
        e("#AjaxifyModal").removeClass("is-visible");
    }), e("#AjaxifyModal").css({
        "margin-left": -e("#AjaxifyModal").outerWidth() / 2,
        opacity: 1
    }), e(".header__cart-toggle").click(function(t) {
        t.preventDefault(), e("#AjaxifyModal").addClass("is-visible"), e("html, body").animate({
            scrollTop: 0
        }, 250, "swing");
    });
  
  	
  
  
      setTimeout(
  function() 
  {
    //e('main#main').addClass('animation_class');
  }, 1500);
}(jQuery);